{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{           copyright (c)  2016 - 2026                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCPDFLib.General;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

interface

procedure RegisterPDFLibGeneralService;
procedure UnRegisterPDFLibGeneralService;

implementation

uses
  Classes, Math, DateUtils, Types, SysUtils, WEBLib.TMSFNCPDFGraphicsLib, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes
  ,WEBLib.TMSFNCPDFLib, WEBLib.TMSFNCUtils, WEBLib.TMSFNCPDFCoreLibBase, WEBLib.Graphics, WEBLib.TMSFNCTypes,
  WEBLib.TMSFNCBitmapContainer
  {$IFDEF WEBLIB}
  ,Contnrs, Web
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  ,Generics.Collections, Generics.Defaults
  {$HINTS OFF}
  {$IF COMPILERVERSION > 22}
  , UITypes
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  {$IFDEF MACOS}
  {$IFDEF IOS}
  ,WEBLib.TMSFNCPDFLib.General.iOS
  {$ELSE}
  ,WEBLib.TMSFNCPDFLib.General.Mac
  {$ENDIF}
  {$ENDIF}
  {$IFDEF ANDROID}
  ,WEBLib.TMSFNCPDFLib.General.Android
  {$ENDIF}
  {$IFDEF MSWINDOWS}
  ,WEBLib.TMSFNCPDFLib.General.Win
  {$ENDIF}
  {$IFDEF UNIX}
  ,WEBLib.TMSFNCPDFLib.General.Unix
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.TMSFNCPDFLib.General.WEB
  {$ENDIF}
  {$IFDEF LCLLIB}
  {$IFNDEF MSWINDOWS}
  {$IFNDEF UNIX}
  ,WEBLib.TMSFNCPDFLib.General.Default
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  ;

type
  TTMSFNCGeneralPDFLibService = class(TTMSFNCPDFLibFactoryService)
  protected
    function DoCreatePDFLib: ITMSFNCCustomPDFLib; override;
  end;

  {$IFDEF WEBLIB}
  UInt32 = Cardinal;
  {$ENDIF}

const
  DefaultMediaBox: TRectF = (Left: 0; Top: 0; Right: 612; Bottom: 792);
  {%H-}PDFStart17 = '%PDF-1.7'#13#10'%'#249#250#251#252;
  {%H-}PDFStart16 = '%PDF-1.6'#13#10'%'#245#246#247#248;
  {%H-}PDFStart15 = '%PDF-1.5'#13#10'%'#241#242#243#244;
  {%H-}PDFStart14 = '%PDF-1.4'#13#10'%'#228#229#230#240;
  {%H-}PDFStart13 = '%PDF-1.3';
  PDFStart = PDFStart17;
  PDFEnd = '%%EOF';
  PDFCR = #13;
  PDFLF = #10;
  PDFLB = PDFCR + PDFLF;
  PDFMaxXref = 65535;
  PDFDestOutputProfileRef = '{PDFDESTOUTPUTPROFILEREFERENCE}';
  PDFDestOutputProfileLengthRef = '{PDFDESTOUTPUTPROFILELENGTHREFERENCE}';
  PDFPageFontTextRef = '{PDFPAGEFONTTEXTREFERENCE%s}';
  PDFPageFontGlyphTextRef = '{PDFPAGEFONTGLYPHTEXTREFERENCE%s}';
  PDFPageRef = '{PDFPAGEREFERENCE}';
  PDFPageGoToRef = '{PDFPAGEGOTOREFERENCE}';
  PDFPageChildRef = '{PDFPAGECHILDREFERENCE}';
  PDFPageAcroFormFieldContentRef = '{PDFPAGEACROFORMFIELDCONTENTREFERENCE}';
  PDFPageContentRef = '{PDFPAGECONTENTREFERENCE}';
  PDFPageContentLengthRef = '{PDFPAGECONTENTLENGTHREFERENCE}';
  PDFPageCountRef = '{PDFPAGECOUNTREFERENCE}';
  PDFPageFontRef = '{PDFPAGEFONTREFERENCE}';
  PDFPagePatternRef = '{PDFPAGEPATTERNREFERENCE}';
  PDFPageAnnotationsRef = '{PDFPAGEANNOTATIONSREFERENCE}';
  PDFPageShadingObjectRef = '{PDFPAGESHADINGOBJECTREFERENCE%s}';
  PDFPageBitmapObjectRef = '{PDFPAGEBITMAPOBJECTREFERENCE%s}';
  PDFPageXObjectRef = '{PDFPAGEXOBJECTREFERENCE}';
  PDFAcroFormRef = '{PDFACROFORMREFERENCE}';
  PDFAcroFormFieldsRef = '{PDFACROFORMFIELDSREFERENCE}';
  PDFAcroFormFontsRef = '{PDFACROFORMFONTSREFERENCE}';

  ICC: array[0..139] of UInt32 = (
    805437440,1161970753,4098,1920233069,541214546,542792024,134270983,318769920,989868800,
    1886610273,1280331841,0,1701736302,0,0,0,0,3606446080,256,768802816,1161970753,
    0,0,0,0,0,0,0,0,0,0,0,167772160,1953656931,4227858432,838860800,1668506980,805371904,
    1795162112,1953526903,2617311232,335544320,1953524578,2952855552,335544320,1129469042,
    3288399872,234881024,1129469031,3556835328,234881024,1129469026,3825270784,234881024,
    1515804786,4093706240,335544320,1515804775,134348800,335544320,1515804770,469893120,
    335544320,1954047348,0,2037411651,1751607666,808591476,1092628528,1700949860,1937330976,
    1936549236,1668172064,1869640303,1702125938,100,1668506980,0,285212672,1651467329,
    1196564581,824713282,691550521,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,542792024,0,
    1374879744,256,3423994112,542792024,0,0,0,0,1987212643,0,16777216,13058,1987212643,0,
    16777216,13058,1987212643,0,16777216,13058,542792024,0,412876800,2773417984,4228120576,
    542792024,0,2368995328,748683264,2500788224,542792024,0,824573952,789577728,2629697536);

type
  TTMSFNCGeneralPDFLib = class;

  TTMSFNCGeneralPDFLibObjectType = (lotDirect, lotIndirect);

  TTMSFNCGeneralPDFLibXRefObject = class;

  TTMSFNCGeneralPDFLibObject = class
  private
    FPDFLib: TTMSFNCGeneralPDFLib;
    FXRefNumber: integer;
    FNumber: integer;
    FType: TTMSFNCGeneralPDFLibObjectType;
    FXRefObject: TTMSFNCGeneralPDFLibXRefObject;
    FRefNameOriginal: string;
    FInactive: Boolean;
    FRefNameGlyphOriginal: string;
    procedure SetNumber(const Value: integer);
    function GetRef: string;
    function GetRefName: string;
    function GetRefNameNotEscaped: string;
    function GetRefNameBase: String; virtual;
    function GetRefIndex(ACheckClassType: Boolean): Integer; virtual;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const ANumber: Integer = -1; const AXRefNumber: Integer = 0); virtual;
    destructor Destroy; override;
    property Inactive: Boolean read FInactive write FInactive;
    property Number: integer read FNumber write SetNumber;
    property &Type: TTMSFNCGeneralPDFLibObjectType read FType;
    property XRefNumber: integer read FXRefNumber write FXRefNumber;
    property XRefObject: TTMSFNCGeneralPDFLibXRefObject read FXRefObject write FXRefObject;
    property PDFLib: TTMSFNCGeneralPDFLib read FPDFLib;
    property Ref: string read GetRef;
    property RefName: string read GetRefName;
    property RefNameNotEscaped: string read GetRefNameNotEscaped;
    property RefNameBase: String read GetRefNameBase;
    property RefNameOriginal: string read FRefNameOriginal write FRefNameOriginal;
    property RefNameGlyphOriginal: string read FRefNameGlyphOriginal write FRefNameGlyphOriginal;
  end;

  TTMSFNCGeneralPDFLibObjectClass = class of TTMSFNCGeneralPDFLibObject;

  TTMSFNCGeneralPDFLibGlyphMapEntry = record
    GlyphId: Integer;
    UnicodeValue: Integer;
    Width: Integer;
  end;

  TTMSFNCGeneralPDFLibGlyphMapEntries = array of TTMSFNCGeneralPDFLibGlyphMapEntry;

  TTMSFNCGeneralPDFLibDestOutputProfile = class(TTMSFNCGeneralPDFLibObject);
  TTMSFNCGeneralPDFLibInfo = class(TTMSFNCGeneralPDFLibObject);
  TTMSFNCGeneralPDFLibCatalog = class(TTMSFNCGeneralPDFLibObject);
  TTMSFNCGeneralPDFLibPages = class(TTMSFNCGeneralPDFLibObject);
  TTMSFNCGeneralPDFLibOutputIntent = class(TTMSFNCGeneralPDFLibObject);
  TTMSFNCGeneralPDFLibFontDescriptor = class;
  TTMSFNCGeneralPDFLibFontFile = class;
  TTMSFNCGeneralPDFLibFontDescendant = class;
  TTMSFNCGeneralPDFLibFontUnicode = class;
  TTMSFNCGeneralPDFLibFont = class;
  TTMSFNCGeneralPDFLibXObject = class;
  TTMSFNCGeneralPDFLibShading = class;
  TTMSFNCGeneralPDFLibPattern = class;
  TTMSFNCGeneralPDFLibBitmap = class;
  TTMSFNCGeneralPDFLibContent = class;
  TTMSFNCGeneralPDFLibAcroForm = class;
  TTMSFNCGeneralPDFLibAnnotation = class;
  TTMSFNCGeneralPDFLibFormField = class;
  TTMSFNCGeneralPDFLibPage = class;

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibPageList = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibPage;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibPage);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibPage read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibPageList = class(TList<TTMSFNCGeneralPDFLibPage>);
  {$ENDIF}

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibFonts = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibFont;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibFont);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibFont read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibFonts = class(TList<TTMSFNCGeneralPDFLibFont>);
  {$ENDIF}

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibXObjects = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibXObject;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibXObject);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibXObject read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibXObjects = class(TList<TTMSFNCGeneralPDFLibXObject>);
  {$ENDIF}

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibShadings = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibShading;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibShading);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibShading read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibShadings = class(TList<TTMSFNCGeneralPDFLibShading>);
  {$ENDIF}

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibPatterns = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibPattern;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibPattern);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibPattern read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibPatterns = class(TList<TTMSFNCGeneralPDFLibPattern>);
  {$ENDIF}

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibAnnotations = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibAnnotation;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibAnnotation);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibAnnotation read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibAnnotations = class(TList<TTMSFNCGeneralPDFLibAnnotation>);
  {$ENDIF}

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibBitmaps = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibBitmap;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibBitmap);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibBitmap read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibBitmaps = class(TList<TTMSFNCGeneralPDFLibBitmap>);
  {$ENDIF}

  TTMSFNCGeneralPDFLibPage = class(TTMSFNCGeneralPDFLibObject)
  private
    FPageNumber: Integer;
    FFontList: TTMSFNCGeneralPDFLibFonts;
    FXObjectList: TTMSFNCGeneralPDFLibXObjects;
    FShadings: TTMSFNCGeneralPDFLibShadings;
    FPatterns: TTMSFNCGeneralPDFLibPatterns;
    FBitmaps: TTMSFNCGeneralPDFLibBitmaps;
    FContent: TTMSFNCGeneralPDFLibContent;
    FAnnotations: TTMSFNCGeneralPDFLibAnnotations;
    FInsertPageNumber: Integer;
  protected
    property InsertPageNumber: Integer read FInsertPageNumber write FInsertPageNumber;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const APageNumber: Integer); reintroduce; virtual;
    destructor Destroy; override;
    property PageNumber: Integer read FPageNumber write FPageNumber;
    property FontList: TTMSFNCGeneralPDFLibFonts read FFontList;
    property XObjectList: TTMSFNCGeneralPDFLibXObjects read FXObjectList;
    property Shadings: TTMSFNCGeneralPDFLibShadings read FShadings;
    property Bitmaps: TTMSFNCGeneralPDFLibBitmaps read FBitmaps;
    property Patterns: TTMSFNCGeneralPDFLibPatterns read FPatterns;
    property Annotations: TTMSFNCGeneralPDFLibAnnotations read FAnnotations;
    property Content: TTMSFNCGeneralPDFLibContent read FContent write FContent;
  end;

  TTMSFNCGeneralPDFLibContent = class(TTMSFNCGeneralPDFLibObject)
  private
    FPage: TTMSFNCGeneralPDFLibPage;
  public
    destructor Destroy; override;
    property Page: TTMSFNCGeneralPDFLibPage read FPage write FPage;
  end;

  TTMSFNCGeneralPDFLibAcroForm = class(TTMSFNCGeneralPDFLibObject);

  TTMSFNCGeneralPDFLibFont = class(TTMSFNCGeneralPDFLibObject)
  private
    FInitializer: TTMSFNCGeneralPDFLibFontInitializer;
    FSize: Single;
    FName: string;
    FStyle: TFontStyles;
    FBase: string;
    FUnicode: Boolean;
    FDescent: Integer;
    FAscent: Integer;
    FBox: TRect;
    FItalicAngle: Integer;
    FFontFile: TTMSFNCGeneralPDFLibFontFile;
    FFontDescriptor: TTMSFNCGeneralPDFLibFontDescriptor;
    FFontDescendant: TTMSFNCGeneralPDFLibFontDescendant;
    FFontUnicode: TTMSFNCGeneralPDFLibFontUnicode;
    FTrueType: Boolean;
    FFontProgramType: TTMSFNCPDFFontProgramType;
    FCapHeight: Integer;
    FUnitsPerEm: Integer;
    function GetGlyphIDs: TTMSFNCPDFGraphicsLibUsedFontCharArray;
    function GetCharArray: TTMSFNCPDFGraphicsLibFontCharArray;
    function GetCharWidths: TTMSFNCPDFGraphicsLibFontCharWidths;
    function GetUsedCharArray: TTMSFNCPDFGraphicsLibUsedFontCharArray;
    function GetRefNameBase: string; override;
  protected
    function BuildGlyphMapEntries: TTMSFNCGeneralPDFLibGlyphMapEntries;
    function BoxAsString: string;
    function WidthsAsString: string;
    function GlyphsAndWidthsAsString: string;
    function FirstGlyphAsString: string;
    function LastGlyphAsString: string;
    function FirstGlyph: Integer;
    function LastGlyph: Integer;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AMainInitializer: TTMSFNCGeneralPDFLibInitializer; const ABase: string; const AName: String; const ASize: Single; const AStyle: TFontStyles); reintroduce; virtual;
    destructor Destroy; override;
    property Base: string read FBase write FBase;
    property Name: string read FName write FName;
    property Size: Single read FSize write FSize;
    property Style: TFontStyles read FStyle write FStyle;
    property Ascent: Integer read FAscent write FAscent;
    property CapHeight: Integer read FCapHeight write FCapHeight;
    property UnitsPerEm: Integer read FUnitsPerEm write FUnitsPerEm;
    property Descent: Integer read FDescent write FDescent;
    property ItalicAngle: Integer read FItalicAngle write FItalicAngle;
    property Box: TRect read FBox write FBox;
    property CharWidths: TTMSFNCPDFGraphicsLibFontCharWidths read GetCharWidths;
    property GlyphIDs: TTMSFNCPDFGraphicsLibUsedFontCharArray read GetGlyphIDs;
    property FontFile: TTMSFNCGeneralPDFLibFontFile read FFontFile write FFontFile;
    property FontDescriptor: TTMSFNCGeneralPDFLibFontDescriptor read FFontDescriptor write FFontDescriptor;
    property FontDescendant: TTMSFNCGeneralPDFLibFontDescendant read FFontDescendant write FFontDescendant;
    property FontUnicode: TTMSFNCGeneralPDFLibFontUnicode read FFontUnicode write FFontUnicode;
    property CharArray: TTMSFNCPDFGraphicsLibFontCharArray read GetCharArray;
    property UsedCharArray: TTMSFNCPDFGraphicsLibUsedFontCharArray read GetUsedCharArray;
    property Unicode: Boolean read FUnicode write FUnicode;
    property TrueType: Boolean read FTrueType write FTrueType;
    property FontProgramType: TTMSFNCPDFFontProgramType read FFontProgramType write FFontProgramType;
    property Initializer: TTMSFNCGeneralPDFLibFontInitializer read FInitializer;
  end;

  TTMSFNCGeneralPDFLibFontDescriptor = class(TTMSFNCGeneralPDFLibObject)
  private
    FFont: TTMSFNCGeneralPDFLibFont;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont); reintroduce; virtual;
    destructor Destroy; override;
    property Font: TTMSFNCGeneralPDFLibFont read FFont write FFont;
  end;

  TTMSFNCGeneralPDFLibFontFile = class(TTMSFNCGeneralPDFLibObject)
  private
    FFont: TTMSFNCGeneralPDFLibFont;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont); reintroduce; virtual;
    destructor Destroy; override;
    property Font: TTMSFNCGeneralPDFLibFont read FFont write FFont;
    procedure InitializeFontFile;
  end;

  TTMSFNCGeneralPDFLibFontDescendant = class(TTMSFNCGeneralPDFLibObject)
  private
    FFont: TTMSFNCGeneralPDFLibFont;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont); reintroduce; virtual;
    destructor Destroy; override;
    property Font: TTMSFNCGeneralPDFLibFont read FFont write FFont;
  end;

  TTMSFNCGeneralPDFLibFontUnicode = class(TTMSFNCGeneralPDFLibObject)
  private
    FFont: TTMSFNCGeneralPDFLibFont;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont); reintroduce; virtual;
    destructor Destroy; override;
    property Font: TTMSFNCGeneralPDFLibFont read FFont write FFont;
  end;

  TTMSFNCGeneralPDFLibXObject = class(TTMSFNCGeneralPDFLibObject);

  TTMSFNCGeneralPDFLibBitmap = class(TTMSFNCGeneralPDFLibXObject)
  private
    FStream: TMemoryStream;
    FBitmap: TTMSFNCBitmap;
    FImageType: TTMSFNCPDFGraphicsLibImageType;
    FQuality: Single;
    FBackgroundColor: TTMSFNCGraphicsColor;
    procedure SetBitmap(const Value: TTMSFNCBitmap);
    function GetRefNameBase: String; override;
    procedure SetStream(const Value: TMemoryStream);
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const ABitmap: TTMSFNCBitmapHelperClass; const AStream: TMemoryStream; const AImageType: TTMSFNCPDFGraphicsLibImageType; const AQuality: Single; const ABackgroundColor: TTMSFNCGraphicsColor); reintroduce; virtual;
    destructor Destroy; override;
    property Stream: TMemoryStream read FStream write SetStream;
    property Bitmap: TTMSFNCBitmap read FBitmap write SetBitmap;
    property ImageType: TTMSFNCPDFGraphicsLibImageType read FImageType write FImageType;
    property Quality: Single read FQuality write FQuality;
    property BackgroundColor: TTMSFNCGraphicsColor read FBackgroundColor write FBackgroundColor;
  end;

  TTMSFNCGeneralPDFLibShadingSubFunction = class(TTMSFNCGeneralPDFLibObject)
  private
    FFillColor: TTMSFNCGraphicsColor;
    FFillColorTo: TTMSFNCGraphicsColor;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFillColor: TTMSFNCGraphicsColor; const AFillColorTo: TTMSFNCGraphicsColor); reintroduce; virtual;
    property FillColor: TTMSFNCGraphicsColor read FFillColor write FFillColor;
    property FillColorTo: TTMSFNCGraphicsColor read FFillColorTo write FFillColorTo;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibShadingSubFunctions = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibShadingSubFunction;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibShadingSubFunction);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibShadingSubFunction read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibShadingSubFunctions = class(TList<TTMSFNCGeneralPDFLibShadingSubFunction>);
  {$ENDIF}

  TTMSFNCGeneralPDFLibShadingFunction = class(TTMSFNCGeneralPDFLibObject)
  private
    FSubFunctions: TTMSFNCGeneralPDFLibShadingSubFunctions;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib); reintroduce; virtual;
    destructor Destroy; override;
    property SubFunctions: TTMSFNCGeneralPDFLibShadingSubFunctions read FSubFunctions;
    function SubFunctionsRef: String;
  end;

  TTMSFNCGeneralPDFLibShading = class(TTMSFNCGeneralPDFLibObject)
  private
    FFunction: TTMSFNCGeneralPDFLibShadingFunction;
    FRect: TRectF;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib); reintroduce; virtual;
    destructor Destroy; override;
    function RectAsString: string; virtual;
    property &Function: TTMSFNCGeneralPDFLibShadingFunction read FFunction write FFunction;
    property Rect: TRectF read FRect write FRect;
  end;

  TTMSFNCGeneralPDFLibAnnotation = class(TTMSFNCGeneralPDFLibObject)
  private
    FRect: TRectF;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const ARect: TRectF); reintroduce; virtual;
    destructor Destroy; override;
    function RectAsString: String;
    property Rect: TRectF read FRect write FRect;
  end;

  TTMSFNCGeneralPDFLibURL = class(TTMSFNCGeneralPDFLibAnnotation)
  private
    FURL: UnicodeString;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const ARect: TRectF; const AURL: UnicodeString); reintroduce; virtual;
    property URL: UnicodeString read FURL write FURL;
  end;

  TTMSFNCGeneralPDFLibGoTo = class(TTMSFNCGeneralPDFLibAnnotation)
  private
    FDestination: UnicodeString;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const ARect: TRectF; const ADestination: UnicodeString); reintroduce; virtual;
    property Destination: UnicodeString read FDestination write FDestination;
  end;

  TTMSFNCGeneralPDFLibGoTo2 = class(TTMSFNCGeneralPDFLibAnnotation)
  private
    FPageIndex: Integer;
    FOptions: UnicodeString;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const ARect: TRectF; const APageIndex: Integer; const AOptions: UnicodeString); reintroduce; virtual;
    property Options: UnicodeString read FOptions write FOptions;
    property PageIndex: Integer read FPageIndex write FPageIndex;
  end;

  TTMSFNCGeneralPDFLibFormField = class(TTMSFNCGeneralPDFLibAnnotation, ITMSFNCCustomPDFFormField)
  private
    FPartialName: string;
    FReadOnly: Boolean;
    FHidden: Boolean;
    FOwnerInterface: IInterface;
  protected
    procedure SetFieldName(const Value: string);
    procedure SetRect(const Value: TRectF);
    procedure SetReadOnly(const Value: Boolean);
    procedure SetHidden(const Value: Boolean);
    function GetFieldName: string;
    function GetRect: TRectF;
    function GetReadOnly: Boolean;
    function GetHidden: Boolean;
    {$IFDEF LCLLIB}
    function _AddRef : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    function _Release : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function _AddRef: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    function _Release: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string; const ARect: TRectF; const AReadOnly: Boolean; const AHidden: Boolean); reintroduce; virtual;
    {$IFDEF LCLLIB}
    function QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function QueryInterface(const IID: TGUID; out Obj): HResult; virtual; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
    property PartialName: string read FPartialName write FPartialName;
    property &ReadOnly: Boolean read FReadOnly write FReadOnly;
    property Hidden: Boolean read FHidden write FHidden;
  end;

  TTMSFNCGeneralPDFLibFormXObject = class(TTMSFNCGeneralPDFLibXObject);
  TTMSFNCGeneralPDFLibFormFieldButton = class(TTMSFNCGeneralPDFLibFormField);
  TTMSFNCGeneralPDFLibFormFieldCheckBoxContent = class;

  TTMSFNCGeneralPDFLibFormFieldCheckBox = class(TTMSFNCGeneralPDFLibFormFieldButton)
  private
    FIsChecked: Boolean;
    FOnContent: TTMSFNCGeneralPDFLibFormFieldCheckBoxContent;
    FOffContent: TTMSFNCGeneralPDFLibFormFieldCheckBoxContent;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string; const ARect: TRectF; const AIsChecked: Boolean; const AReadOnly: Boolean; const AHidden: Boolean); reintroduce; virtual;
    property IsChecked: Boolean read FIsChecked write FIsChecked;
    property OnContent: TTMSFNCGeneralPDFLibFormFieldCheckBoxContent read FOnContent write FOnContent;
    property OffContent: TTMSFNCGeneralPDFLibFormFieldCheckBoxContent read FOffContent write FOffContent;
  end;

  TTMSFNCGeneralPDFLibFormFieldCheckBoxContent = class(TTMSFNCGeneralPDFLibFormXObject)
  private
    FIsOnState: Boolean;
    FFormField: TTMSFNCGeneralPDFLibFormFieldCheckBox;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFormField: TTMSFNCGeneralPDFLibFormFieldCheckBox; const AIsOnState: Boolean); reintroduce; virtual;
    property FormField: TTMSFNCGeneralPDFLibFormFieldCheckBox read FFormField;
    property IsOnState: Boolean read FIsOnState;
  end;

  TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup = class(TTMSFNCGeneralPDFLibFormField)
  private
    FGroupID: string;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string; const AGroupID: string); reintroduce; virtual;
    property GroupID: string read FGroupID write FGroupID;
  end;

  TTMSFNCGeneralPDFLibFormFieldRadioButtonContent = class;

  TTMSFNCGeneralPDFLibFormFieldRadioButton = class(TTMSFNCGeneralPDFLibFormFieldButton)
  private
    FIsChecked: Boolean;
    FGroupID: string;
    FOnContent: TTMSFNCGeneralPDFLibFormFieldRadioButtonContent;
    FOffContent: TTMSFNCGeneralPDFLibFormFieldRadioButtonContent;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string; const ARect: TRectF; const AGroupID: string; const AIsChecked, AReadOnly, AHidden: Boolean); reintroduce; virtual;
    property GroupID: string read FGroupID write FGroupID;
    property IsChecked: Boolean read FIsChecked write FIsChecked;
    property OnContent: TTMSFNCGeneralPDFLibFormFieldRadioButtonContent read FOnContent write FOnContent;
    property OffContent: TTMSFNCGeneralPDFLibFormFieldRadioButtonContent read FOffContent write FOffContent;
  end;

  TTMSFNCGeneralPDFLibFormFieldRadioButtonContent = class(TTMSFNCGeneralPDFLibFormXObject)
  private
    FIsOnState: Boolean;
    FFormField: TTMSFNCGeneralPDFLibFormFieldRadioButton;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFormField: TTMSFNCGeneralPDFLibFormFieldRadioButton; const AIsOnState: Boolean); reintroduce; virtual;
    property FormField: TTMSFNCGeneralPDFLibFormFieldRadioButton read FFormField;
    property IsOnState: Boolean read FIsOnState;
  end;

  TTMSFNCGeneralPDFLibFormFieldTextContent = class;

  TTMSFNCGeneralPDFLibFormFieldText = class(TTMSFNCGeneralPDFLibFormField, ITMSFNCCustomPDFFormFieldEdit)
  private
    FText: string;
    FMultiline: Boolean;
    FIsPassword: Boolean;
    FHorizontalAlign: TTMSFNCGraphicsTextAlign;
    FContent: TTMSFNCGeneralPDFLibFormFieldTextContent;
    FFont: TTMSFNCPDFGraphicsLibFont;
    FAutoSize: Boolean;
    FOnChanged: TNotifyEvent;
  protected
    procedure SetText(const Value: UnicodeString);
    procedure SetHorizontalAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetFont(const Value: TTMSFNCPDFGraphicsLibFont);
    procedure SetFontAutoSize(const Value: Boolean);
    function GetText: UnicodeString;
    function GetHorizontalAlign: TTMSFNCGraphicsTextAlign;
    function GetFont: TTMSFNCPDFGraphicsLibFont;
    function GetFontAutoSize: Boolean;
    procedure DoChanged;
    procedure DoFontChanged(Sender: TObject);
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string; const ARect: TRectF; const AText: UnicodeString; const ATextAlign: TTMSFNCGraphicsTextAlign; const AReadOnly: Boolean; const AHidden: Boolean); reintroduce; virtual;
    destructor Destroy; override;
    property Text: UnicodeString read GetText write SetText;
    property HorizontalAlign: TTMSFNCGraphicsTextAlign read GetHorizontalAlign write SetHorizontalAlign;
    property Font: TTMSFNCPDFGraphicsLibFont read GetFont write SetFont;
    property Multiline: Boolean read FMultiline write FMultiline;
    property IsPassword: Boolean read FIsPassword write FIsPassword;
    property AutoSize: Boolean read GetFontAutoSize write SetFontAutoSize;
    property Content: TTMSFNCGeneralPDFLibFormFieldTextContent read FContent write FContent;
    property OnChanged: TNotifyEvent read FOnChanged write FOnChanged;
  end;

  TTMSFNCGeneralPDFLibFormFieldTextContent = class(TTMSFNCGeneralPDFLibFormXObject)
  private
    FFormField: TTMSFNCGeneralPDFLibFormFieldText;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; AFormField: TTMSFNCGeneralPDFLibFormFieldText); reintroduce; virtual;
    property FormField: TTMSFNCGeneralPDFLibFormFieldText read FFormField;
  end;

  TTMSFNCGeneralPDFLibFormFieldChoice = class(TTMSFNCGeneralPDFLibFormField)
  private
    FItemIndex: Integer;
    FItems: TStrings;
    FFont: TTMSFNCPDFGraphicsLibFont;
    FOnChanged: TNotifyEvent;
  protected
    procedure DoChanged;
    procedure DoItemsChange(Sender: TObject);
    procedure DoFontChanged(Sender: TObject);
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string; const ARect: TRectF; const AItems: TTMSFNCPDFLibStringArray; const AItemIndex: Integer; const AReadOnly: Boolean; const AHidden: Boolean); reintroduce; virtual;
    destructor Destroy; override;
    property Items: TStrings read FItems write FItems;
    property ItemIndex: Integer read FItemIndex write FItemIndex;
    property Font: TTMSFNCPDFGraphicsLibFont read FFont write FFont;
    property OnChanged: TNotifyEvent read FOnChanged write FOnChanged;
  end;

  TTMSFNCGeneralPDFLibFormFieldComboBoxContent = class;

  TTMSFNCGeneralPDFLibFormFieldComboBox = class(TTMSFNCGeneralPDFLibFormFieldChoice, ITMSFNCCustomPDFFormFieldComboBox)
  private
    FEditable: Boolean;
    FAutoSize: Boolean;
    FContent: TTMSFNCGeneralPDFLibFormFieldComboBoxContent;
  protected
    procedure SetItems(const Value: TStrings);
    procedure SetItemIndex(const Value: Integer);
    procedure SetEditable(const Value: Boolean);
    procedure SetFont(const Value: TTMSFNCPDFGraphicsLibFont);
    procedure SetFontAutoSize(const Value: Boolean);
    function GetItems: TStrings;
    function GetItemIndex: Integer;
    function GetEditable: Boolean;
    function GetFont: TTMSFNCPDFGraphicsLibFont;
    function GetFontAutoSize: Boolean;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string; const ARect: TRectF; const AItems: TTMSFNCPDFLibStringArray; const AItemIndex: Integer; const AEditable: Boolean; const AReadOnly: Boolean; const AHidden: Boolean); reintroduce; virtual;
    property Editable: Boolean read GetEditable write SetEditable;
    property AutoSize: Boolean read GetFontAutoSize write SetFontAutoSize;
    property Content: TTMSFNCGeneralPDFLibFormFieldComboBoxContent read FContent write FContent;
  end;

  TTMSFNCGeneralPDFLibFormFieldComboBoxContent = class(TTMSFNCGeneralPDFLibFormXObject)
  private
    FFormField: TTMSFNCGeneralPDFLibFormFieldComboBox;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; AFormField: TTMSFNCGeneralPDFLibFormFieldComboBox); reintroduce; virtual;
    property FormField: TTMSFNCGeneralPDFLibFormFieldComboBox read FFormField;
  end;

  TTMSFNCGeneralPDFLibFormFieldListBoxContent = class;

  TTMSFNCGeneralPDFLibFormFieldListBox = class(TTMSFNCGeneralPDFLibFormFieldChoice, ITMSFNCCustomPDFFormFieldListBox)
  private
    FContent: TTMSFNCGeneralPDFLibFormFieldListBoxContent;
  protected
    procedure SetItems(const Value: TStrings);
    procedure SetItemIndex(const Value: Integer);
    procedure SetFont(const Value: TTMSFNCPDFGraphicsLibFont);
    function GetItems: TStrings;
    function GetItemIndex: Integer;
    function GetFont: TTMSFNCPDFGraphicsLibFont;
  public
    property Content: TTMSFNCGeneralPDFLibFormFieldListBoxContent read FContent write FContent;
  end;

  TTMSFNCGeneralPDFLibFormFieldListBoxContent = class(TTMSFNCGeneralPDFLibFormXObject)
  private
    FFormField: TTMSFNCGeneralPDFLibFormFieldListBox;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; AFormField: TTMSFNCGeneralPDFLibFormFieldListBox); reintroduce; virtual;
    property FormField: TTMSFNCGeneralPDFLibFormFieldListBox read FFormField;
  end;

  TTMSFNCGeneralPDFLibPattern = class(TTMSFNCGeneralPDFLibObject)
  private
    FShading: TTMSFNCGeneralPDFLibShading;
    function GetRefNameBase: string; override;
  public
    destructor Destroy; override;
    property Shading: TTMSFNCGeneralPDFLibShading read FShading write FShading;
  end;

  TTMSFNCGeneralPDFLibLinearGradient = class(TTMSFNCGeneralPDFLibShading)
  private
    FFillOrientation: TTMSFNCGraphicsFillOrientation;
  public
    constructor Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFillOrientation: TTMSFNCGraphicsFillOrientation); reintroduce; virtual;
    property FillOrientation: TTMSFNCGraphicsFillOrientation read FFillOrientation write FFillOrientation;
  end;

  TTMSFNCGeneralPDFLibXRefObject = class
  private
    FXRefOffset: integer;
    FXRefNumber: integer;
    FXRefType: string;
    FXRefObject: TTMSFNCGeneralPDFLibObject;
    FInXRefList: Boolean;
  public
    constructor Create(const AValue: TTMSFNCGeneralPDFLibObject = nil);
    destructor Destroy; override;
    class function FormatValue(AValue: Integer; ALength: Integer): string;
    function GenerateXRefValue: string;
    property XRefOffset: integer read FXRefOffset write FXRefOffset;
    property XRefNumber: integer read FXRefNumber write FXRefNumber;
    property XRefType: string read FXRefType write FXRefType;
    property XRefObject: TTMSFNCGeneralPDFLibObject read FXRefObject write FXRefObject;
    property InXRefList: Boolean read FInXRefList write FInXRefList;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCGeneralPDFLibXRefObjects = class(TObjectList)
  private
    function GetItem(Index: Integer): TTMSFNCGeneralPDFLibXRefObject;
    procedure SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibXRefObject);
  public
    property Items[Index: Integer]: TTMSFNCGeneralPDFLibXRefObject read GetItem write SetItem; default;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCGeneralPDFLibXRefObjects = class(TObjectList<TTMSFNCGeneralPDFLibXRefObject>)
  public
  {$ENDIF}
    function AddObjectClass(const AObjectClass: TTMSFNCGeneralPDFLibObjectClass = nil): TTMSFNCGeneralPDFLibXRefObject;
    function AddObject(const AObject: TTMSFNCGeneralPDFLibObject = nil): TTMSFNCGeneralPDFLibXRefObject;
    function IndexOfObject(const AObject: TTMSFNCGeneralPDFLibObject; const ACheckClassType: Boolean = False): Integer;
  end;

  TTMSFNCGeneralPDFLib = class(TInterfacedObject, ITMSFNCCustomPDFLib, ITMSFNCCustomPDFFormFieldsLib)
  private
    {$IFNDEF LCLWEBLIB}
    FComparePageNumbers: IComparer<TTMSFNCGeneralPDFLibPage>;
    {$ENDIF}
    FOnBeforeDrawHeader: TTMSFNCPDFLibBeforeDrawHeaderEvent;
    FOnBeforeDrawFooter: TTMSFNCPDFLibBeforeDrawFooterEvent;
    FOnBeforeDrawPageNumber: TTMSFNCPDFLibBeforeDrawPageNumberEvent;
    FOnAfterDrawHeader: TTMSFNCPDFLibAfterDrawHeaderEvent;
    FOnAfterDrawFooter: TTMSFNCPDFLibAfterDrawFooterEvent;
    FOnAfterDrawPageNumber: TTMSFNCPDFLibAfterDrawPageNumberEvent;
    FOnNewPageStarted: TTMSFNCPDFLibNewPageStartedEvent;
    FPageHeight, FPageWidth: Single;
    FBlockFontUpdate: Boolean;
    FOSFontList: TStringList;
    FInfo: TTMSFNCGeneralPDFLibInfo;
    FDestOutputProfile: TTMSFNCGeneralPDFLibDestOutputProfile;
    FInitializer: TTMSFNCGeneralPDFLibInitializer;
    FAcroForm: TTMSFNCGeneralPDFLibAcroForm;
    FOutputIntent: TTMSFNCGeneralPDFLibOutputIntent;
    FActivePage: TTMSFNCGeneralPDFLibPage;
    FActiveFont: TTMSFNCGeneralPDFLibFont;
    FFormFieldGlobalFont: TTMSFNCPDFGraphicsLibFont;
    FFormFieldGlobalAutoSize: Boolean;
    FActiveShading: TTMSFNCGeneralPDFLibShading;
    XRefAddress: Int64;
    FXRefObjects: TTMSFNCGeneralPDFLibXRefObjects;
    FFontList: TTMSFNCGeneralPDFLibFonts;
    FFontLookupCache: TStringList;
    FPageCount: Integer;
    FOutput: TTMSFNCPDFGraphicsLibOutputWriter;
    FPDFFileName: string;
    FDocumentStarted, FPageStarted: Boolean;
    FPDFGraphicsLib: ITMSFNCCustomPDFGraphicsLib;
    FPDFGraphicsExLib: ITMSFNCCustomPDFGraphicsExLib;
    FPDFInitializationLib: ITMSFNCCustomPDFInitializationLib;
    FMediaBox: TRectF;
    FPageOrientation: TTMSFNCPDFLibPageOrientation;
    FAuthor: String;
    FSubject: String;
    FAllowsPrinting: Boolean;
    FTitle: String;
    FCreator: String;
    FUserPassword: String;
    FAllowsCopying: Boolean;
    FKeywords: TStrings;
    FOwnerPassword: String;
    FBleedBox: TRectF;
    FCropBox: TRectF;
    FArtBox: TRectF;
    FTrimBox: TRectF;
    FPageSize: TTMSFNCPDFLibPageSize;
    FPageNumberFormat: UnicodeString;
    FPageNumber: TTMSFNCPDFLibPageNumber;
    FPageNumberSize: Single;
    FPageNumberMargins: TTMSFNCMargins;
    FHeader: UnicodeString;
    FFooter: UnicodeString;
    FHeaderSize: Single;
    FHeaderMargins: TTMSFNCMargins;
    FFooterMargins: TTMSFNCMargins;
    FFooterSize: Single;
    FFooterAlignment: TTMSFNCGraphicsTextAlign;
    FHeaderAlignment: TTMSFNCGraphicsTextAlign;
    FPageNumberAlignment: TTMSFNCGraphicsTextAlign;
    FModificationDate: string;
    FProducer: String;
    FCreationDate: String;
    FEmbedFonts: Boolean;
    FFontFallBackList: TStrings;
    FFooterFont: TTMSFNCPDFGraphicsLibFont;
    FHeaderFont: TTMSFNCPDFGraphicsLibFont;
    FPageNumberFont: TTMSFNCPDFGraphicsLibFont;
    FPDFStandard: TTMSFNCPDFLibStandard;
    procedure SetPageSize(const Value: TTMSFNCPDFLibPageSize);
    procedure SetPageOrientation(
      const Value: TTMSFNCPDFLibPageOrientation);
    procedure SetHeaderMargins(const Value: TTMSFNCMargins);
    procedure SetPageNumberMargins(const Value: TTMSFNCMargins);
    procedure SetFooterMargins(const Value: TTMSFNCMargins);
    procedure SetAllowsCopying(const Value: Boolean);
    procedure SetAllowsPrinting(const Value: Boolean);
    procedure SetAuthor(const Value: String);
    procedure SetCreator(const Value: String);
    procedure SetFooter(const Value: UnicodeString);
    procedure SetFooterAlignment(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetFooterSize(const Value: Single);
    procedure SetHeader(const Value: UnicodeString);
    procedure SetHeaderAlignment(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetHeaderSize(const Value: Single);
    procedure SetPageNumber(const Value: TTMSFNCPDFLibPageNumber);
    procedure SetPageNumberFormat(const Value: UnicodeString);
    procedure SetPageNumberAlignment(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetPageNumberSize(const Value: Single);
    procedure SetKeywords(const Value: TStrings);
    procedure SetFontFallBackList(const Value: TStrings);
    procedure SetOwnerPassword(const Value: String);
    procedure SetSubject(const Value: String);
    procedure SetTitle(const Value: String);
    procedure SetUserPassword(const Value: String);
    procedure SetArtBox(const Value: TRectF);
    procedure SetBleedBox(const Value: TRectF);
    procedure SetCropBox(const Value: TRectF);
    procedure SetMediaBox(const Value: TRectF);
    procedure SetTrimBox(const Value: TRectF);
    procedure SetEmbedFonts(const Value: Boolean);
    procedure SetFooterFont(const Value: TTMSFNCPDFGraphicsLibFont);
    procedure SetHeaderFont(const Value: TTMSFNCPDFGraphicsLibFont);
    procedure SetPageNumberFont(const Value: TTMSFNCPDFGraphicsLibFont);
    procedure SetPageHeight(const Value: Single);
    procedure SetPageWidth(const Value: Single);
    procedure SetOnAfterDrawFooter(const Value: TTMSFNCPDFLibAfterDrawFooterEvent);
    procedure SetOnAfterDrawHeader(const Value: TTMSFNCPDFLibAfterDrawHeaderEvent);
    procedure SetOnAfterDrawPageNumber(const Value: TTMSFNCPDFLibAfterDrawPageNumberEvent);
    procedure SetOnBeforeDrawFooter(const Value: TTMSFNCPDFLibBeforeDrawFooterEvent);
    procedure SetOnBeforeDrawHeader(const Value: TTMSFNCPDFLibBeforeDrawHeaderEvent);
    procedure SetOnBeforeDrawPageNumber(const Value: TTMSFNCPDFLibBeforeDrawPageNumberEvent);
    procedure SetOnNewPageStarted(const Value: TTMSFNCPDFLibNewPageStartedEvent);
    procedure SetBitmapContainer(const Value: TTMSFNCBitmapContainer);
    procedure SetPDFStandard(const Value: TTMSFNCPDFLibStandard);
    function GetPDFStandard: TTMSFNCPDFLibStandard;
    function GetAllowsCopying: Boolean;
    function GetAllowsPrinting: Boolean;
    function GetAuthor: String;
    function GetCreator: String;
    function GetFooter: UnicodeString;
    function GetFooterAlignment: TTMSFNCGraphicsTextAlign;
    function GetFooterMargins: TTMSFNCMargins;
    function GetFooterSize: Single;
    function GetHeader: UnicodeString;
    function GetHeaderAlignment: TTMSFNCGraphicsTextAlign;
    function GetHeaderMargins: TTMSFNCMargins;
    function GetHeaderSize: Single;
    function GetPageNumber: TTMSFNCPDFLibPageNumber;
    function GetPageNumberFormat: UnicodeString;
    function GetPageNumberAlignment: TTMSFNCGraphicsTextAlign;
    function GetPageNumberMargins: TTMSFNCMargins;
    function GetPageNumberSize: Single;
    function GetKeywords: TStrings;
    function GetFontFallBackList: TStrings;
    function GetOwnerPassword: String;
    function GetPageOrientation: TTMSFNCPDFLibPageOrientation;
    function GetPageSize: TTMSFNCPDFLibPageSize;
    function GetSubject: String;
    function GetTitle: String;
    function GetUserPassword: String;
    function GetArtBox: TRectF;
    function GetBleedBox: TRectF;
    function GetCreationDate: String;
    function GetCropBox: TRectF;
    function GetMediaBox: TRectF;
    function GetModificationDate: string;
    function GetProducer: String;
    function GetTrimBox: TRectF;
    function GetEmbedFonts: Boolean;
    function GetFooterFont: TTMSFNCPDFGraphicsLibFont;
    function GetHeaderFont: TTMSFNCPDFGraphicsLibFont;
    function GetPageNumberFont: TTMSFNCPDFGraphicsLibFont;
    function GetPageHeight: Single;
    function GetPageWidth: Single;
    function GetOnAfterDrawFooter: TTMSFNCPDFLibAfterDrawFooterEvent;
    function GetOnAfterDrawHeader: TTMSFNCPDFLibAfterDrawHeaderEvent;
    function GetOnAfterDrawPageNumber: TTMSFNCPDFLibAfterDrawPageNumberEvent;
    function GetOnBeforeDrawFooter: TTMSFNCPDFLibBeforeDrawFooterEvent;
    function GetOnBeforeDrawHeader: TTMSFNCPDFLibBeforeDrawHeaderEvent;
    function GetOnBeforeDrawPageNumber: TTMSFNCPDFLibBeforeDrawPageNumberEvent;
    function GetOnNewPageStarted: TTMSFNCPDFLibNewPageStartedEvent;
    function GetBitmapContainer: TTMSFNCBitmapContainer;
  protected
    procedure DoNewPageStarted(APageIndex: Integer);
    procedure DoBeforeDrawHeader(Sender: TObject; APageIndex: Integer; AHeader: UnicodeString; ARect: TRectF; AGraphics: ITMSFNCCustomPDFGraphicsLib; var ADefaultDraw: Boolean); virtual;
    procedure DoBeforeDrawPageNumber(Sender: TObject; APageIndex: Integer; APageNumber: UnicodeString; ARect: TRectF; AGraphics: ITMSFNCCustomPDFGraphicsLib; var ADefaultDraw: Boolean); virtual;
    procedure DoBeforeDrawFooter(Sender: TObject; APageIndex: Integer; AFooter: UnicodeString; ARect: TRectF; AGraphics: ITMSFNCCustomPDFGraphicsLib; var ADefaultDraw: Boolean); virtual;
    procedure DoAfterDrawHeader(Sender: TObject; APageIndex: Integer; AHeader: UnicodeString; ARect: TRectF; AGraphics: ITMSFNCCustomPDFGraphicsLib); virtual;
    procedure DoAfterDrawPageNumber(Sender: TObject; APageIndex: Integer; APageNumber: UnicodeString; ARect: TRectF; AGraphics: ITMSFNCCustomPDFGraphicsLib); virtual;
    procedure DoAfterDrawFooter(Sender: TObject; APageIndex: Integer; AFooter: UnicodeString; ARect: TRectF; AGraphics: ITMSFNCCustomPDFGraphicsLib); virtual;
    procedure FontChanged(Sender: TObject);
    procedure NotifyURL(Sender: TObject; ARect: TRectF; AURL: UnicodeString);
    procedure NotifyGoTo(Sender: TObject; ARect: TRectF; ADestination: UnicodeString);
    procedure NotifyGoTo2(Sender: TObject; ARect: TRectF; APageIndex: Integer; AOptions: UnicodeString);
    procedure NotifyUnicode(Sender: TObject; AValue: UnicodeString);
    procedure NotifyText(Sender: TObject; {%H-}AValue: UnicodeString);
    procedure NotifyShading(Sender: TObject; AFillColor: TTMSFNCGraphicsColor; AFillColorTo: TTMSFNCGraphicsColor; AFillOrientation: TTMSFNCGraphicsFillOrientation; var AShadingReference: string);
    procedure NotifyShadingRect(Sender: TObject; ARect: TRectF);
    procedure NotifyBitmap(Sender: TObject; AValue: TTMSFNCBitmapHelperClass; AImageType: TTMSFNCPDFGraphicsLibImageType; AQuality: Single; ABackgroundColor: TTMSFNCGraphicsColor; var ABitmapReference: string);
    procedure DestroyFont(AFont: TTMSFNCGeneralPDFLibFont);
    procedure FormTextFieldChanged(Sender: TObject);
    procedure FormChoiceFieldChanged(Sender: TObject);
    procedure FormUpdateFontList(AText: UnicodeString; AFont: TTMSFNCPDFGraphicsLibFont);
    procedure UpdateBoxRect;
    procedure FinishPage;
    procedure CleanUpUnusedFonts;
    procedure UpdateFontList(ASearchForUnicodeFont: Boolean = False);
    procedure WriteFontList;
    procedure InitializeFontList;
    procedure UpdateGlyphIds;
    procedure WriteBitmapList;
    procedure WriteAnnotationList;
    procedure WriteFormXObjects;
    procedure WritePatternList;
    procedure WriteShadingList;
    procedure WriteXRefTable;
    procedure SetPDFGraphicsLib(const Value: ITMSFNCCustomPDFGraphicsLib);
    procedure SetPDFGraphicsExLib(const Value: ITMSFNCCustomPDFGraphicsExLib);
    procedure SetPDFInitializationLib(const Value: ITMSFNCCustomPDFInitializationLib);
    function GetFontCacheKey(const ABaseFontName: string; AUnicodeFont: Boolean): string;
    function GetCachedFont(const ABaseFontName: string; AUnicodeFont: Boolean): TTMSFNCGeneralPDFLibFont;
    function BuildInternalFontName(const AFontName: string; const AFontStyle: TFontStyles): string;
    function ShouldUseUnicodeFontForText(const AText: UnicodeString): Boolean;
    procedure CacheFont(const AFont: TTMSFNCGeneralPDFLibFont);
    procedure RemoveCachedFont(const AFont: TTMSFNCGeneralPDFLibFont);
    procedure ClearFontCache;
    function GetFormFieldFont: TTMSFNCPDFGraphicsLibFont;
    function GetFormFieldAutosize: Boolean;
    procedure SetFormFieldFont(const Value: TTMSFNCPDFGraphicsLibFont);
    procedure SetFormFieldAutoSize(const Value: Boolean);
    function AddEdit(AFieldName: string; ARect: TRectF; AHorizontalAlign: TTMSFNCGraphicsTextAlign = gtaLeading; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldEdit; overload;
    function AddEdit(AFieldName: string; ARect: TRectF; AText: UnicodeString; AHorizontalAlign: TTMSFNCGraphicsTextAlign = gtaLeading; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldEdit; overload;
    function AddMemo(AFieldName: string; ARect: TRectF; AHorizontalAlign: TTMSFNCGraphicsTextAlign = gtaLeading; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldEdit; overload;
    function AddMemo(AFieldName: string; ARect: TRectF; AText: UnicodeString; AHorizontalAlign: TTMSFNCGraphicsTextAlign = gtaLeading; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldEdit; overload;
    function AddPasswordEdit(AFieldName: string; ARect: TRectF; AHorizontalAlign: TTMSFNCGraphicsTextAlign = gtaLeading; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldEdit;
    function AddComboBox(AFieldName: string; ARect: TRectF; AItems: TTMSFNCPDFLibStringArray; AItemIndex: Integer = -1; AEditable: Boolean = False; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldComboBox; overload;
    function AddComboBox(AFieldName: string; ARect: TRectF; AItems: TStrings; AItemIndex: Integer = -1; AEditable: Boolean = False; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldComboBox; overload;
    function AddListBox(AFieldName: string; ARect: TRectF; AItems: TTMSFNCPDFLibStringArray; AItemIndex: Integer = -1; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldListBox; overload;
    function AddListBox(AFieldName: string; ARect: TRectF; AItems: TStrings; AItemIndex: Integer = -1; AReadOnly: Boolean = False; AHidden: Boolean = False): ITMSFNCCustomPDFFormFieldListBox; overload;
    procedure AddCheckBox(AFieldName: string; ARect: TRectF; AIsChecked: Boolean; AReadOnly: Boolean = False; AHidden: Boolean = False);
    procedure AddRadioGroup(AFieldName: string; AGroupID: string);
    procedure AddRadioButton(AFieldName: string; ARect: TRecTF; AGroupID: string; AIsChecked: Boolean = False; AReadOnly: Boolean = False; AHidden: Boolean = False);
    procedure BeginDocument(FileName: String = '');
    procedure OpenDocument({%H-}FileName: String); overload;
    procedure OpenDocument({%H-}FileStream: TMemoryStream); overload;
    procedure SaveDocumentFromStream({%H-}FileStream: TMemoryStream; {%H-}FileName: String);
    procedure GetDocumentInfo;
    procedure GetPageInfo({%H-}PageIndex: Integer);
    procedure CloseDocument;
    procedure NewPage;
    procedure InsertPage(PageIndex: Integer);
    procedure DrawPage({%H-}PageIndex: Integer);
    procedure DrawHeader;
    procedure DrawFooter;
    procedure DrawPageNumber;
    function GetPDFGraphicsLib: ITMSFNCCustomPDFGraphicsLib;
    function GetPDFGraphicsExLib: ITMSFNCCustomPDFGraphicsExLib;
    function GetPDFInitializationLib: ITMSFNCCustomPDFInitializationLib;
    function CompareStreams(AStream1, AStream2: TMemoryStream): Boolean;
    function VerifyFontName(AFontName: string): string;
    function SearchForFont(ABaseFontName: string; AUnicodeFont: Boolean): TTMSFNCGeneralPDFLibFont;
    function GetPageReferences: String;
    function GetAcroFormFieldReferences: string;
    function GetKeywordsString: string;
    function GetAcroFormFontsRefs: string;
    function GetFontRefs(APage: TTMSFNCGeneralPDFLibPage): String;
    function GetXObjectRefs(APage: TTMSFNCGeneralPDFLibPage): string;
    function GetShadingRef(APage: TTMSFNCGeneralPDFLibPage): string;
    function GetAnnotationsRef(APage: TTMSFNCGeneralPDFLibPage): string;
    function GetPatternRef(APage: TTMSFNCGeneralPDFLibPage): string;
    function GetContentRef(APage: TTMSFNCGeneralPDFLibPage): string;
    function GetRadioGroupReferences(AGroup: TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup): string;
    function GetRadioGroupCheckedValueRef(AGroup: TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup): string;
    function GetRadioButtonParentRef(ARadioButton: TTMSFNCGeneralPDFLibFormFieldRadioButton): string;
    function GetAcroFormRef: string;
    function GetDestOutputProfileRef: String;
    function GetPageRef(APage: TTMSFNCGeneralPDFLibPage): string;
    function GetPageByIndex(APageIndex: Integer): TTMSFNCGeneralPDFLibPage;
    function UnlockWithPassword({%H-}Password: String): Boolean;
    function GetPageCount: Integer;
    function GetPageIndex: Integer;
    function IsDocumentOpened: Boolean;
    function GetHeaderRect: TRectF;
    function GetPageNumberRect: TRectF;
    function GetFooterRect: TRectF;
    function EndDocument(AOpenInPDFReader: Boolean = False): TMemoryStream;
    property MediaBox: TRectF read FMediaBox write FMediaBox;
    property TrimBox: TRectF read FTrimBox write FTrimBox;
    property ArtBox: TRectF read FArtBox write FArtBox;
    property BleedBox: TRectF read FBleedBox write FBleedBox;
    property CropBox: TRectF read FCropBox write FCropBox;
    property EmbedFonts: Boolean read FEmbedFonts write FEmbedFonts;
    property ModificationDate: string read FModificationDate;
    property Producer: String read FProducer;
    property CreationDate: String read FCreationDate;
    property Initializer: TTMSFNCGeneralPDFLibInitializer read FInitializer;
    property PageWidth: Single read GetPageWidth write SetPageWidth;
    property PageHeight: Single read GetPageHeight write SetPageHeight;
    property PageSize: TTMSFNCPDFLibPageSize read FPageSize write FPageSize default psLetter;
    property Orientation: TTMSFNCPDFLibPageOrientation read FPageOrientation write FPageOrientation default poPortrait;
    property Author: String read FAuthor write FAuthor;
    property Creator: String read FCreator write FCreator;
    property Header: UnicodeString read FHeader write FHeader;
    property HeaderSize: Single read FHeaderSize write FHeaderSize;
    property HeaderMargins: TTMSFNCMargins read FHeaderMargins write FHeaderMargins;
    property HeaderAlignment: TTMSFNCGraphicsTextAlign read FHeaderAlignment write FHeaderAlignment default gtaCenter;
    property HeaderFont: TTMSFNCPDFGraphicsLibFont read GetHeaderFont write SetHeaderFont;
    property PageNumberFormat: UnicodeString read FPageNumberFormat write FPageNumberFormat;
    property PageNumber: TTMSFNCPDFLibPageNumber read FPageNumber write FPageNumber;
    property PageNumberSize: Single read FPageNumberSize write FPageNumberSize;
    property PageNumberMargins: TTMSFNCMargins read FPageNumberMargins write FPageNumberMargins;
    property PageNumberAlignment: TTMSFNCGraphicsTextAlign read FPageNumberAlignment write FPageNumberAlignment default gtaTrailing;
    property PageNumberFont: TTMSFNCPDFGraphicsLibFont read GetPageNumberFont write SetPageNumberFont;
    property PDFStandard: TTMSFNCPDFLibStandard read FPDFStandard write FPDFStandard default pdfNone;
    property Footer: UnicodeString read FFooter write FFooter;
    property FooterSize: Single read FFooterSize write FFooterSize;
    property FooterMargins: TTMSFNCMargins read FFooterMargins write FFooterMargins;
    property FooterAlignment: TTMSFNCGraphicsTextAlign read FFooterAlignment write FFooterAlignment default gtaCenter;
    property FooterFont: TTMSFNCPDFGraphicsLibFont read GetFooterFont write SetFooterFont;
    property Title: String read FTitle write FTitle;
    property OwnerPassword: String read FOwnerPassword write FOwnerPassword;
    property UserPassword: String read FUserPassword write FUserPassword;
    property AllowsPrinting: Boolean read FAllowsPrinting write FAllowsPrinting default True;
    property AllowsCopying: Boolean read FAllowsCopying write FAllowsCopying default True;
    property Subject: String read FSubject write FSubject;
    property Keywords: TStrings read FKeywords write FKeywords;
    property FontFallBackList: TStrings read FFontFallBackList write FFontFallBackList;
    property OnBeforeDrawHeader: TTMSFNCPDFLibBeforeDrawHeaderEvent read GetOnBeforeDrawHeader write SetOnBeforeDrawHeader;
    property OnAfterDrawHeader: TTMSFNCPDFLibAfterDrawHeaderEvent read GetOnAfterDrawHeader write SetOnAfterDrawHeader;
    property OnBeforeDrawPageNumber: TTMSFNCPDFLibBeforeDrawPageNumberEvent read GetOnBeforeDrawPageNumber write SetOnBeforeDrawPageNumber;
    property OnAfterDrawPageNumber: TTMSFNCPDFLibAfterDrawPageNumberEvent read GetOnAfterDrawPageNumber write SetOnAfterDrawPageNumber;
    property OnBeforeDrawFooter: TTMSFNCPDFLibBeforeDrawFooterEvent read GetOnBeforeDrawFooter write SetOnBeforeDrawFooter;
    property OnAfterDrawFooter: TTMSFNCPDFLibAfterDrawFooterEvent read GetOnAfterDrawFooter write SetOnAfterDrawFooter;
    property OnNewPageStarted: TTMSFNCPDFLibNewPageStartedEvent read GetOnNewPageStarted write SetOnNewPageStarted;
    property BitmapContainer: TTMSFNCBitmapContainer read GetBitmapContainer write SetBitmapContainer;
  public
    constructor Create;
    destructor Destroy; override;
  end;

var
  PDFLibService: ITMSFNCPDFLibGeneralService;

procedure RegisterPDFLibGeneralService;
begin
  if not TTMSFNCPDFLibPlatformServices.Current.SupportsPlatformService(ITMSFNCPDFLibGeneralService, IInterface(PDFLibService)) then
  begin
    PDFLibService := TTMSFNCGeneralPDFLibService.Create;
    TTMSFNCPDFLibPlatformServices.Current.AddPlatformService(ITMSFNCPDFLibGeneralService, PDFLibService);
  end;
end;

procedure UnregisterPDFLibGeneralService;
begin
  TTMSFNCPDFLibPlatformServices.Current.RemovePlatformService(ITMSFNCPDFLibGeneralService);
end;

{ TTMSFNCGeneralPDFLibService }

function TTMSFNCGeneralPDFLibService.DoCreatePDFLib: ITMSFNCCustomPDFLib;
begin
  Result := TTMSFNCGeneralPDFLib.Create;
end;

function TTMSFNCGeneralPDFLib.AddComboBox(AFieldName: string; ARect: TRectF;
  AItems: TStrings; AItemIndex: Integer; AEditable, AReadOnly,
  AHidden: Boolean): ITMSFNCCustomPDFFormFieldComboBox;
var
  arr: TTMSFNCPDFLibStringArray;
  I: Integer;
begin
  SetLength(arr, AItems.Count);
  for I := 0 to Length(arr) - 1 do
    arr[I] := AItems[I];

  Result := AddComboBox(AFieldName, ARect, arr, AItemIndex, AEditable, AReadOnly, AHidden);
end;

function TTMSFNCGeneralPDFLib.AddEdit(AFieldName: string; ARect: TRectF;
  AText: UnicodeString; AHorizontalAlign: TTMSFNCGraphicsTextAlign;
  AReadOnly: Boolean; AHidden: Boolean): ITMSFNCCustomPDFFormFieldEdit;
var
  t: TTMSFNCGeneralPDFLibFormFieldText;
  tC: TTMSFNCGeneralPDFLibFormFieldTextContent;
  mb, r: TRectF;
begin
  Result := nil;
  if Assigned(FActivePage) then
  begin
    mb := MediaBox;
    r := RectF(ARect.Left, mb.Bottom - mb.Top - ARect.Top, ARect.Right, mb.Bottom - mb.Top - ARect.Bottom);
    t := TTMSFNCGeneralPDFLibFormFieldText.Create(Self, AFieldName, r, AText, AHorizontalAlign, AReadOnly, AHidden);
    t.OnChanged := @FormTextFieldChanged;
    FXRefObjects.AddObject(t);
    FActivePage.Annotations.Add(t);

    if AText <> '' then
    begin
      tC := TTMSFNCGeneralPDFLibFormFieldTextContent.Create(Self, t);
      FXRefObjects.AddObject(tC);
    end;

    FormTextFieldChanged(t);
    Result := t;
  end;
end;

function TTMSFNCGeneralPDFLib.AddListBox(AFieldName: string; ARect: TRectF;
  AItems: TStrings; AItemIndex: Integer; AReadOnly,
  AHidden: Boolean): ITMSFNCCustomPDFFormFieldListBox;
var
  arr: TTMSFNCPDFLibStringArray;
  I: Integer;
begin
  SetLength(arr, AItems.Count);
  for I := 0 to Length(arr) - 1 do
    arr[I] := AItems[I];

  Result := AddListBox(AFieldName, ARect, arr, AItemIndex, AReadOnly, AHidden);
end;

procedure TTMSFNCGeneralPDFLib.AddCheckBox(AFieldName: string; ARect: TRectF;
  AIsChecked, AReadOnly, AHidden: Boolean);
var
  mb, r: TRectF;
  cb: TTMSFNCGeneralPDFLibFormFieldCheckBox;
  cbOn: TTMSFNCGeneralPDFLibFormFieldCheckBoxContent;
  cbOff: TTMSFNCGeneralPDFLibFormFieldCheckBoxContent;
begin
  if Assigned(FActivePage) then
  begin
    mb := MediaBox;
    r := RectF(ARect.Left, mb.Bottom - mb.Top - ARect.Top, ARect.Right, mb.Bottom - mb.Top - ARect.Bottom);
    cb := TTMSFNCGeneralPDFLibFormFieldCheckBox.Create(Self, AFieldName, r, AIsChecked, AReadOnly, AHidden);
    FXRefObjects.AddObject(cb);
    FActivePage.Annotations.Add(cb);

    cbOn := TTMSFNCGeneralPDFLibFormFieldCheckBoxContent.Create(Self, cb, True);
    FXRefObjects.AddObject(cbOn);

    cbOff := TTMSFNCGeneralPDFLibFormFieldCheckBoxContent.Create(Self, cb, False);
    FXRefObjects.AddObject(cbOff);
  end;
end;

function TTMSFNCGeneralPDFLib.AddComboBox(AFieldName: string; ARect: TRectF;
  AItems: TTMSFNCPDFLibStringArray; AItemIndex: Integer; AEditable, AReadOnly,
  AHidden: Boolean): ITMSFNCCustomPDFFormFieldComboBox;
var
  cb: TTMSFNCGeneralPDFLibFormFieldComboBox;
  cbC: TTMSFNCGeneralPDFLibFormFieldComboBoxContent;
  mb, r: TRectF;
begin
  Result := nil;
  if Assigned(FActivePage) then
  begin
    mb := MediaBox;
    r := RectF(ARect.Left, mb.Bottom - mb.Top - ARect.Top, ARect.Right, mb.Bottom - mb.Top - ARect.Bottom);
    cb := TTMSFNCGeneralPDFLibFormFieldComboBox.Create(Self, AFieldName, r, AItems, AItemIndex, AEditable, AReadOnly, AHidden);
    cb.OnChanged := @FormChoiceFieldChanged;
    FXRefObjects.AddObject(cb);
    FActivePage.Annotations.Add(cb);

    cbC := TTMSFNCGeneralPDFLibFormFieldComboBoxContent.Create(Self, cb);
    FXRefObjects.AddObject(cbC);

    FormChoiceFieldChanged(cb);
    Result := cb;
  end;
end;

function TTMSFNCGeneralPDFLib.AddListBox(AFieldName: string; ARect: TRectF;
  AItems: TTMSFNCPDFLibStringArray; AItemIndex: Integer; AReadOnly,
  AHidden: Boolean): ITMSFNCCustomPDFFormFieldListBox;
var
  lb: TTMSFNCGeneralPDFLibFormFieldListBox;
  lbC: TTMSFNCGeneralPDFLibFormFieldListBoxContent;
  mb, r: TRectF;
begin
  Result := nil;
  if Assigned(FActivePage) then
  begin
    mb := MediaBox;
    r := RectF(ARect.Left, mb.Bottom - mb.Top - ARect.Top, ARect.Right, mb.Bottom - mb.Top - ARect.Bottom);
    lb := TTMSFNCGeneralPDFLibFormFieldListBox.Create(Self, AFieldName, r, AItems, AItemIndex, AReadOnly, AHidden);
    lb.OnChanged := @FormChoiceFieldChanged;
    FXRefObjects.AddObject(lb);
    FActivePage.Annotations.Add(lb);

    lbC := TTMSFNCGeneralPDFLibFormFieldListBoxContent.Create(Self, lb);
    FXRefObjects.AddObject(lbC);

    FormChoiceFieldChanged(lb);
    Result := lb;
  end;
end;

function TTMSFNCGeneralPDFLib.AddMemo(AFieldName: string; ARect: TRectF;
  AHorizontalAlign: TTMSFNCGraphicsTextAlign; AReadOnly, AHidden: Boolean): ITMSFNCCustomPDFFormFieldEdit;
begin
  Result := AddMemo(AFieldName, ARect, '', AHorizontalAlign, AReadOnly, AHidden);
end;

function TTMSFNCGeneralPDFLib.AddMemo(AFieldName: string; ARect: TRectF;
  AText: UnicodeString; AHorizontalAlign: TTMSFNCGraphicsTextAlign;
  AReadOnly, AHidden: Boolean): ITMSFNCCustomPDFFormFieldEdit;
var
  t: TTMSFNCGeneralPDFLibFormFieldText;
  tC: TTMSFNCGeneralPDFLibFormFieldTextContent;
  mb, r: TRectF;
begin
  Result := nil;
  if Assigned(FActivePage) then
  begin
    mb := MediaBox;
    r := RectF(ARect.Left, mb.Bottom - mb.Top - ARect.Top, ARect.Right, mb.Bottom - mb.Top - ARect.Bottom);
    t := TTMSFNCGeneralPDFLibFormFieldText.Create(Self, AFieldName, r, AText, AHorizontalAlign, AReadOnly, AHidden);
    t.Multiline := True;
    t.OnChanged := @FormTextFieldChanged;
    FXRefObjects.AddObject(t);
    FActivePage.Annotations.Add(t);

    tC := TTMSFNCGeneralPDFLibFormFieldTextContent.Create(Self, t);
    FXRefObjects.AddObject(tC);

    FormTextFieldChanged(t);
    Result := t;
  end;
end;

function TTMSFNCGeneralPDFLib.AddPasswordEdit(AFieldName: string;
  ARect: TRectF; AHorizontalAlign: TTMSFNCGraphicsTextAlign; AReadOnly, AHidden: Boolean): ITMSFNCCustomPDFFormFieldEdit;
var
  t: TTMSFNCGeneralPDFLibFormFieldText;
  tC: TTMSFNCGeneralPDFLibFormFieldTextContent;
  mb, r: TRectF;
begin
  Result := nil;
  if Assigned(FActivePage) then
  begin
    FOutput.EscapeString('*');

    mb := MediaBox;
    r := RectF(ARect.Left, mb.Bottom - mb.Top - ARect.Top, ARect.Right, mb.Bottom - mb.Top - ARect.Bottom);
    t := TTMSFNCGeneralPDFLibFormFieldText.Create(Self, AFieldName, r, '', AHorizontalAlign, AReadOnly, AHidden);
    t.IsPassword := True;
    FXRefObjects.AddObject(t);
    FActivePage.Annotations.Add(t);

    tC := TTMSFNCGeneralPDFLibFormFieldTextContent.Create(Self, t);
    FXRefObjects.AddObject(tC);

    Result := t;
  end;
end;

procedure TTMSFNCGeneralPDFLib.AddRadioButton(AFieldName: string; ARect: TRecTF;
  AGroupID: string; AIsChecked, AReadOnly, AHidden: Boolean);
var
  mb, r: TRectF;
  rb: TTMSFNCGeneralPDFLibFormFieldRadioButton;
  rbOn: TTMSFNCGeneralPDFLibFormFieldRadioButtonContent;
  rbOff: TTMSFNCGeneralPDFLibFormFieldRadioButtonContent;
begin
  if Assigned(FActivePage) then
  begin
    mb := MediaBox;
    r := RectF(ARect.Left, mb.Bottom - mb.Top - ARect.Top, ARect.Right, mb.Bottom - mb.Top - ARect.Bottom);
    rb := TTMSFNCGeneralPDFLibFormFieldRadioButton.Create(Self, AFieldName, r, AGroupID, AIsChecked, AReadOnly, AHidden);
    FXRefObjects.AddObject(rb);
    FActivePage.Annotations.Add(rb);

    rbOn := TTMSFNCGeneralPDFLibFormFieldRadioButtonContent.Create(Self, rb, True);
    FXRefObjects.AddObject(rbOn);

    rbOff := TTMSFNCGeneralPDFLibFormFieldRadioButtonContent.Create(Self, rb, False);
    FXRefObjects.AddObject(rbOff);
  end;
end;

procedure TTMSFNCGeneralPDFLib.AddRadioGroup(AFieldName, AGroupID: string);
var
  rg: TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup;
begin
  if Assigned(FActivePage) then
  begin
    rg := TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup.Create(Self, AFieldName, AGroupID);
    FXRefObjects.AddObject(rg);
    FActivePage.Annotations.Add(rg);
  end;
end;

function TTMSFNCGeneralPDFLib.AddEdit(AFieldName: string; ARect: TRectF;
  AHorizontalAlign: TTMSFNCGraphicsTextAlign; AReadOnly, AHidden: Boolean): ITMSFNCCustomPDFFormFieldEdit;
begin
  Result := AddEdit(AFieldName, ARect, '', AHorizontalAlign, AReadOnly, AHidden);
end;

procedure TTMSFNCGeneralPDFLib.BeginDocument(FileName: String = '');
var
  r: TTMSFNCGeneralPDFLibXRefObject;
  d: TDateTime;
  dt, dtiso: string;
  ms: TStringStream;
  s: String;

  function EscapePdfLiteral(const S: string): string;
  var
    i: Integer;
    c: Char;
  begin
    Result := '';
    for i := 1 to Length(S) do
    begin
      c := S[i];
      case c of
        '\', '(', ')':
          Result := Result + '\' + c;
        #8:
          Result := Result + '\b';
        #9:
          Result := Result + '\t';
        #10:
          Result := Result + '\n';
        #12:
          Result := Result + '\f';
        #13:
          Result := Result + '\r';
      else
        Result := Result + c;
      end;
    end;
  end;

  function EscapeXml(const S: string): string;
  begin
    Result := StringReplace(S, '&', '&amp;', [rfReplaceAll]);
    Result := StringReplace(Result, '<', '&lt;', [rfReplaceAll]);
    Result := StringReplace(Result, '>', '&gt;', [rfReplaceAll]);
    Result := StringReplace(Result, '"', '&quot;', [rfReplaceAll]);
    Result := StringReplace(Result, '''', '&apos;', [rfReplaceAll]);
  end;

  function StringToPdfUtf16Hex(const S: string): string;
  var
    i: Integer;
    c: Word;
  begin
    Result := 'FEFF';
    for i := 1 to Length(S) do
    begin
      c := Ord(S[i]);
      Result := Result + FOutput.AddHex4(c);
    end;
  end;

  function PdfTextLiteralOrHex(const S: string): string;
  begin
    if FOutput.IsUnicodeString(S) then
      Result := '<' + StringToPdfUtf16Hex(S) + '>'
    else
      Result := '(' + EscapePdfLiteral(S) + ')';
  end;
begin
  FPDFFileName := FileName;
  ClearFontCache;
  FDocumentStarted := True;

  r := FXRefObjects.AddObject;
  r.XRefNumber := PDFMaxXref;
  FOutput.StartNewStream;

  case PDFStandard of
    pdfNone: FOutput.WriteString(PDFStart + PDFLB);
    pdfA1: FOutput.WriteString(PDFStart14 + PDFLB);
  end;

  r := FXRefObjects.AddObjectClass(TTMSFNCGeneralPDFLibCatalog);
  FOutput.StartNewStream(r);
  FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(r)) + ' 0 obj' + PDFLB);
  FOutput.WriteString('<<');
  FOutput.WriteString('/Type/Catalog');
  FOutput.WriteString('/Pages 2 0 R');
  case PDFStandard of
    pdfA1:
    begin
      FOutput.WriteString('/OutputIntents[3 0 R]');
      FOutput.WriteString('/MarkInfo <</Marked true>>/Metadata 5 0 R/StructTreeRoot<<>>');
    end;
  end;

  FOutput.WriteString('/AcroForm ' + PDFAcroFormRef + ' 0 R');
  FOutput.WriteString('>>' + PDFLB);
  FOutput.WriteString('endobj' + PDFLB);

  r := FXRefObjects.AddObjectClass(TTMSFNCGeneralPDFLibPages);
  FOutput.StartNewStream(r);
  FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(r)) +' 0 obj' + PDFLB);
  FOutput.WriteString('<<');
  FOutput.WriteString('/Type/Pages');
  FOutput.WriteString('/Kids['+PDFPageChildRef+']');
  FOutput.WriteString('/Count ' + PDFPageCountRef);
  FOutput.WriteString('>>' + PDFLB);
  FOutput.WriteString('endobj' + PDFLB);

  FAcroForm := TTMSFNCGeneralPDFLibAcroForm.Create(Self);
  r := FXRefObjects.AddObject(FAcroForm);
  FOutput.StartNewStream(r);
  FOutput.WriteString(PDFAcroFormRef + ' 0 obj' + PDFLB);
  FOutput.WriteString('<<');
  FOutput.WriteString('/NeedAppearances false/Fields['+PDFAcroFormFieldsRef+']/DR<</Font<<' + PDFAcroFormFontsRef + '>>>>');
  FOutput.WriteString('>>' + PDFLB);
  FOutput.WriteString('endobj' + PDFLB);

  d := Now;
  dt := ConvertToPDFDate(d);
  dtiso := DateTimeToIso(d);

  case PDFStandard of
    pdfA1:
    begin
      FOutputIntent := TTMSFNCGeneralPDFLibOutputIntent.Create(Self);
      r := FXRefObjects.AddObject(FOutputIntent);
      FOutput.StartNewStream(r);
      FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(r)) +' 0 obj' + PDFLB);
      FOutput.WriteString('<<');
      FOutput.WriteString('/Type/OutputIntent');
      FOutput.WriteString('/OutputCondition()');
      FOutput.WriteString('/OutputConditionIdentifier(sRGB)');
      FOutput.WriteString('/RegistryName(http://www.color.org)');
      FOutput.WriteString('/Info(sRGB IEC61966-2.1)');
      FOutput.WriteString('/S/GTS_PDFA1');
      FOutput.WriteString('/DestOutputProfile ' + PDFDestOutputProfileRef + ' 0 R');
      FOutput.WriteString('>>' + PDFLB);
      FOutput.WriteString('endobj' + PDFLB);

      FDestOutputProfile := TTMSFNCGeneralPDFLibDestOutputProfile.Create(Self);
      r := FXRefObjects.AddObject(FDestOutputProfile);
      FOutput.StartNewStream(r);
      FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(r)) +' 0 obj' + PDFLB);
      FOutput.WriteString('<<');
      FOutput.WriteString(PDFDestOutputProfileLengthRef);
      FOutput.WriteString('>>' + PDFLB);
      FOutput.WriteString('stream' + PDFLB);
      FOutput.StartContentStream(r);

      {$IFDEF WEBLIB}
      raise Exception.Create('Write ICC Array');
      {$ELSE}
      FOutput.Write(@ICC, SizeOf(ICC));
      {$ENDIF}

      ms := FOutput.FinishContentStream(PDFDestOutputProfileLengthRef, True, '/N 3');
      if Assigned(ms) then
        FOutput.Streams.Add(ms);

      FOutput.StartNewStream;
      FOutput.WriteString(PDFLB);
      FOutput.WriteString('endstream' + PDFLB);
      FOutput.WriteString('endobj' + PDFLB);

      FOutputIntent := TTMSFNCGeneralPDFLibOutputIntent.Create(Self);
      r := FXRefObjects.AddObject(FOutputIntent);
      FOutput.StartNewStream(r);
      FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(r)) +' 0 obj' + PDFLB);
      FOutput.WriteString('<<');

      s := Format(PDFMetaData, [EscapeXml(Producer), dtiso, dtiso, EscapeXml(Creator), EscapeXml(Title), EscapeXml(Author), EscapeXml(Subject), EscapeXml(Keywords.Text), EscapeXml(Producer)]);

      FOutput.WriteString('/Length '+IntToStr(Length(s))+'/Subtype/XML/Type/Metadata');
      FOutput.WriteString('>>' + PDFLB);
      FOutput.WriteString('stream' + PDFLB);
      FOutput.WriteString(s + PDFLB);
      FOutput.WriteString('endstream' + PDFLB);
      FOutput.WriteString('endobj' + PDFLB);
    end;
  end;

  FInfo := TTMSFNCGeneralPDFLibInfo.Create(Self);
  r := FXRefObjects.AddObject(FInfo);
  FOutput.StartNewStream(r);
  FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(r)) +' 0 obj' + PDFLB);
  FOutput.WriteString('<<');
  FOutput.WriteString('/Producer <>');
  FOutput.WriteString('/Author ' + PdfTextLiteralOrHex(Author));
  FOutput.WriteString('/CreationDate (D:'+dt+')');
  FOutput.WriteString('/Creator ' + PdfTextLiteralOrHex(Creator));
  FOutput.WriteString('/Keywords ' + PdfTextLiteralOrHex(GetKeywordsString));
  FOutput.WriteString('/Subject ' + PdfTextLiteralOrHex(Subject));
  FOutput.WriteString('/Title ' + PdfTextLiteralOrHex(Title));
  FOutput.WriteString('/ModDate (D:'+dt+')');
  FOutput.WriteString('>>' + PDFLB);
  FOutput.WriteString('endobj' + PDFLB);
end;

procedure TTMSFNCGeneralPDFLib.NewPage;
var
  ab, mb, bb, cb, tb: TRectF;
  r: TTMSFNCGeneralPDFLibXRefObject;
  cnt: TTMSFNCGeneralPDFLibContent;
begin
  mb := MediaBox;
  ab := ArtBox;
  bb := BleedBox;
  cb := CropBox;
  tb := TrimBox;

  if FPageStarted then
    UpdateGlyphIds;
  FinishPage;
  FActivePage := TTMSFNCGeneralPDFLibPage.Create(Self, FPageCount);
  r := FXRefObjects.AddObject(FActivePage);
  FOutput.StartNewStream(r);
  FOutput.WriteString(PDFPageRef + ' 0 obj' + PDFLB);
  FOutput.WriteString('<<');
  FOutput.WriteString('/Type/Page');
  FOutput.WriteString('/Parent 2 0 R');
  FOutput.WriteString('/MediaBox[' + IntToStr(Round(mb.Left))+ ' '+IntToStr(Round(mb.Top)) + ' ' + IntToStr(Round(mb.Right)) + ' ' + IntToStr(Round(mb.Bottom)) + ']');
  FOutput.WriteString('/ArtBox[' + IntToStr(Round(ab.Left))+ ' '+IntToStr(Round(ab.Top)) + ' ' + IntToStr(Round(ab.Right)) + ' ' + IntToStr(Round(ab.Bottom)) + ']');
  FOutput.WriteString('/BleedBox[' + IntToStr(Round(bb.Left))+ ' '+IntToStr(Round(bb.Top)) + ' ' + IntToStr(Round(bb.Right)) + ' ' + IntToStr(Round(bb.Bottom)) + ']');
  FOutput.WriteString('/CropBox[' + IntToStr(Round(cb.Left))+ ' '+IntToStr(Round(cb.Top)) + ' ' + IntToStr(Round(cb.Right)) + ' ' + IntToStr(Round(cb.Bottom)) + ']');
  FOutput.WriteString('/Trimbox[' + IntToStr(Round(tb.Left))+ ' '+IntToStr(Round(tb.Top)) + ' ' + IntToStr(Round(tb.Right)) + ' ' + IntToStr(Round(tb.Bottom)) + ']');
  FOutput.WriteString('/Contents ' + PDFPageContentRef +' 0 R');
  FOutput.WriteString('/ProcSet[/PDF/Text/ImageC]');
  FOutput.WriteString('/Annots['+PDFPageAnnotationsRef+']');
  FOutput.WriteString('/Resources');
  FOutput.WriteString('<<');
  FOutput.WriteString('/XObject');
  FOutput.WriteString('<<');
  FOutput.WriteString(PDFPageXObjectRef);
  FOutput.WriteString('>>');
  FOutput.WriteString('/Font');
  FOutput.WriteString('<<');
  FOutput.WriteString(PDFPageFontRef);
  FOutput.WriteString('>>');
  FOutput.WriteString('/Pattern');
  FOutput.WriteString('<<');
  FOutput.WriteString(PDFPagePatternRef);
  FOutput.WriteString('>>');
  FOutput.WriteString('>>');
  FOutput.WriteString('>>' + PDFLB);
  FOutput.WriteString('endobj' + PDFLB);

  UpdateFontList(False);

  cnt := TTMSFNCGeneralPDFLibContent.Create(Self);
  cnt.Page := FActivePage;
  r := FXRefObjects.AddObject(cnt);
  FActivePage.Content := cnt;
  FOutput.StartNewStream(r);
  FOutput.WriteString(PDFPageContentRef + ' 0 obj' + PDFLB);
  FOutput.WriteString('<<');
  FOutput.WriteString(PDFPageContentLengthRef);
  FOutput.WriteString('>>' + PDFLB);
  FOutput.WriteString('stream' + PDFLB);
  FOutput.StartContentStream(r);

  if Assigned(FPDFInitializationLib) then
  begin
    FPDFInitializationLib.SetCanvas(FOutput);
    FPDFInitializationLib.SetPageWidth(mb.Right - mb.Left);
    FPDFInitializationLib.SetPageHeight(mb.Bottom - mb.Top);
    FPDFInitializationLib.InitializeAppearance;
  end;

  DoNewPageStarted(GetPageIndex);

  DrawHeader;
  DrawFooter;
  DrawPageNumber;

  Inc(FPageCount);
  FPageStarted := True;
end;

procedure TTMSFNCGeneralPDFLib.NotifyBitmap(Sender: TObject; AValue: TTMSFNCBitmapHelperClass; AImageType: TTMSFNCPDFGraphicsLibImageType; AQuality: Single; ABackgroundColor: TTMSFNCGraphicsColor; var ABitmapReference: string);
var
  bmp, bmpc: TTMSFNCGeneralPDFLibBitmap;
  ms: TMemoryStream;
  {$IFDEF WEBLIB}
  v: JSValue;
  s: string;
  {$ENDIF}
  x: TTMSFNCGeneralPDFLibXRefObject;

  {$IFDEF WEBLIB}
  function GetBase64Image(AImage: TJSHTMLElement; AQL: Single; AC: TTMSFNCGraphicsColor): string;
  var
    s: string;
    m: TJSHTMLElement;
    qt: Single;
    c: string;
  begin
    s := '';
    m := AImage;
    qt := AQL;
    c := TTMSFNCGraphics.ColorToHTML(AC);

    asm
      function getBase64Image(img, q, ct) {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = ct;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/jpeg", q);
        return dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
      }
      s = getBase64Image(m, qt, c);
    end;
    Result := s;
  end;
  {$ENDIF}

begin
  if Assigned(FActivePage) and Assigned(AValue) then
  begin
    ms := TMemoryStream.Create;
    try
      {$IFDEF WEBLIB}
      s := GetBase64Image(TJSHTMLElement(AValue.Image), AQuality, ABackgroundColor);
      asm
        var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        if (base64regex.test(s)) {
          var binary_string = window.atob(s);
          var len = binary_string.length;
          var bytes = new Uint8Array( len );
          for (var i = 0; i < len; i++)        {
              bytes[i] = binary_string.charCodeAt(i);
          }
          ms.Write(bytes, bytes.length);
        }
      end;
      {$ELSE}
      AValue.SaveToStream(ms);
      {$ENDIF}
      bmp := nil;
      {$IFDEF WEBLIB}
      for v in FXRefObjects do
      begin
        x := TTMSFNCGeneralPDFLibXRefObject(v);
      {$ELSE}
      for x in FXRefObjects do
      begin
      {$ENDIF}
        if Assigned(x.XRefObject) and (x.XRefObject is TTMSFNCGeneralPDFLibBitmap) then
        begin
          bmpc := x.XRefObject as TTMSFNCGeneralPDFLibBitmap;
          if Assigned(bmpc.Stream) and (AQuality = bmpc.Quality) and (ABackgroundColor = bmpc.BackgroundColor) and CompareStreams(bmpc.Stream, ms) then
          begin
            bmp := bmpc;
            Break;
          end;
        end;
      end;

      if not Assigned(bmp) then
      begin
        bmp := TTMSFNCGeneralPDFLibBitmap.Create(Self, AValue, ms, AImageType, AQuality, ABackgroundColor);
        FXRefObjects.AddObject(bmp);
      end;

      if FActivePage.Bitmaps.IndexOf(bmp) < 0 then
        FActivePage.Bitmaps.Add(bmp);

      if FActivePage.XObjectList.IndexOf(bmp) < 0 then
        FActivePage.XObjectList.Add(bmp);

      ABitmapReference := Format(PDFPageBitmapObjectRef, [bmp.RefNameNotEscaped]);
      bmp.RefNameOriginal := ABitmapReference;
    finally
      ms.Free;
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.NotifyShading(Sender: TObject; AFillColor: TTMSFNCGraphicsColor; AFillColorTo: TTMSFNCGraphicsColor; AFillOrientation: TTMSFNCGraphicsFillOrientation; var AShadingReference: string);
var
  lg: TTMSFNCGeneralPDFLibLinearGradient;
  f: TTMSFNCGeneralPDFLibShadingFunction;
  sf: TTMSFNCGeneralPDFLibShadingSubFunction;
  p: TTMSFNCGeneralPDFLibPattern;
begin
  if Assigned(FActivePage) then
  begin
    lg := TTMSFNCGeneralPDFLibLinearGradient.Create(Self, AFillOrientation);
    FXRefObjects.AddObject(lg);
    f := TTMSFNCGeneralPDFLibShadingFunction.Create(Self);
    FXRefObjects.AddObject(f);
    lg.&Function := f;

    sf := TTMSFNCGeneralPDFLibShadingSubFunction.Create(Self, AFillColor, AFillColorTo);
    FXRefObjects.AddObject(sf);
    f.SubFunctions.Add(sf);

    sf := TTMSFNCGeneralPDFLibShadingSubFunction.Create(Self, AFillColor, AFillColorTo);
    FXRefObjects.AddObject(sf);
    f.SubFunctions.Add(sf);

    FActivePage.Shadings.Add(lg);

    p := TTMSFNCGeneralPDFLibPattern.Create(Self);
    p.Shading := lg;
    FXRefObjects.AddObject(p);
    FActivePage.Patterns.Add(p);

    AShadingReference := Format(PDFPageShadingObjectRef, [p.RefNameNotEscaped]);
    p.RefNameOriginal := AShadingReference;

    FActiveShading := lg;
  end;
end;

procedure TTMSFNCGeneralPDFLib.NotifyShadingRect(Sender: TObject;
  ARect: TRectF);
begin
  if Assigned(FActiveShading) then
    FActiveShading.Rect := ARect;
end;

procedure TTMSFNCGeneralPDFLib.NotifyText(Sender: TObject;
  AValue: UnicodeString);
begin
  UpdateFontList(ShouldUseUnicodeFontForText(AValue));
end;

procedure TTMSFNCGeneralPDFLib.NotifyUnicode(Sender: TObject; AValue: UnicodeString);
var
  I, v: Integer;
  vu: Boolean;
  fnff, fns, fn: string;
  cr: Boolean;
begin
  if Assigned(FOutput) and Assigned(FActiveFont) then
  begin
    fnff := FActiveFont.Base;
    for fnff in FontFallBackList do
    begin
      if not Assigned(FActiveFont) then
        Break;
      cr := (FActiveFont.UsedCharArray.Count = 0);
      vu := True;
      {$IFDEF ZEROSTRINGINDEX}
      for I := 0 to Length(AValue) - 1 do
      {$ENDIF}
      {$IFNDEF ZEROSTRINGINDEX}
      for I := 1 to Length(AValue) do
      {$ENDIF}
      begin
        v := Ord(AValue[I]);
        if (v >= 32) and (FActiveFont.CharArray.IndexOf(v) < 0) then
        begin
          vu := False;
          Break;
        end;
      end;

      if not vu then
      begin
        if cr then
        begin
          FActiveFont.Inactive := True;
          RemoveCachedFont(FActiveFont);
          FActiveFont := nil;
        end;

        fns := fnff;
        {$IFDEF WEBLIB}
        if not Assigned(FInitializer) or not FInitializer.IsFontAvailable(fns) then
          Continue;
        {$ELSE}
        if FOSFontList.IndexOf(fns) = -1 then
          Continue;
        {$ENDIF}
        FBlockFontUpdate := True;
        FPDFGraphicsLib.Font.Name := fns;
        FBlockFontUpdate := False;
        UpdateFontList(True);
      end
      else
        Break;
    end;

    if Assigned(FActiveFont) and not FActiveFont.Unicode then
    begin
      fn := FActiveFont.Base;
      cr := (FActiveFont.UsedCharArray.Count = 0);
      if cr then
      begin
        FActiveFont.Inactive := True;
        RemoveCachedFont(FActiveFont);
        FActiveFont := nil;
      end;

      FBlockFontUpdate := True;
      FPDFGraphicsLib.Font.Name := VerifyFontName(fn);
      FBlockFontUpdate := False;
      UpdateFontList(True);
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.NotifyURL(Sender: TObject; ARect: TRectF; AURL: UnicodeString);
var
  u: TTMSFNCGeneralPDFLibURL;
begin
  if Assigned(FActivePage) then
  begin
    u := TTMSFNCGeneralPDFLibURL.Create(Self, ARect, AURL);
    FXRefObjects.AddObject(u);
    FActivePage.Annotations.Add(u);
  end;
end;

procedure TTMSFNCGeneralPDFLib.NotifyGoTo2(Sender: TObject; ARect: TRectF; APageIndex: Integer; AOptions: UnicodeString);
var
  u: TTMSFNCGeneralPDFLibGoTo2;
begin
  if Assigned(FActivePage) then
  begin
    u := TTMSFNCGeneralPDFLibGoTo2.Create(Self, ARect, APageIndex, AOptions);
    FXRefObjects.AddObject(u);
    FActivePage.Annotations.Add(u);
  end;
end;

procedure TTMSFNCGeneralPDFLib.NotifyGoTo(Sender: TObject; ARect: TRectF; ADestination: UnicodeString);
var
  u: TTMSFNCGeneralPDFLibGoTo;
begin
  if Assigned(FActivePage) then
  begin
    u := TTMSFNCGeneralPDFLibGoTo.Create(Self, ARect, ADestination);
    FXRefObjects.AddObject(u);
    FActivePage.Annotations.Add(u);
  end;
end;

procedure TTMSFNCGeneralPDFLib.OpenDocument(FileStream: TMemoryStream);
begin
  if IsDocumentOpened then
    CloseDocument;
end;

procedure TTMSFNCGeneralPDFLib.OpenDocument(FileName: String);
begin
  if IsDocumentOpened then
    CloseDocument;
end;

procedure TTMSFNCGeneralPDFLib.CleanUpUnusedFonts;
var
  I: Integer;
  ft: TTMSFNCGeneralPDFLibFont;
  cr: Boolean;
begin
  for I := FFontList.Count - 1 downto 0 do
  begin
    ft := FFontList[I];
    cr := ft.Inactive and (ft.UsedCharArray.Count = 0);
    if cr then
      DestroyFont(ft);
  end;
end;

procedure TTMSFNCGeneralPDFLib.CloseDocument;
begin
end;

function TTMSFNCGeneralPDFLib.CompareStreams(AStream1, AStream2: TMemoryStream): Boolean;
const
  Block_Size = 4096;
var
  {$IFDEF WEBLIB}
  Buffer_1: TBytes;
  Buffer_2: TBytes;
  {$ELSE}
  Buffer_1: array[0..Block_Size-1] of byte;
  Buffer_2: array[0..Block_Size-1] of byte;
  {$ENDIF}
  Buffer_Length: integer;
begin
  Result := False;

  AStream1.Position := 0;
  AStream2.Position := 0;

  if AStream1.Size <> AStream2.Size then
    Exit;

  while AStream1.Position < AStream1.Size do
  begin
    Buffer_Length := AStream1.Read({%H-}Buffer_1, Block_Size);
    AStream2.Read({%H-}Buffer_2, Block_Size);

    {$IFDEF WEBLIB}
    if not (Buffer_1 = Buffer_2) then
      Exit;
    {$ELSE}
    if not CompareMem(@Buffer_1, @Buffer_2, Buffer_Length) then
      Exit;
    {$ENDIF}
  end;

  Result := True;
end;

constructor TTMSFNCGeneralPDFLib.Create;
var
  r: TRectF;
begin
  inherited;
  {$IFNDEF LCLWEBLIB}
  FComparePageNumbers := TDelegatedComparer<TTMSFNCGeneralPDFLibPage>.Create(
    function(const Item1, Item2: TTMSFNCGeneralPDFLibPage): Integer
    begin
      Result := CompareValue(Item1.InsertPageNumber, Item2.InsertPageNumber);
    end
    );
  {$ENDIF}

  FPageHeight := 0;
  FPageWidth := 0;
  FFontFallBackList := TStringList.Create;
  FOSFontList := TStringList.Create;
  FOSFontList.CaseSensitive := False;
  TTMSFNCUtils.GetFonts(FOSFontList);
  FEmbedFonts := True;
  FInitializer := TTMSFNCGeneralPDFLibInitializer.Create;
  FInitializer.InitializeFontFallBackList(FFontFallBackList);
  FPageCount := 0;
  FOutput := TTMSFNCPDFGraphicsLibOutputWriter.Create;
  FOutput.OnFontChanged := @FontChanged;
  FOutput.OnNotifyURL := @NotifyURL;
  FOutput.OnNotifyGoTo := @NotifyGoTo;
  FOutput.OnNotifyGoTo2 := @NotifyGoTo2;
  FOutput.OnNotifyText := @NotifyText;
  FOutput.OnNotifyUnicode := @NotifyUnicode;
  FOutput.OnNotifyBitmap := @NotifyBitmap;
  FOutput.OnNotifyShading := @NotifyShading;
  FOutput.OnNotifyShadingRect := @NotifyShadingRect;
  FXRefObjects := TTMSFNCGeneralPDFLibXRefObjects.Create;
  FFontList := TTMSFNCGeneralPDFLibFonts.Create;
  FFontLookupCache := TStringList.Create;
  FFontLookupCache.Sorted := True;
  FFontLookupCache.CaseSensitive := True;
  FFontLookupCache.Duplicates := dupIgnore;
  FMediaBox := DefaultMediaBox;
  FCropBox := DefaultMediaBox;
  FTrimBox := DefaultMediaBox;
  FArtBox := DefaultMediaBox;
  FBleedBox := DefaultMediaBox;
  FPageOrientation := poPortrait;
  FPageSize := psLetter;
  FKeywords := TStringList.Create;
  FAllowsPrinting := True;
  FAllowsCopying := True;
  FPDFStandard := pdfNone;
  FFormFieldGlobalAutoSize := False;
  FFormFieldGlobalFont := TTMSFNCPDFGraphicsLibFont.Create;

  FHeader := 'Header';
  FHeaderSize := 30;
  r := RectF(5, 5, 5, 5);
  FHeaderMargins := TTMSFNCMargins.Create(r);
  FHeaderAlignment := gtaCenter;
  FHeaderFont := TTMSFNCPDFGraphicsLibFont.Create;

  FFooter := 'Footer';
  FFooterSize := 30;
  r := RectF(5, 5, 5, 5);
  FFooterMargins := TTMSFNCMargins.Create(r);
  FFooterAlignment := gtaCenter;
  FFooterFont := TTMSFNCPDFGraphicsLibFont.Create;

  FPageNumber := pnNone;
  FPageNumberFormat := '%d';
  FPageNumberSize := 30;
  r := RectF(5, 5, 5, 5);
  FPageNumberMargins := TTMSFNCMargins.Create(r);
  FPageNumberAlignment := gtaTrailing;
  FPageNumberFont := TTMSFNCPDFGraphicsLibFont.Create;
end;

destructor TTMSFNCGeneralPDFLib.Destroy;
begin                    
  FAcroForm := nil;
  FOutputIntent := nil;

  if Assigned(FFormFieldGlobalFont) then
  begin
    FFormFieldGlobalFont.Free;
    FFormFieldGlobalFont := nil;
  end;

  if Assigned(FFontFallBackList) then
  begin
    FFontFallBackList.Free;
    FFontFallBackList := nil;
  end;

  if Assigned(FOSFontList) then
  begin
    FOSFontList.Free;
    FOSFontList := nil;
  end;

  if Assigned(FInitializer) then
  begin
    FInitializer.Free;
    FInitializer := nil;
  end;

  if Assigned(FFontLookupCache) then
  begin
    FFontLookupCache.Free;
    FFontLookupCache := nil;
  end;

  if Assigned(FFontList) then
  begin
    FFontList.Free;
    FFontList := nil;
  end;

  if Assigned(FXRefObjects) then
  begin
    FXRefObjects.Free;
    FXRefObjects := nil;
  end;

  if Assigned(FOutput) then
  begin
    FOutput.Free;
    FOutput := nil;
  end;

  if Assigned(FFooterMargins) then
  begin
    FFooterMargins.Free;
    FFooterMargins := nil;
  end;

  if Assigned(FHeaderMargins) then
  begin
    FHeaderMargins.Free;
    FHeaderMargins := nil;
  end;

  if Assigned(FPageNumberMargins) then
  begin
    FPageNumberMargins.Free;
    FPageNumberMargins := nil;
  end;

  if Assigned(FKeywords) then
  begin
    FKeywords.Free;
    FKeywords := nil;
  end;

  if Assigned(FHeaderFont) then
  begin
    FHeaderFont.Free;
    FHeaderFont := nil;
  end;

  if Assigned(FPageNumberFont) then
  begin
    FPageNumberFont.Free;
    FPageNumberFont := nil;
  end;

  if Assigned(FFooterFont) then
  begin
    FFooterFont.Free;
    FFooterFont := nil;
  end;

  inherited;
end;

procedure TTMSFNCGeneralPDFLib.DestroyFont(AFont: TTMSFNCGeneralPDFLibFont);
var
  I: Integer;
  ftd: TTMSFNCGeneralPDFLibFontDescriptor;
  ftds: TTMSFNCGeneralPDFLibFontDescendant;
  ftff: TTMSFNCGeneralPDFLibFontFile;
  ftu: TTMSFNCGeneralPDFLibFontUnicode;
  x: TTMSFNCGeneralPDFLibXRefObject;
  pg: TTMSFNCGeneralPDFLibPage;
begin
  if Assigned(AFont) then
  begin
    RemoveCachedFont(AFont);
    FFontList.Remove(AFont);
    ftd := AFont.FontDescriptor;
    ftds := AFont.FontDescendant;
    ftff := AFont.FontFile;
    ftu := AFont.FontUnicode;

    for I := 0 to FXRefObjects.Count - 1 do
    begin
      x := FXRefObjects[I];
      if Assigned(x.XRefObject) and (x.XRefObject is TTMSFNCGeneralPDFLibPage) then
      begin
        pg := x.XRefObject as TTMSFNCGeneralPDFLibPage;
        pg.FontList.Remove(AFont);
      end;
    end;

    for I := FXRefObjects.Count - 1 downto 0 do
    begin
      x := FXRefObjects[I];
      if Assigned(x.XRefObject) and (x.XRefObject = ftd) then
        FXRefObjects.Delete(I)
      else if Assigned(x.XRefObject) and (x.XRefObject = ftds) then
        FXRefObjects.Delete(I)
      else if Assigned(x.XRefObject) and (x.XRefObject = ftff) then
        FXRefObjects.Delete(I)
      else if Assigned(x.XRefObject) and (x.XRefObject = ftu) then
        FXRefObjects.Delete(I)
      else if Assigned(x.XRefObject) and (x.XRefObject = AFont) then
        FXRefObjects.Delete(I)
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.DoAfterDrawFooter(Sender: TObject;
  APageIndex: Integer; AFooter: UnicodeString; ARect: TRectF;
  AGraphics: ITMSFNCCustomPDFGraphicsLib);
begin
  if Assigned(OnAfterDrawFooter) then
    OnAfterDrawFooter(Self, APageIndex, AFooter, ARect, AGraphics);
end;

procedure TTMSFNCGeneralPDFLib.DoAfterDrawHeader(Sender: TObject;
  APageIndex: Integer; AHeader: UnicodeString; ARect: TRectF;
  AGraphics: ITMSFNCCustomPDFGraphicsLib);
begin
  if Assigned(OnAfterDrawHeader) then
    OnAfterDrawHeader(Self, APageIndex, AHeader, ARect, AGraphics);
end;

procedure TTMSFNCGeneralPDFLib.DoAfterDrawPageNumber(Sender: TObject;
  APageIndex: Integer; APageNumber: UnicodeString; ARect: TRectF;
  AGraphics: ITMSFNCCustomPDFGraphicsLib);
begin
  if Assigned(OnAfterDrawPageNumber) then
    OnAfterDrawPageNumber(Self, APageIndex, APageNumber, ARect, AGraphics);
end;

procedure TTMSFNCGeneralPDFLib.DoBeforeDrawFooter(Sender: TObject;
  APageIndex: Integer; AFooter: UnicodeString; ARect: TRectF;
  AGraphics: ITMSFNCCustomPDFGraphicsLib; var ADefaultDraw: Boolean);
begin
  if Assigned(OnBeforeDrawFooter) then
    OnBeforeDrawFooter(Self, APageIndex, AFooter, ARect, AGraphics, ADefaultDraw);
end;

procedure TTMSFNCGeneralPDFLib.DoBeforeDrawHeader(Sender: TObject;
  APageIndex: Integer; AHeader: UnicodeString; ARect: TRectF;
  AGraphics: ITMSFNCCustomPDFGraphicsLib; var ADefaultDraw: Boolean);
begin
  if Assigned(OnBeforeDrawHeader) then
    OnBeforeDrawHeader(Self, APageIndex, AHeader, ARect, AGraphics, ADefaultDraw);
end;

procedure TTMSFNCGeneralPDFLib.DoBeforeDrawPageNumber(Sender: TObject;
  APageIndex: Integer; APageNumber: UnicodeString; ARect: TRectF;
  AGraphics: ITMSFNCCustomPDFGraphicsLib; var ADefaultDraw: Boolean);
begin
  if Assigned(OnBeforeDrawPageNumber) then
    OnBeforeDrawPageNumber(Self, APageIndex, APageNumber, ARect, AGraphics, ADefaultDraw);
end;

procedure TTMSFNCGeneralPDFLib.DoNewPageStarted(APageIndex: Integer);
begin
  if Assigned(OnNewPageStarted) then
    OnNewPageStarted(Self, APageIndex);
end;

procedure TTMSFNCGeneralPDFLib.DrawFooter;
var
  al: TTMSFNCGraphicsTextAlign;
  ft: TTMSFNCPDFGraphicsLibFont;
  sz: TSizeF;
  r, rc: TRectF;
  df: Boolean;
begin
  if not Assigned(FPDFGraphicsLib) then
    Exit;

  al := FPDFGraphicsLib.Alignment;
  ft := TTMSFNCPDFGraphicsLibFont.Create;
  ft.Assign(FPDFGraphicsLib.Font);
  FPDFGraphicsLib.Alignment := FooterAlignment;
  FPDFGraphicsLib.Font.Assign(FooterFont);
  r := GetFooterRect;

  df := True;
  DoBeforeDrawFooter(Self, GetPageIndex, Footer, r, FPDFGraphicsLib, df);
  if df then
  begin
    if TTMSFNCUtils.IsHTMLUnicode(Footer) then
    begin
      rc := FPDFGraphicsLib.DrawHTMLText(Footer, r, False, 1, True);
      sz.cx := rc.Right - rc.Left;
      sz.cy := rc.Bottom - rc.Top;
      FPDFGraphicsLib.DrawHTMLText(Footer, RectF(R.Left, R.Top + (r.Bottom - r.Top - sz.cy) / 2, r.Left + (r.Right - r.Left), (R.Top + (r.Bottom - r.Top - sz.cy) / 2) + sz.cy));
    end
    else
    begin
      rc := FPDFGraphicsLib.DrawText(Footer, r, True);
      sz.cx := rc.Right - rc.Left;
      sz.cy := rc.Bottom - rc.Top;
      FPDFGraphicsLib.DrawText(Footer, RectF(R.Left, R.Top + (r.Bottom - r.Top - sz.cy) / 2, r.Left + (r.Right - r.Left), (R.Top + (r.Bottom - r.Top - sz.cy) / 2) + sz.cy
      ));
    end;

    DoAfterDrawFooter(Self, GetPageIndex, Footer, r, FPDFGraphicsLib);
  end;

  FPDFGraphicsLib.Alignment := al;
  FPDFGraphicsLib.Font.Assign(ft);
  ft.Free;
end;

procedure TTMSFNCGeneralPDFLib.DrawHeader;
var
  al: TTMSFNCGraphicsTextAlign;
  ft: TTMSFNCPDFGraphicsLibFont;
  sz: TSizeF;
  r, rc: TRectF;
  df: Boolean;
begin
  if not Assigned(FPDFGraphicsLib) then
    Exit;

  al := FPDFGraphicsLib.Alignment;
  ft := TTMSFNCPDFGraphicsLibFont.Create;
  ft.Assign(FPDFGraphicsLib.Font);
  FPDFGraphicsLib.Alignment := HeaderAlignment;
  FPDFGraphicsLib.Font.Assign(HeaderFont);
  r := GetHeaderRect;

  df := True;
  DoBeforeDrawHeader(Self, GetPageIndex, Header, r, FPDFGraphicsLib, df);
  if df then
  begin
    if TTMSFNCUtils.IsHTMLUnicode(Header) then
    begin
      rc := FPDFGraphicsLib.DrawHTMLText(Header, r, False, 1, True);
      sz.cx := rc.Right - rc.Left;
      sz.cy := rc.Bottom - rc.Top;
      FPDFGraphicsLib.DrawHTMLText(Header, RectF(R.Left, R.Top + (r.Bottom - r.Top - sz.cy) / 2, r.Left + (r.Right - r.Left), (R.Top + (r.Bottom - r.Top - sz.cy) / 2) + sz.cy));
    end
    else
    begin
      rc := FPDFGraphicsLib.DrawText(Header, r, True);
      sz.cx := rc.Right - rc.Left;
      sz.cy := rc.Bottom - rc.Top;
      FPDFGraphicsLib.DrawText(Header, RectF(R.Left, R.Top + (r.Bottom - r.Top - sz.cy) / 2, r.Left + (r.Right - r.Left), (R.Top + (r.Bottom - r.Top - sz.cy) / 2) + sz.cy));
    end;

    DoAfterDrawHeader(Self, GetPageIndex, Header, r, FPDFGraphicsLib);
  end;

  FPDFGraphicsLib.Alignment := al;
  FPDFGraphicsLib.Font.Assign(ft);
  ft.Free;
end;

procedure TTMSFNCGeneralPDFLib.DrawPageNumber;
var
  al: TTMSFNCGraphicsTextAlign;
  ft: TTMSFNCPDFGraphicsLibFont;
  sz: TSizeF;
  r, rc: TRectF;
  df: Boolean;
  s: UnicodeString;
begin
  if not Assigned(FPDFGraphicsLib) or (PageNumber = pnNone) then
    Exit;

  al := FPDFGraphicsLib.Alignment;
  ft := TTMSFNCPDFGraphicsLibFont.Create;
  ft.Assign(FPDFGraphicsLib.Font);
  FPDFGraphicsLib.Alignment := PageNumberAlignment;
  FPDFGraphicsLib.Font.Assign(PageNumberFont);
  r := GetPageNumberRect;

  df := True;
  {$IFDEF LCLLIB}
  s := UTF8Decode(Format(UTF8Encode(PageNumberFormat), [GetPageIndex + 1]));
  {$ENDIF}
  {$IFNDEF LCLLIB}
  s := Format(PageNumberFormat, [GetPageIndex + 1]);
  {$ENDIF}
  DoBeforeDrawPageNumber(Self, GetPageIndex, s, r, FPDFGraphicsLib, df);
  if df then
  begin
    if TTMSFNCUtils.IsHTMLUnicode(s) then
    begin
      rc := FPDFGraphicsLib.DrawHTMLText(s, r, False, 1, True);
      sz.cx := rc.Right - rc.Left;
      sz.cy := rc.Bottom - rc.Top;
      FPDFGraphicsLib.DrawHTMLText(s, RectF(R.Left, R.Top + (r.Bottom - r.Top - sz.cy) / 2, r.Left + (r.Right - r.Left), (R.Top + (r.Bottom - r.Top - sz.cy) / 2) + sz.cy));
    end
    else
    begin
      rc := FPDFGraphicsLib.DrawText(s, r, True);
      sz.cx := rc.Right - rc.Left;
      sz.cy := rc.Bottom - rc.Top;
      FPDFGraphicsLib.DrawText(s, RectF(R.Left, R.Top + (r.Bottom - r.Top - sz.cy) / 2, r.Left + ((r.Right - r.Left) - r.Left), (R.Top + (r.Bottom - r.Top - sz.cy) / 2) + sz.cy));
    end;

    DoAfterDrawPageNumber(Self, GetPageIndex, s, r, FPDFGraphicsLib);
  end;

  FPDFGraphicsLib.Alignment := al;
  FPDFGraphicsLib.Font.Assign(ft);
  ft.Free;
end;

procedure TTMSFNCGeneralPDFLib.DrawPage(PageIndex: Integer);
begin
end;

function TTMSFNCGeneralPDFLib.EndDocument(AOpenInPDFReader: Boolean = False): TMemoryStream;
var
  ms: TMemoryStream;
  I: Integer;
  st: TStream;
  gt2: TTMSFNCGeneralPDFLibGoTo2;
  sts: TTMSFNCPDFGraphicsLibOutputWriterStream;
  x: TTMSFNCGeneralPDFLibXRefObject;
  pg: TTMSFNCGeneralPDFLibPage;
  fid: array[0..3] of UInt32;
  IDs: UnicodeString;
  P: PChar;
begin
  Result := nil;
  if FDocumentStarted then
  begin
    InitializeFontList;
    UpdateGlyphIds;
    FinishPage;
    WriteFontList;
    WriteBitmapList;
    WriteAnnotationList;
    WriteFormXObjects;
    WriteShadingList;
    WritePatternList;

    for I := 0 to FOutput.Streams.Count - 1 do
    begin
      st := TStream(FOutput.Streams[I]);
      st.Position := 0;
      if st is TTMSFNCPDFGraphicsLibOutputWriterStream then
      begin
        sts := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
        if Assigned(sts.Reference) and (sts.Reference is TTMSFNCGeneralPDFLibXRefObject) then
        begin
          x := sts.Reference as TTMSFNCGeneralPDFLibXRefObject;
          if x.XRefObject is TTMSFNCGeneralPDFLibPages then
          begin
            FOutput.Stream := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
            FOutput.ReplaceStrings([PDFPageChildRef, PDFPageCountRef], [GetPageReferences, IntToStr(FPageCount)]);
          end
          else if x.XRefObject is TTMSFNCGeneralPDFLibOutputIntent then
          begin
            FOutput.Stream := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
            FOutput.ReplaceStrings([PDFDestOutputProfileRef], [GetDestOutputProfileRef]);
          end
          else if x.XRefObject is TTMSFNCGeneralPDFLibGoTo2 then
          begin
            gt2 := (x.XRefObject as TTMSFNCGeneralPDFLibGoTo2);
            FOutput.Stream := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
            FOutput.ReplaceStrings([PDFPageGoToRef], [GetPageRef(GetPageByIndex(gt2.PageIndex))]);
          end
          else if x.XRefObject is TTMSFNCGeneralPDFLibCatalog then
          begin
            FOutput.Stream := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
            FOutput.ReplaceStrings([PDFAcroFormRef], [GetAcroFormRef]);
          end
          else if x.XRefObject is TTMSFNCGeneralPDFLibPage then
          begin
            pg := x.XRefObject as TTMSFNCGeneralPDFLibPage;
            FOutput.Stream := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
            FOutput.ReplaceStrings([PDFPageFontRef, PDFPageXObjectRef, PDFPageContentRef, PDFPagePatternRef, PDFPageRef, PDFPageAnnotationsRef],
              [GetFontRefs(pg), GetXObjectRefs(pg), GetContentRef(pg), GetPatternRef(pg), GetPageRef(pg), GetAnnotationsRef(pg)]);
          end
          else if x.XRefObject is TTMSFNCGeneralPDFLibContent then
          begin
            pg := (x.XRefObject as TTMSFNCGeneralPDFLibContent).Page;
            FOutput.Stream := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
            FOutput.ReplaceStrings([PDFPageContentRef], [GetContentRef(pg)]);
          end
          else if x.XRefObject is TTMSFNCGeneralPDFLibAcroForm then
          begin
            FOutput.Stream := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
            FOutput.ReplaceStrings([PDFAcroFormRef, PDFAcroFormFieldsRef, PDFAcroFormFontsRef], [GetAcroFormRef, GetAcroFormFieldReferences, GetAcroFormFontsRefs]);
          end;
        end;
      end;
    end;

    FOutput.Stream := CreateStringStream;
    for I := 0 to FOutput.Streams.Count - 1 do
    begin
      st := TStream(FOutput.Streams[I]);
      st.Position := 0;
      if st is TTMSFNCPDFGraphicsLibOutputWriterStream then
      begin
        sts := st as TTMSFNCPDFGraphicsLibOutputWriterStream;
        if Assigned(sts.Reference) and (sts.Reference is TTMSFNCGeneralPDFLibXRefObject) then
        begin
          x := sts.Reference as TTMSFNCGeneralPDFLibXRefObject;
          if x.XRefOffset < 0 then
            x.XRefOffset := FOutput.Stream.Position;
        end;
      end;

      FOutput.Stream.CopyFrom(st, st.Size);
    end;

    FOutput.Streams.Add(FOutput.Stream);
    FOutput.StreamPosition := FOutput.Stream.Size;
    XRefAddress := FOutput.StreamPosition;
    WriteXRefTable;
    FOutput.WriteString('trailer' + PDFLB);
    FOutput.WriteString('<<');
    FOutput.WriteString('/Root 1 0 R');
    FOutput.WriteString('/Info ' + IntToStr(FXRefObjects.IndexOf(FInfo.XRefObject)) + ' 0 R');
    FOutput.WriteString('/Size ' + IntToStr(FXRefObjects.Count));
    case PDFStandard of
      pdfA1:
      begin
        {$IFDEF WEBLIB}
        raise Exception.Create('PDF Standard A1');
        {$ELSE}
        Randomize;
        for i := 0 to high(fid) do
          fid[i] := UInt32(Random(MaxInt));

        Inc(fid[0], GetTickCountX);
        SetLength(IDs,34);
        P := pointer(IDs);
        P[0] := '<';
        {$IFNDEF FMXMOBILE}
        {$IFNDEF LINUX}
        BinToHex(@fid[0], p + 1, 16);
        {$ENDIF}
        {$ENDIF}
        P[33] := '>';
        FOutput.WriteString('/ID[' + p + ' ' + p +']');
        {$ENDIF}
      end;
    end;
    FOutput.WriteString('>>'+ PDFLB);
    FOutput.WriteString('startxref' + PDFLB);
    FOutput.WriteString(IntToStr(XRefAddress) + PDFLB);
    FOutput.WriteString(PDFEnd + PDFLB);

    FOutput.StreamPosition := 0;
    if FPDFFileName <> '' then
    begin
      {$IFDEF WEBLIB}
      if AOpenInPDFReader then
      begin
        ms := TMemoryStream.Create;
        try
          ms.CopyFrom(FOutput.Stream, FOutput.Stream.Size);
          ms.OpenFile('application/pdf');
        finally
          ms.Free;
        end;
      end;
      {$ELSE}
      FOutput.Stream.SaveToFile(FPDFFileName);
      if AOpenInPDFReader then
        TTMSFNCUtils.OpenFile(FPDFFileName);
      {$ENDIF}
    end
    else
    begin
      ms := TMemoryStream.Create;
      ms.CopyFrom(FOutput.Stream, FOutput.Stream.Size);
      Result := ms;
    end;

    FFontList.Clear;
    ClearFontCache;
    FActivePage := nil;
    FXRefObjects.Clear;
    FOutput.ClearProperties;
    FOutput.Streams.Clear;
    FDocumentStarted := False;
    FPageCount := 0;
  end;
end;

procedure TTMSFNCGeneralPDFLib.WriteFontList;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  ft: TTMSFNCGeneralPDFLibFont;
  ftd: TTMSFNCGeneralPDFLibFontDescriptor;
  ftds: TTMSFNCGeneralPDFLibFontDescendant;
  ftff: TTMSFNCGeneralPDFLibFontFile;
  ftu: TTMSFNCGeneralPDFLibFontUnicode;
  os: integer;
  s: String;
  ms: TStringStream;
  ls: Integer;
  useCompression: Boolean;
  I: Integer;
  mapCount: Integer;
  glyphMap: TTMSFNCGeneralPDFLibGlyphMapEntries;
  useComposite: Boolean;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  if not Assigned(FOutput) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibFont then
      begin
        ft := x.XRefObject as TTMSFNCGeneralPDFLibFont;
        if not ft.Inactive then
        begin
          useComposite := ft.Unicode or (ft.FontProgramType = fptOpenTypeCFF);
          FOutput.StartNewStream(x);
          FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
          FOutput.WriteString('<<');
          FOutput.WriteString('/Type/Font');
          FOutput.WriteString('/BaseFont/' + ft.Name);
          if useComposite then
          begin
            FOutput.WriteString('/Subtype/Type0');
            FOutput.WriteString('/Encoding/Identity-H');
          end
          else
          begin
            FOutput.WriteString('/Subtype/TrueType');
            FOutput.WriteString('/Encoding/WinAnsiEncoding');
          end;

          if Assigned(ft.FontDescriptor) then
            FOutput.WriteString('/FontDescriptor ' + IntToStr(FXRefObjects.IndexOf(ft.FontDescriptor.XRefObject)) + ' 0 R');

          FOutput.WriteString('/Name' + ft.RefName);

          if Assigned(ft.FontDescendant) then
            FOutput.WriteString('/DescendantFonts[' + IntToStr(FXRefObjects.IndexOf(ft.FontDescendant.XRefObject)) + ' 0 R]');

          if useComposite then
          begin
            if Assigned(ft.FontUnicode) then
              FOutput.WriteString('/ToUnicode ' + IntToStr(FXRefObjects.IndexOf(ft.FontUnicode.XRefObject)) + ' 0 R')
          end
          else
          begin
            FOutput.WriteString('/FirstChar ' + ft.FirstGlyphAsString);
            FOutput.WriteString('/LastChar ' + ft.LastGlyphAsString);
            FOutput.WriteString('/Widths['+ft.WidthsAsString+']');
          end;

          FOutput.WriteString('>>' + PDFLB);
          FOutput.WriteString('endobj' + PDFLB);
        end;
        if ft.Inactive then
        begin
          x.XRefType := 'f';
          x.XRefOffset := 0;
        end;
      end
      else if x.XRefObject is TTMSFNCGeneralPDFLibFontDescriptor then
      begin
        ftd := (x.XRefObject as TTMSFNCGeneralPDFLibFontDescriptor);
        if not ftd.Font.Inactive then
        begin
          FOutput.StartNewStream(x);
          FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
          FOutput.WriteString('<<');
          FOutput.WriteString('/Type/FontDescriptor');
          FOutput.WriteString('/FontName/' + ftd.Font.Name);
          FOutput.WriteString('/Ascent ' + IntToStr(ftd.Font.Ascent));
          FOutput.WriteString('/CapHeight ' + IntToStr(ftd.Font.CapHeight));
          FOutput.WriteString('/Descent ' + IntToStr(ftd.Font.Descent));
          FOutput.WriteString('/ItalicAngle ' + IntToStr(ftd.Font.ItalicAngle));
          FOutput.WriteString('/StemV 87');
          FOutput.WriteString('/Flags 32');
          FOutput.WriteString('/MissingWidth 600');
          FOutput.WriteString('/FontBBox[' + ftd.Font.BoxAsString+']');
          if Assigned(ftd.Font) and Assigned(ftd.Font.FontFile) and EmbedFonts then
          begin
            if ftd.Font.FontProgramType = fptOpenTypeCFF then
              FOutput.WriteString('/FontFile3 ' + IntToStr(FXRefObjects.IndexOf(ftd.Font.FontFile.XRefObject)) + ' 0 R')
            else
              FOutput.WriteString('/FontFile2 ' + IntToStr(FXRefObjects.IndexOf(ftd.Font.FontFile.XRefObject)) + ' 0 R');
          end;
          FOutput.WriteString('>>' + PDFLB);
          FOutput.WriteString('endobj' + PDFLB);
        end;
        if ftd.Font.Inactive then
        begin
          x.XRefType := 'f';
          x.XRefOffset := 0;
        end;
      end
      else if x.XRefObject is TTMSFNCGeneralPDFLibFontFile then
      begin
        ftff := (x.XRefObject as TTMSFNCGeneralPDFLibFontFile);
        if not ftff.Font.Inactive then
        begin
          os := ftff.Font.Initializer.GetTTFDataLength;
          ftff.Font.Initializer.CompressTTFData;
          ls := ftff.Font.Initializer.GetTTFDataCompressedLength;

          FOutput.StartNewStream(x);
          FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
          FOutput.WriteString('<<');
          FOutput.WriteString('/Length ' + IntToStr(ls));
          if ftff.Font.FontProgramType <> fptOpenTypeCFF then
            FOutput.WriteString('/Length1 ' + IntToStr(os))
          else
            FOutput.WriteString('/Subtype/OpenType');
          useCompression := CanCompress;
          if useCompression then
          begin
            FOutput.WriteString('/Filter');
            FOutput.WriteString('/FlateDecode');
          end;
          FOutput.WriteString('>>' + PDFLB);
          FOutput.WriteString('stream' + PDFLB);
          ms := ftff.Font.Initializer.GetTTFDataCompressed;
          if Assigned(ms) then
            FOutput.Streams.Add(ms);
          FOutput.StartNewStream;
          FOutput.WriteString(PDFLB);
          FOutput.WriteString('endstream' + PDFLB);
          FOutput.WriteString('endobj' + PDFLB);
        end;
        if ftff.Font.Inactive then
        begin
          x.XRefType := 'f';
          x.XRefOffset := 0;
        end;
      end
      else if x.XRefObject is TTMSFNCGeneralPDFLibFontDescendant then
      begin
        ftds := (x.XRefObject as TTMSFNCGeneralPDFLibFontDescendant);
        if not ftds.Font.Inactive then
        begin
          FOutput.StartNewStream(x);
          FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
          FOutput.WriteString('<<');
          FOutput.WriteString('/Type/Font');
          if ftds.Font.FontProgramType = fptOpenTypeCFF then
            FOutput.WriteString('/Subtype/CIDFontType0')
          else
          begin
            FOutput.WriteString('/Subtype/CIDFontType2');
            case PDFStandard of
              pdfA1: FOutput.WriteString('/CIDToGIDMap/Identity');
            end;
          end;
          FOutput.WriteString('/BaseFont/' + ftds.Font.Name);
          FOutput.WriteString('/CIDSystemInfo<</Supplement 0/Ordering(Identity)/Registry(Adobe)>>');
          FOutput.WriteString('/DW 600');
          FOutput.WriteString('/W[' + ftds.Font.GlyphsAndWidthsAsString + ']');

          if Assigned(ftds.Font) and Assigned(ftds.Font.FontDescriptor) then
            FOutput.WriteString('/FontDescriptor ' + IntToStr(FXRefObjects.IndexOf(ftds.Font.FontDescriptor.XRefObject)) + ' 0 R');

          FOutput.WriteString('>>' + PDFLB);
          FOutput.WriteString('endobj' + PDFLB);
        end;
        if ftds.Font.Inactive then
        begin
          x.XRefType := 'f';
          x.XRefOffset := 0;
        end;
      end
      else if x.XRefObject is TTMSFNCGeneralPDFLibFontUnicode then
      begin
        ftu := (x.XRefObject as TTMSFNCGeneralPDFLibFontUnicode);
        if not ftu.Font.Inactive then
        begin
          s := '/CIDInit /ProcSet findresource begin'+ PDFLF+
          '12 dict begin'+ PDFLF + 'begincmap'+ PDFLF + '/CIDSystemInfo'+ PDFLF + '<<'+ PDFLF + '/Registry ('+
          ftu.Font.RefNameNotEscaped+'+0)'+ PDFLF + '/Ordering (UCS)'+ PDFLF + '/Supplement 0'+ PDFLF + '>> def'+ PDFLF+
          '/CMapName /'+ftu.font.RefNameNotEscaped+'+0 def'+ PDFLF + '/CMapType 2 def'+ PDFLF+
          '1 begincodespacerange'+ PDFLF + '<0000> <FFFF>'+ PDFLF + 'endcodespacerange'+ PDFLF;

          glyphMap := ftu.Font.BuildGlyphMapEntries;
          mapCount := Length(glyphMap);
          s := s + IntToStr(mapCount) + ' beginbfchar' + PDFLF;
          for i := 0 to mapCount - 1 do
          begin
            s := s + '<' + FOutput.AddHex4(glyphMap[I].GlyphId) + '><' +
              FOutput.AddHex4(glyphMap[I].UnicodeValue) + '>' + PDFLF;
          end;
          s := s + 'endbfchar' + PDFLF;
          s := s + 'endcmap' + PDFLF + 'CMapName currentdict /CMap defineresource pop'+PDFLF+'end'+PDFLF+'end';

          ms := FOutput.CompressString(s);
          ls := 0;
          if Assigned(ms) then
            ls := ms.Size;

          FOutput.StartNewStream(x);
          FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
          FOutput.WriteString('<<');
          FOutput.WriteString('/Length ' + IntToStr(ls));
          useCompression := CanCompress;
          if useCompression then
          begin
            FOutput.WriteString('/Filter');
            FOutput.WriteString('/FlateDecode');
          end;
          FOutput.WriteString('>>' + PDFLB);
          FOutput.WriteString('stream' + PDFLB);
          if Assigned(ms) then
            FOutput.Streams.Add(ms);
          FOutput.StartNewStream;
          FOutput.WriteString(PDFLB);
          FOutput.WriteString('endstream' + PDFLB);
          FOutput.WriteString('endobj' + PDFLB);
        end;
        if ftu.Font.Inactive then
        begin
          x.XRefType := 'f';
          x.XRefOffset := 0;
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.WriteAnnotationList;

  function StringToPdfUtf16Hex(const S: string): string;
  var
    i: Integer;
    c: Word;
  begin
    Result := 'FEFF';

    for i := 1 to Length(S) do
    begin
      c := Ord(S[i]);
      Result := Result + FOutput.AddHex4(c);
    end;
  end;

  function EscapePdfLiteral(const S: string): string;
  var
    i: Integer;
    c: Char;
  begin
    Result := '';
    for i := 1 to Length(S) do
    begin
      c := S[i];
      case c of
        '\', '(', ')':
          Result := Result + '\' + c;
        #8:
          Result := Result + '\b';
        #9:
          Result := Result + '\t';
        #10:
          Result := Result + '\n';
        #12:
          Result := Result + '\f';
        #13:
          Result := Result + '\r';
      else
        Result := Result + c;
      end;
    end;
  end;

  function PdfTextLiteralOrHex(const S: string): string;
  begin
    if FOutput.IsUnicodeString(S) then
      Result := '<' + StringToPdfUtf16Hex(S) + '>'
    else
      Result := '(' + EscapePdfLiteral(S) + ')';
  end;

var
  x: TTMSFNCGeneralPDFLibXRefObject;
  an: TTMSFNCGeneralPDFLibAnnotation;
  u: TTMSFNCGeneralPDFLibURL;
  gt: TTMSFNCGeneralPDFLibGoTo;
  gt2: TTMSFNCGeneralPDFLibGoTo2;
  w: TTMSFNCGeneralPDFLibFormField;
  tf: TTMSFNCGeneralPDFLibFormFieldText;
  chk: TTMSFNCGeneralPDFLibFormFieldCheckBox;
  cb: TTMSFNCGeneralPDFLibFormFieldComboBox;
  lb: TTMSFNCGeneralPDFLibFormFieldListBox;
  ch: TTMSFNCGeneralPDFLibFormFieldChoice;
  rbg: TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup;
  rb: TTMSFNCGeneralPDFLibFormFieldRadioButton;
  flag, fieldFlag: Int32;
  o: string;
  rv: string;
  I: Integer;
  ft: TTMSFNCPDFGraphicsLibFont;
  ftTemp: TTMSFNCGeneralPDFLibFont;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  if not Assigned(FOutput) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibAnnotation then
      begin
        an := x.XRefObject as TTMSFNCGeneralPDFLibAnnotation;
        FOutput.StartNewStream(x);
        FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
        FOutput.WriteString('<<');
        if not (an is TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup) then
          FOutput.WriteString('/Type/Annot');

        if (an is TTMSFNCGeneralPDFLibURL) or (an is TTMSFNCGeneralPDFLibGoTo) or (an is TTMSFNCGeneralPDFLibGoTo2) then
        begin
          FOutput.WriteString('/Subtype/Link');
          FOutput.WriteString('/A');
          FOutput.WriteString('<<');
          if an is TTMSFNCGeneralPDFLibURL then
          begin
            u := an as TTMSFNCGeneralPDFLibURL;
            {$IFDEF LCLLIB}
            FOutput.WriteString('/Type/Action/S/URI/URI(' + EscapePdfLiteral(UTF8Encode(u.URL)) + ')');
            {$ENDIF}
            {$IFNDEF LCLLIB}
            FOutput.WriteString('/Type/Action/S/URI/URI(' + EscapePdfLiteral(u.URL) + ')');
            {$ENDIF}
          end
          else if an is TTMSFNCGeneralPDFLibGoTo then
          begin
            gt := an as TTMSFNCGeneralPDFLibGoTo;
            {$IFDEF LCLLIB}
            FOutput.WriteString('/Type/Action/S/GoTo/D['+UTF8Encode(gt.Destination) + ']');
            {$ENDIF}
            {$IFNDEF LCLLIB}
            FOutput.WriteString('/Type/Action/S/GoTo/D['+gt.Destination + ']');
            {$ENDIF}
          end
          else if an is TTMSFNCGeneralPDFLibGoTo2 then
          begin
            gt2 := an as TTMSFNCGeneralPDFLibGoTo2;

            o := '';
            if gt2.Options <> '' then
              o := ' ' + gt2.Options;

            {$IFDEF LCLLIB}
            FOutput.WriteString('/Type/Action/S/GoTo/D['+UTF8Encode(PDFPageGoToRef + ' 0 R' + o) + ']');
            {$ENDIF}
            {$IFNDEF LCLLIB}
            FOutput.WriteString('/Type/Action/S/GoTo/D['+ PDFPageGoToRef + ' 0 R' + o + ']');
            {$ENDIF}
          end;

          FOutput.WriteString('>>');
          FOutput.WriteString('/BS');
          FOutput.WriteString('<<');
          FOutput.WriteString('/W 0/S/S');
          FOutput.WriteString('>>');
        end
        else if (an is TTMSFNCGeneralPDFLibFormField) then
        begin
          w := an as TTMSFNCGeneralPDFLibFormField;
          if not (w is TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup) then
            FOutput.WriteString('/Subtype/Widget');

          if not (w is TTMSFNCGeneralPDFLibFormFieldRadioButton) then
            FOutput.WriteString('/T(' + EscapePdfLiteral(w.PartialName) + ')');

          flag := 4;
          if w.Hidden then
            flag := flag or 2;

          fieldFlag := 0;
          if w.&ReadOnly then
            fieldFlag := 1;

          FOutput.WriteString('/F ' + IntToStr(flag));
          if w is TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup then
          begin
            rbg := w as TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup;
            FOutput.WriteString('/FT/Btn');
            fieldFlag := fieldFlag or 49152; //15th & 16th bit
            FOutput.WriteString('/Kids[' + GetRadioGroupReferences(rbg) + ']');
            rv := GetRadioGroupCheckedValueRef(rbg);
            if rv = '' then
              rv := 'Off';
            FOutput.WriteString('/V /' + rv);
          end
          else if w is TTMSFNCGeneralPDFLibFormFieldText then
          begin
            tf := w as TTMSFNCGeneralPDFLibFormFieldText;
            FOutput.WriteString('/FT/Tx');
            if tf.Multiline then
              fieldFlag := fieldFlag or 4096; //13th bit

            if tf.IsPassword then
              fieldFlag := fieldFlag or 8192; //14th bit

            ft := TTMSFNCPDFGraphicsLibFont.Create;
            try
              ft.Assign(FPDFGraphicsLib.Font);
              FPDFGraphicsLib.Font.Assign(tf.Font);
              ftTemp := SearchForFont(BuildInternalFontName(VerifyFontName(tf.Font.Name), tf.Font.Style), ShouldUseUnicodeFontForText(tf.Text));
              if not Assigned(ftTemp) then
              begin
                FormUpdateFontList(tf.Text, tf.Font);
                ftTemp := SearchForFont(BuildInternalFontName(VerifyFontName(tf.Font.Name), tf.Font.Style), ShouldUseUnicodeFontForText(tf.Text));
              end;
              if Assigned(ftTemp) then
              begin
                if tf.AutoSize then
                  FOutput.WriteString('/DA (' + FOutput.ConvertColorToString(tf.Font.Color) + ' rg ' + ftTemp.RefName + ' 0 Tf)')
                else
                  FOutput.WriteString('/DA (' + FOutput.ConvertColorToString(tf.Font.Color) + ' rg ' + ftTemp.RefName + ' ' + Foutput.ConvertFloatToString(tf.Font.Size) + ' Tf)')
              end;
              FPDFGraphicsLib.Font.Assign(ft);
            finally
              ft.Free;
            end;

            if tf.Text <> '' then
              FOutput.WriteString('/V ' + PdfTextLiteralOrHex(tf.Text));

            case tf.HorizontalAlign of
              gtaLeading: FOutput.WriteString('/Q 0');
              gtaCenter: FOutput.WriteString('/Q 1');
              gtaTrailing: FOutput.WriteString('/Q 2');
            end;

            if Assigned(tf.Content) and Assigned(tf.Content.XRefObject) then
              FOutput.WriteString('/AP <</N ' + IntToStr(FXRefObjects.IndexOf(tf.Content.XRefObject)) +' 0 R>>');
          end
          else if w is TTMSFNCGeneralPDFLibFormFieldButton then
          begin
            if w is TTMSFNCGeneralPDFLibFormFieldCheckBox then
            begin
              FOutput.WriteString('/FT/Btn');
              FOutput.WriteString('/MK<</BG[1.0]/BC[0.0]/CA(8)>>');
              chk := w as TTMSFNCGeneralPDFLibFormFieldCheckBox;
              if chk.IsChecked then
              begin
                FOutput.WriteString('/V /On');
                FOutput.WriteString('/AS /On');
              end
              else
              begin
                FOutput.WriteString('/V /Off');
                FOutput.WriteString('/AS /Off');
              end;

              if Assigned(chk.OnContent) and Assigned(chk.OffContent) then
              begin
                FOutput.WriteString('/AP');
                FOutput.WriteString('<<');
                FOutput.WriteString('/N');
                FOutput.WriteString('<<');
                FOutput.WriteString('/On ' + IntToStr(FXRefObjects.IndexOf(chk.OnContent.XRefObject)) + ' 0 R');
                FOutput.WriteString('/Off ' + IntToStr(FXRefObjects.IndexOf(chk.OffContent.XRefObject)) + ' 0 R');
                FOutput.WriteString('>>');
                FOutput.WriteString('>>');
              end;
            end
            else if w is TTMSFNCGeneralPDFLibFormFieldRadioButton then
            begin
              rb := w as TTMSFNCGeneralPDFLibFormFieldRadioButton;
              if rb.IsChecked then
                FOutput.WriteString('/AS /' + rb.PartialName)
              else
                FOutput.WriteString('/AS /Off');

              FOutput.WriteString('/MK<</BG[1.0]/BC[0.0]>>');
              o := GetRadioButtonParentRef(rb);
              if o <> '' then
                FOutput.WriteString('/Parent ' + o);
              if Assigned(rb.OnContent) and Assigned(rb.OffContent) then
              begin
                FOutput.WriteString('/AP');
                FOutput.WriteString('<<');
                FOutput.WriteString('/N');
                FOutput.WriteString('<<');
                FOutput.WriteString('/' + rb.PartialName + ' ' + IntToStr(FXRefObjects.IndexOf(rb.OnContent.XRefObject)) + ' 0 R');
                FOutput.WriteString('/Off ' + IntToStr(FXRefObjects.IndexOf(rb.OffContent.XRefObject)) + ' 0 R');
                FOutput.WriteString('>>');
                FOutput.WriteString('>>');
              end;
            end;
          end
          else if w is TTMSFNCGeneralPDFLibFormFieldChoice then
          begin
            ch := w as TTMSFNCGeneralPDFLibFormFieldChoice;

            FOutput.WriteString('/FT/Ch');
            if (ch.ItemIndex > -1) and (ch.ItemIndex < ch.Items.Count) then
              FOutput.WriteString('/V ' + PdfTextLiteralOrHex(ch.Items[ch.ItemIndex]));

            FOutput.WriteString('/Opt [');
            for I := 0 to ch.Items.Count - 1 do
              FOutput.WriteString(PdfTextLiteralOrHex(ch.Items[I]));
            FOutput.WriteString(']');

            ft := TTMSFNCPDFGraphicsLibFont.Create;
            try
              ft.Assign(FPDFGraphicsLib.Font);
              FPDFGraphicsLib.Font.Assign(ch.Font);
              ftTemp := SearchForFont(BuildInternalFontName(VerifyFontName(ch.Font.Name), ch.Font.Style), ShouldUseUnicodeFontForText(ch.Items.Text));
              if not Assigned(ftTemp) then
              begin
                FormUpdateFontList(ch.Items.Text, ch.Font);
                ftTemp := SearchForFont(BuildInternalFontName(VerifyFontName(ch.Font.Name), ch.Font.Style), ShouldUseUnicodeFontForText(ch.Items.Text));
              end;
              if Assigned(ftTemp) then
              begin
                if (ch is TTMSFNCGeneralPDFLibFormFieldComboBox) and (ch as TTMSFNCGeneralPDFLibFormFieldComboBox).AutoSize then
                  FOutput.WriteString('/DA (' + FOutput.ConvertColorToString(ch.Font.Color) + ' rg ' + ftTemp.RefName + ' 0 Tf)')
                else
                  FOutput.WriteString('/DA (' + FOutput.ConvertColorToString(ch.Font.Color) + ' rg ' + ftTemp.RefName + ' ' + FOutput.ConvertFloatToString(ch.Font.Size) + ' Tf)');
              end;
              FPDFGraphicsLib.Font.Assign(ft);
            finally
              ft.Free;
            end;

            if ch is TTMSFNCGeneralPDFLibFormFieldListBox then
            begin
              lb := (ch as TTMSFNCGeneralPDFLibFormFieldListBox);
              if Assigned(lb.Content) and Assigned(lb.Content.XRefObject) then
                FOutput.WriteString('/AP <</N ' + IntToStr(FXRefObjects.IndexOf(lb.Content.XRefObject)) +' 0 R>>');
            end
            else if ch is TTMSFNCGeneralPDFLibFormFieldComboBox then
            begin
              cb := ch as TTMSFNCGeneralPDFLibFormFieldComboBox;
              fieldFlag := fieldFlag or 131072; //18th bit set to 1
              if cb.Editable then
                fieldFlag := fieldFlag or 262144; //19th bit set to 1

              if Assigned(cb.Content) and Assigned(cb.Content.XRefObject) then
                FOutput.WriteString('/AP <</N ' + IntToStr(FXRefObjects.IndexOf(cb.Content.XRefObject)) +' 0 R>>');
            end;
          end;

          if fieldFlag <> 0 then
            FOutput.WriteString('/Ff ' + IntToStr(fieldFlag));
        end;

        if not (an is TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup) then
          FOutput.WriteString('/Rect['+ an.RectAsString +']');

        FOutput.WriteString('>>' + PDFLB);
        FOutput.WriteString('endobj' + PDFLB);
      end;
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.WriteBitmapList;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  bmp: TTMSFNCGeneralPDFLibBitmap;
  ms: TMemoryStream;
  ls: Integer;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  if not Assigned(FOutput) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibBitmap then
      begin
        bmp := x.XRefObject as TTMSFNCGeneralPDFLibBitmap;

        {$IFDEF WEBLIB}
        ms := TMemoryStream.Create;
        bmp.Stream.Position := 0;
        ms.CopyFrom(bmp.Stream, bmp.Stream.Size);
        {$ELSE}
        ms := TTMSFNCUtils.ConvertBitmapToJPEGStream(bmp.Bitmap, bmp.Quality, bmp.BackgroundColor);
        {$ENDIF}
        ls := 0;
        if Assigned(ms) then
          ls := ms.Size;

        FOutput.StartNewStream(x);
        FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
        FOutput.WriteString('<<');
        FOutput.WriteString('/Type/XObject');
        FOutput.WriteString('/Subtype/Image');
        FOutput.WriteString('/Filter/DCTDecode');
        FOutput.WriteString('/Width ' + IntToStr(bmp.Bitmap.Width));
        FOutput.WriteString('/Height ' + IntToStr(bmp.Bitmap.Height));
        FOutput.WriteString('/ColorSpace/DeviceRGB');
        FOutput.WriteString('/BitsPerComponent 8');
        FOutput.WriteString('/Length ' + IntToStr(ls));
        FOutput.WriteString('>>' + PDFLB);
        FOutput.WriteString('stream' + PDFLB);
        if Assigned(ms) then
          FOutput.Streams.Add(ms);
        FOutput.StartNewStream;
        FOutput.WriteString(PDFLB);
        FOutput.WriteString('endstream' + PDFLB);
        FOutput.WriteString('endobj' + PDFLB);
      end
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.WritePatternList;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  p: TTMSFNCGeneralPDFLibPattern;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  if not Assigned(FOutput) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibPattern then
      begin
        p := x.XRefObject as TTMSFNCGeneralPDFLibPattern;
        FOutput.StartNewStream(x);
        FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
        FOutput.WriteString('<<');
        FOutput.WriteString('/Type/Pattern');
        FOutput.WriteString('/PatternType 2');
        if Assigned(p.Shading) then
          FOutput.WriteString('/Shading ' + IntToStr(FXRefObjects.IndexOf(p.Shading.XRefObject)) + ' 0 R');
        FOutput.WriteString('>>' + PDFLB);
        FOutput.WriteString('endobj' + PDFLB);
      end
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.WriteShadingList;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  f: TTMSFNCGeneralPDFLibShadingFunction;
  sf: TTMSFNCGeneralPDFLibShadingSubFunction;
  s: TTMSFNCGeneralPDFLibShading;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  if not Assigned(FOutput) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibShading then
      begin
        s := x.XRefObject as TTMSFNCGeneralPDFLibShading;
        FOutput.StartNewStream(x);
        FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
        FOutput.WriteString('<<');
        if s is TTMSFNCGeneralPDFLibLinearGradient then
          FOutput.WriteString('/ShadingType 2');

        FOutput.WriteString('/Extend[false false]');
        FOutput.WriteString('/ColorSpace/DeviceRGB');
        FOutput.WriteString('/Coords['+s.RectAsString+']');
        if Assigned(s.&Function) then
          FOutput.WriteString('/Function ' + IntToStr(FXRefObjects.IndexOf(s.&Function.XRefObject)) + ' 0 R');
        FOutput.WriteString('>>' + PDFLB);
        FOutput.WriteString('endobj' + PDFLB);
      end
      else if x.XRefObject is TTMSFNCGeneralPDFLibShadingFunction then
      begin
        f := x.XRefObject as TTMSFNCGeneralPDFLibShadingFunction;
        FOutput.StartNewStream(x);
        FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
        FOutput.WriteString('<<');
        FOutput.WriteString('/FunctionType 3');
        FOutput.WriteString('/Domain[0 1]');
        FOutput.WriteString('/Encode[0 1 0 1]');
        FOutput.WriteString('/Bounds[1]');
        FOutput.WriteString('/Functions['+ f.SubFunctionsRef +']');
        FOutput.WriteString('>>' + PDFLB);
        FOutput.WriteString('endobj' + PDFLB);
      end
      else if x.XRefObject is TTMSFNCGeneralPDFLibShadingSubFunction then
      begin
        sf := x.XRefObject as TTMSFNCGeneralPDFLibShadingSubFunction;
        FOutput.StartNewStream(x);
        FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);
        FOutput.WriteString('<<');
        FOutput.WriteString('/FunctionType 2');
        FOutput.WriteString('/Domain[0 1]');
        FOutput.WriteString('/C0['+FOutput.ConvertColorToString(sf.FillColor)+']');
        FOutput.WriteString('/C1['+FOutput.ConvertColorToString(sf.FillColorTo)+']');
        FOutput.WriteString('/N 1');
        FOutput.WriteString('>>' + PDFLB);
        FOutput.WriteString('endobj' + PDFLB);
      end;
    end;
  end;
end;

type
  TTMSFNCGeneralPDFLibTextLine = record
    Text: string;
    HorizontalAlign: Single;
  end;

  TTMSFNCGeneralPDFLibTextLineArray = TArray<TTMSFNCGeneralPDFLibTextLine>;

procedure TTMSFNCGeneralPDFLib.WriteFormXObjects;

  function GetTextWidth(AText: string; AFontSize: Single): Single;
  var
    r: TRectF;
  begin
    FPDFGraphicsLib.Font.Size := AFontSize;
    r := FPDFGraphicsLib.CalculateText(AText);
    Result := r.Right - r.Left;
  end;

  function GetTextHeight(AText: string; AFontSize: Single): Single;
  var
    r: TRectF;
  begin
    FPDFGraphicsLib.Font.Size := AFontSize;
    r := FPDFGraphicsLib.CalculateText(AText);
    Result := r.Bottom - r.Top;
  end;

  function WrapTextToWidth(const AText: string; AFieldWidth, AFontSize: Single; AAlign: TTMSFNCGraphicsTextAlign): TTMSFNCGeneralPDFLibTextLineArray;
  var
    lines: TStringList;
    words: TArray<string>;
    word, currentLine: string;
    lineWidth, wordWidth, spaceWidth: Single;
    I: Integer;
  begin
    SetLength(Result, 0);
    spaceWidth := GetTextWidth(' ', AFontSize);
    lines := TStringList.Create;
    try
      lines.Text := AText;
      for I := 0 to lines.Count - 1 do
      begin
        words := lines[I].Split([' ']);
        currentLine := '';
        lineWidth := 0;

        for word in words do
        begin
          wordWidth := GetTextWidth(word, AFontSize);
          if (lineWidth + IfThen(lineWidth > 0, spaceWidth, 0) + wordWidth + spaceWidth) > AFieldWidth then
          begin
            if currentLine <> '' then
            begin
              SetLength(Result, Length(Result) + 1);
              Result[Length(Result) - 1].Text := currentLine;
              Result[Length(Result) - 1].HorizontalAlign := 0;
              case AAlign of
                gtaCenter: Result[Length(Result) - 1].HorizontalAlign := (AFieldWidth - lineWidth - spaceWidth) / 2;
                gtaTrailing: Result[Length(Result) - 1].HorizontalAlign := (AFieldWidth - lineWidth - spaceWidth);
              end;
            end;
            currentLine := word;
            lineWidth := wordWidth;
          end
          else
          begin
            if lineWidth > 0 then
            begin
              currentLine := currentLine + ' ';
              lineWidth := lineWidth + spaceWidth;
            end;
            currentLine := currentLine + word;
            lineWidth := lineWidth + wordWidth;
          end;
        end;

        if currentLine <> '' then
        begin
          SetLength(Result, Length(Result) + 1);
          Result[Length(Result) - 1].Text := currentLine;
          Result[Length(Result) - 1].HorizontalAlign := 0;
          case AAlign of
            gtaCenter: Result[Length(Result) - 1].HorizontalAlign := (AFieldWidth - lineWidth) / 2;
            gtaTrailing: Result[Length(Result) - 1].HorizontalAlign := (AFieldWidth - lineWidth);
          end;
        end;
      end;
    finally
      lines.Free;
    end;
  end;

  function GetTextFieldLines(AFieldWidth, AFieldHeight: Single;
    AFormField: TTMSFNCGeneralPDFLibFormFieldText; var AFontSize: Single): TTMSFNCGeneralPDFLibTextLineArray;
  const
    cAscentRatio = 0.65;
  var
    r, tempR: TRectF;
    tl, ha: Single;
    ft: TTMSFNCPDFGraphicsLibFont;
  begin
    ft := TTMSFNCPDFGraphicsLibFont.Create;
    try
      ft.Assign(FPDFGraphicsLib.Font);
      FPDFGraphicsLib.Font.Assign(AFormField.Font);

      if AFormField.MultiLine then
      begin
        if AFormField.AutoSize then
        begin
          AFontSize := 13;
          tempR := RectF(0, 0, AFieldWidth, AFieldHeight);
          repeat
            AFontSize := AFontSize - 1;
            FPDFGraphicsLib.Font.Size := AFontSize;
            r := FPDFGraphicsLib.CalculateText(AFormField.Text, tempR);
          until (((r.Right - r.Left) < AFieldWidth) and ((r.Bottom - r.Top) < AFieldHeight) or (AFontSize < 1));
          Result := WrapTextToWidth(AFormField.Text, AFieldWidth, AFontSize, AFormField.HorizontalAlign);
        end
        else
        begin
          Result := WrapTextToWidth(AFormField.Text, AFieldWidth, AFontSize, AFormField.HorizontalAlign);
        end;
      end
      else
      begin
        if AFormField.AutoSize then
        begin
          tl := GetTextWidth(AFormField.Text, 1);
          if tl > 0 then
          begin
            AFontSize := Min(AFieldWidth / tl, AFieldHeight * cAscentRatio);
            case AFormField.HorizontalAlign of
              gtaCenter: ha := (AFieldWidth - tl * AFontSize) / 2;
              gtaTrailing: ha := AFieldWidth - tl * AFontSize;
            else
              ha := 0;
            end;
          end
          else
          begin
            AFontSize := AFieldHeight * cAscentRatio;
            ha := 0;
          end;
        end
        else
        begin
          tl := GetTextWidth(AFormField.Text, AFontSize);
          case AFormField.HorizontalAlign of
            gtaCenter: ha := (AFieldWidth - tl) / 2;
            gtaTrailing: ha := AFieldWidth - tl - 1;
          else
            ha := 1;
          end;
        end;

        SetLength(Result, 1);
        Result[0].Text := AFormField.Text;
        Result[0].HorizontalAlign := ha;
      end;

      FPDFGraphicsLib.Font.Assign(ft);
    finally
      ft.Free;
    end;
  end;

const
  PDFFormFieldContentRef = '{PDFFormFieldContentRef}';
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  chkC: TTMSFNCGeneralPDFLibFormFieldCheckBoxContent;
  rbC: TTMSFNCGeneralPDFLibFormFieldRadioButtonContent;
  txtC: TTMSFNCGeneralPDFLibFormFieldTextContent;
  lbC: TTMSFNCGeneralPDFLibFormFieldListBoxContent;
  cbC: TTMSFNCGeneralPDFLibFormFieldComboBoxContent;
  w, h, fontSize, a: Single;
  xC, yC, w2, h2, xw2, yh2, bz: Single;
  I: Integer;
  ft: TTMSFNCGeneralPDFLibFont;
  lines: TTMSFNCGeneralPDFLibTextLineArray;
  ms: TStringStream;
  fontRef, fontResRef, adFlags: string;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}

  procedure ApplyOutputFont(const AFont: TTMSFNCGeneralPDFLibFont);
  begin
    if Assigned(AFont) then
    begin
      FOutput.FontUnicode := AFont.Unicode;
      FOutput.FontEmbedding := EmbedFonts;
      FOutput.FontRefName := AFont.RefNameOriginal;
      FOutput.FontGlyphRefName := AFont.RefNameGlyphOriginal;
      FOutput.FontCharWidths := AFont.CharWidths;
      FOutput.FontCharArray := AFont.CharArray;
      FOutput.FontUsedCharArray := AFont.UsedCharArray;
    end;
  end;
begin
  if not Assigned(FOutput) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibFormXObject then
      begin
        fontRef := '';
        fontResRef := '';
        adFlags := '';

        FOutput.StartNewStream(x);
        FOutput.WriteString(IntToStr(FXRefObjects.IndexOf(x)) + ' 0 obj' + PDFLB);

        FOutput.WriteString('<<');
        FOutput.WriteString(PDFFormFieldContentRef);
        FOutput.WriteString('>>' + PDFLB);
        FOutput.WriteString('stream' + PDFLB);
        FOutput.StartContentStream(x.XRefObject);

        if (x.XRefObject is TTMSFNCGeneralPDFLibFormFieldCheckBoxContent) then
        begin
          chkC := x.XRefObject as TTMSFNCGeneralPDFLibFormFieldCheckBoxContent;
          h := chkC.FormField.Rect.Top - chkC.FormField.Rect.Bottom;
          w := chkC.FormField.Rect.Right - chkC.FormField.Rect.Left;

          FOutput.WriteString('0.8 g' + PDFLB);
          FOutput.WriteRectangle(RectF(0, 0, w, h));
          FOutput.WriteString('s' + PDFLB);
          if chkC.IsOnState then
          begin
            FOutput.WriteString('0 g' + PDFLB);
            FOutput.WriteStrokeWidth(1);
            FOutput.MoveTo(PointF(1, 1));
            FOutput.LineTo(PointF(h - 1, w - 1));
            FOutput.MoveTo(PointF(1, w - 1));
            FOutput.LineTo(PointF(h - 1, 1));
            FOutput.WriteString('S' + PDFLB);
          end;

          adFlags := '/Type/XObject/Subtype/Form/Resources<</ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']';
        end
        else if x.XRefObject is TTMSFNCGeneralPDFLibFormFieldRadioButtonContent then
        begin
          rbC := x.XRefObject as TTMSFNCGeneralPDFLibFormFieldRadioButtonContent;

          w := (rbC.FormField.Rect.Right - rbC.FormField.Rect.Left) - 2;
          h := (rbC.FormField.Rect.Top - rbC.FormField.Rect.Bottom) - 2;
          xC := 1;
          yC := 1;
          bz := 4/3 * (sqrt(2) - 1);
          w2 := w / 2;
          h2 := h / 2;
          xw2 := xC + w2;
          yh2 := yC + h2;
          FOutput.WriteString('q' + PDFLB);
          FOutput.WriteString('n' + PDFLB);
          FOutput.WriteString('1.0 g' + PDFLB);
          FOutput.MoveTo(PointF(xC, yC + w/2));
          FOutput.CurveTo(xC, yh2 - h2 * bz, xw2 - w2 * bz, yC, xw2, yC);
          FOutput.CurveTo(xw2 + w2 * bz, yC, xC + w, yh2 - h2 * bz, xC + w, yh2);
          FOutput.CurveTo(xC + w, yh2 + h2 * bz, xw2 + w2 * bz, yC + h, xw2, yC + h);
          FOutput.CurveTo(xw2 - w2 * bz, yC + h, xC, yh2 + h2 * bz, xC, yh2);
          FOutput.WriteString('h' + PDFLB);
          FOutput.WriteString('B' + PDFLB);
          if rbC.IsOnState then
          begin
            h := (rbC.FormField.Rect.Top - rbC.FormField.Rect.Bottom) / 2;
            w := (rbC.FormField.Rect.Right - rbC.FormField.Rect.Left) / 2;
            xC := w / 2;
            yC := h / 2;
            w2 := w / 2;
            h2 := h / 2;
            xw2 := xC + w2;
            yh2 := yC + h2;
            FOutput.WriteString('n' + PDFLB);
            FOutput.WriteString('0 g' + PDFLB);
            FOutput.MoveTo(PointF(xC, yC + w/2));
            FOutput.CurveTo(xC, yh2 - h2 * bz, xw2 - w2 * bz, yC, xw2, yC);
            FOutput.CurveTo(xw2 + w2 * bz, yC, xC + w, yh2 - h2 * bz, xC + w, yh2);
            FOutput.CurveTo(xC + w, yh2 + h2 * bz, xw2 + w2 * bz, yC + h, xw2, yC + h);
            FOutput.CurveTo(xw2 - w2 * bz, yC + h, xC, yh2 + h2 * bz, xC, yh2);
            FOutput.WriteString('h' + PDFLB);
            FOutput.WriteString('B' + PDFLB);
          end;
          FOutput.WriteString('Q' + PDFLB);

          h := rbC.FormField.Rect.Top - rbC.FormField.Rect.Bottom;
          w := rbC.FormField.Rect.Right - rbC.FormField.Rect.Left;
          adFlags := '/Type/XObject/Subtype/Form/Resources<</ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']';
        end
        else if x.XRefObject is TTMSFNCGeneralPDFLibFormFieldTextContent then
        begin
          txtC := x.XRefObject as TTMSFNCGeneralPDFLibFormFieldTextContent;
          w := txtC.FormField.Rect.Right - txtC.FormField.Rect.Left;
          h := txtC.FormField.Rect.Top - txtC.FormField.Rect.Bottom;
          fontSize := txtC.FormField.Font.Size;
          lines := GetTextFieldLines(w, h, txtC.FormField, fontSize);

          FOutput.WriteString('/Tx BMC' + PDFLB);
          FOutput.WriteString('q' + PDFLB);
          FOutput.WriteString('BT' + PDFLB);
          ft := SearchForFont(BuildInternalFontName(VerifyFontName(txtC.FormField.Font.Name), txtC.FormField.Font.Style), ShouldUseUnicodeFontForText(txtC.FormField.Text));
          if not Assigned(ft) then
          begin
            FormUpdateFontList(txtC.FormField.Text, txtC.FormField.Font);
            ft := SearchForFont(BuildInternalFontName(VerifyFontName(txtC.FormField.Font.Name), txtC.FormField.Font.Style), ShouldUseUnicodeFontForText(txtC.FormField.Text));
          end;
          if Assigned(ft) then
          begin
            ApplyOutputFont(ft);
            FOutput.WriteString(FOutput.ConvertColorToString(txtC.FormField.Font.Color) + ' rg' + PDFLB);
            FOutput.WriteString(ft.RefName + ' ' + FOutput.ConvertFloatToString(fontSize) + ' Tf' + PDFLB);
            fontResRef := ft.Ref;
            a := ft.Ascent / 1000 * fontSize;
          end
          else
            a := fontSize - 2;

          if txtC.FormField.Multiline then
          begin
            for I := 0 to Length(lines) - 1 do
            begin
              FOutput.MoveTextTo(PointF(lines[I].HorizontalAlign, h - (I + 1) * fontSize * 1.1));
              FOutput.AddText(lines[I].Text);
              FOutput.WriteTextMatrix(1, 0, 0, 1, 0, 0);
            end;
          end
          else
          begin
            if Length(lines) > 0 then
            begin
              FOutput.MoveTextTo(PointF(lines[0].HorizontalAlign, (H - A)/2));
              FOutput.AddText(lines[0].Text);
            end;
          end;
          FOutput.WriteString('ET' + PDFLB);
          FOutput.WriteString('Q' + PDFLB);
          FOutput.WriteString('EMC' + PDFLB);

          if fontResRef <> '' then
            adFlags := '/Type/XObject/Subtype/Form/Resources<</Font<<' + fontResRef + '>>/ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']'
          else
            adFlags := '/Type/XObject/Subtype/Form/Resources<</ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']';
        end
        else if x.XRefObject is TTMSFNCGeneralPDFLibFormFieldComboBoxContent then
        begin
          cbC := x.XRefObject as TTMSFNCGeneralPDFLibFormFieldComboBoxContent;
          w := cbC.FormField.Rect.Right - cbC.FormField.Rect.Left;
          h := cbC.FormField.Rect.Top - cbC.FormField.Rect.Bottom;

          ft := SearchForFont(BuildInternalFontName(VerifyFontName(cbC.FormField.Font.Name), cbC.FormField.Font.Style), ShouldUseUnicodeFontForText(cbC.FormField.Items.Text));
          if not Assigned(ft) then
          begin
            FormUpdateFontList(cbC.FormField.Items.Text, cbC.FormField.Font);
            ft := SearchForFont(BuildInternalFontName(VerifyFontName(cbC.FormField.Font.Name), cbC.FormField.Font.Style), ShouldUseUnicodeFontForText(cbC.FormField.Items.Text));
          end;
          if Assigned(ft) then
          begin
            fontRef := ft.RefName;
            fontResRef := ft.Ref;
          end;

          FOutput.WriteString('/Tx BMC' + PDFLB);
          FOutput.WriteString('q' + PDFLB);
          if (cbC.FormField.Items.Count > 0) and (cbC.FormField.ItemIndex > -1) then
          begin
            FOutput.WriteString('BT' + PDFLB);
            if cbC.FormField.AutoSize then
            begin
              h2 := GetTextWidth(cbC.FormField.Items[cbC.FormField.ItemIndex], 1);
              if h2 > 0 then
                fontSize := Min(w / h2, h * 0.65)
              else
                fontSize := h * 0.65;
            end
            else
              fontSize := cbC.FormField.Font.Size;

            ft := SearchForFont(BuildInternalFontName(VerifyFontName(cbC.FormField.Font.Name), cbC.FormField.Font.Style), ShouldUseUnicodeFontForText(cbC.FormField.Items.Text));
            if not Assigned(ft) then
            begin
              FormUpdateFontList(cbC.FormField.Items.Text, cbC.FormField.Font);
              ft := SearchForFont(BuildInternalFontName(VerifyFontName(cbC.FormField.Font.Name), cbC.FormField.Font.Style), ShouldUseUnicodeFontForText(cbC.FormField.Items.Text));
            end;
            if Assigned(ft) then
            begin
              ApplyOutputFont(ft);
              FOutput.WriteString(FOutput.ConvertColorToString(cbC.FormField.Font.Color) + ' rg' + PDFLB);
              FOutput.WriteString(ft.RefName + ' ' + FOutput.ConvertFloatToString(fontSize) + ' Tf' + PDFLB);
              fontRef := ft.RefName;
              fontResRef := ft.Ref;
            end;
            FOutput.MoveTextTo(PointF(1, (h - cbC.FormField.Font.Size) / 2 + 1));
            FOutput.AddText(cbC.FormField.Items[cbC.FormField.ItemIndex]);
            FOutput.WriteString('ET' + PDFLB);
          end;
          FOutput.WriteString('Q' + PDFLB);
          FOutput.WriteString('EMC' + PDFLB);

          if fontResRef <> '' then
            adFlags := '/Type/XObject/Subtype/Form/Resources<</Font<<' + fontResRef + '>>/ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']'
          else
            adFlags := '/Type/XObject/Subtype/Form/Resources<</ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']';
        end
        else if x.XRefObject is TTMSFNCGeneralPDFLibFormFieldListBoxContent then
        begin
          lbC := x.XRefObject as TTMSFNCGeneralPDFLibFormFieldListBoxContent;
          w := lbC.FormField.Rect.Right - lbC.FormField.Rect.Left;
          h := lbC.FormField.Rect.Top - lbC.FormField.Rect.Bottom;
          fontSize := lbC.FormField.Font.Size;

          fontRef := '';
          ft := SearchForFont(BuildInternalFontName(VerifyFontName(lbC.FormField.Font.Name), lbC.FormField.Font.Style), ShouldUseUnicodeFontForText(lbC.FormField.Items.Text));
          if not Assigned(ft) then
          begin
            FormUpdateFontList(lbC.FormField.Items.Text, lbC.FormField.Font);
            ft := SearchForFont(BuildInternalFontName(VerifyFontName(lbC.FormField.Font.Name), lbC.FormField.Font.Style), ShouldUseUnicodeFontForText(lbC.FormField.Items.Text));
          end;
          if Assigned(ft) then
          begin
            ApplyOutputFont(ft);
            fontRef := ft.RefName;
            fontResRef := ft.Ref;
          end;

          FOutput.WriteString('/Tx BMC' + PDFLB);
          FOutput.WriteString('q' + PDFLB);
          FOutput.WriteRectangle(RectF(1, 1, w - 1, h - 1));
          FOutput.WriteString('W' + PDFLB);
          FOutput.WriteString('n' + PDFLB);
          if lbC.FormField.ItemIndex > 0 then
          begin
            FOutput.WriteString('0.9 g' + PDFLB);
            FOutput.WriteRectangle(RectF(1, h - (lbC.FormField.ItemIndex + 1) * fontSize * 1.2, w - 1, h - lbC.FormField.ItemIndex * fontSize * 1.2));
            FOutput.WriteString('f' + PDFLB);
            FOutput.WriteString('0 g' + PDFLB);
          end;
          for I := 0 to lbC.FormField.Items.Count - 1 do
          begin
            FOutput.WriteString('BT' + PDFLB);
            FOutput.WriteString('0 g' + PDFLB);
            if fontRef <> '' then
              FOutput.WriteString(fontRef + ' ' + FOutput.ConvertFloatToString(lbC.FormField.Font.Size) + ' Tf' + PDFLB);
            FOutput.MoveTextTo(PointF(1, h - (I + 1) * fontSize * 1.1));
            FOutput.AddText(lbC.FormField.Items[I]);
            FOutput.WriteString('ET' + PDFLB);
          end;
          FOutput.WriteString('Q' + PDFLB);
          FOutput.WriteString('EMC' + PDFLB);

          if fontResRef <> '' then
            adFlags := '/Type/XObject/Subtype/Form/Resources<</Font<<' + fontResRef + '>>/ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']'
          else
            adFlags := '/Type/XObject/Subtype/Form/Resources<</ProcSet[/PDF/Text]>>/BBox [0 0 ' + FOutput.ConvertFloatToString(w) + ' ' + FOutput.ConvertFloatToString(h) + ']';
        end;

        UpdateGlyphIds;
        ms := FOutput.FinishContentStream(PDFFormFieldContentRef, True, adFlags);
        if Assigned(ms) then
          FOutput.Streams.Add(ms);

        FOutput.StartNewStream;
        FOutput.WriteString(PDFLB);
        FOutput.WriteString('endstream' + PDFLB);
        FOutput.WriteString('endobj' + PDFLB);
      end;
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.WriteXRefTable;
var
  cnt: integer;
  x: TTMSFNCGeneralPDFLibXRefObject;
  {$IFDEF WEBLIB}
  i: Integer;
  {$ENDIF}
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  cnt := 0;
  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if x.InXRefList then
      Inc(cnt);
  end;

  FOutput.WriteString('xref' + PDFLB + '0 ' + IntToStr(cnt) + PDFLB);

  {$IFDEF WEBLIB}
  for i := 0 to FXRefObjects.Count - 1 do
  begin
    x := FXRefObjects[i];
    if x.InXRefList then
      FOutput.WriteString(x.GenerateXRefValue + PDFLB);
  end;
  {$ELSE}
  for x in FXRefObjects do
  begin
    if x.InXRefList then
      FOutput.WriteString(x.GenerateXRefValue + PDFLB);
  end;
  {$ENDIF}
end;

procedure TTMSFNCGeneralPDFLib.FinishPage;
var
  I: Integer;
  ft: TTMSFNCGeneralPDFLibFont;
  p: TTMSFNCGeneralPDFLibPattern;
  bmp: TTMSFNCGeneralPDFLibBitmap;
  ms: TStringStream;
  a: TTMSFNCGeneralPDFLibAnnotation;
  SearchValues: array of String;
  ReplaceValues: array of String;
  ReplaceIdx: Integer;
  ReplaceCount: Integer;
begin
  if FPageStarted then
  begin
    FPageStarted := False;
    ReplaceCount := FActivePage.FontList.Count + FActivePage.Patterns.Count +
      FActivePage.Bitmaps.Count + FActivePage.Annotations.Count;
    if ReplaceCount > 0 then
    begin
      SetLength(SearchValues, ReplaceCount);
      SetLength(ReplaceValues, ReplaceCount);
    end;
    ReplaceIdx := 0;

    for I := 0 to FActivePage.FontList.Count - 1 do
    begin
      ft := FActivePage.FontList[I];
      SearchValues[ReplaceIdx] := ft.RefNameOriginal;
      ReplaceValues[ReplaceIdx] := ft.RefName;
      Inc(ReplaceIdx);
    end;

    for I := 0 to FActivePage.Patterns.Count - 1 do
    begin
      p := FActivePage.Patterns[I];
      SearchValues[ReplaceIdx] := p.RefNameOriginal;
      ReplaceValues[ReplaceIdx] := p.RefName;
      Inc(ReplaceIdx);
    end;

    for I := 0 to FActivePage.Bitmaps.Count - 1 do
    begin
      bmp := FActivePage.Bitmaps[I];
      SearchValues[ReplaceIdx] := bmp.RefNameOriginal;
      ReplaceValues[ReplaceIdx] := bmp.RefName;
      Inc(ReplaceIdx);
    end;

    for I := 0 to FActivePage.Annotations.Count - 1 do
    begin
      a := FActivePage.Annotations[I];
      SearchValues[ReplaceIdx] := a.RefNameOriginal;
      ReplaceValues[ReplaceIdx] := a.RefName;
      Inc(ReplaceIdx);
    end;

    if ReplaceIdx > 0 then
    begin
      if ReplaceIdx <> Length(SearchValues) then
      begin
        SetLength(SearchValues, ReplaceIdx);
        SetLength(ReplaceValues, ReplaceIdx);
      end;
      FOutput.ReplaceStrings(SearchValues, ReplaceValues);
    end;

    ms := FOutput.FinishContentStream(PDFPageContentLengthRef, True);
    if Assigned(ms) then
      FOutput.Streams.Add(ms);
    FOutput.StartNewStream;
    FOutput.WriteString(PDFLB);
    FOutput.WriteString('endstream' + PDFLB);
    FOutput.WriteString('endobj' + PDFLB);
    FOutput.ClearProperties;
  end;
end;

procedure TTMSFNCGeneralPDFLib.FontChanged(Sender: TObject);
begin
  UpdateFontList(False);
end;

procedure TTMSFNCGeneralPDFLib.FormChoiceFieldChanged(Sender: TObject);
begin
  FormUpdateFontList((Sender as TTMSFNCGeneralPDFLibFormFieldChoice).Items.Text,
    (Sender as TTMSFNCGeneralPDFLibFormFieldChoice).Font);
end;

procedure TTMSFNCGeneralPDFLib.FormTextFieldChanged(Sender: TObject);
var
  tC: TTMSFNCGeneralPDFLibFormFieldTextContent;
begin
  FormUpdateFontList((Sender as TTMSFNCGeneralPDFLibFormFieldText).Text,
    (Sender as TTMSFNCGeneralPDFLibFormFieldText).Font);

  if ((Sender as TTMSFNCGeneralPDFLibFormFieldText).Text <> '') and not Assigned((Sender as TTMSFNCGeneralPDFLibFormFieldText).Content) then
  begin
    tC := TTMSFNCGeneralPDFLibFormFieldTextContent.Create(Self, (Sender as TTMSFNCGeneralPDFLibFormFieldText));
    FXRefObjects.AddObject(tC);
  end;
end;

procedure TTMSFNCGeneralPDFLib.FormUpdateFontList(AText: UnicodeString;
  AFont: TTMSFNCPDFGraphicsLibFont);
var
  ft: TTMSFNCPDFGraphicsLibFont;
  useUnicode: Boolean;
begin
  ft := TTMSFNCPDFGraphicsLibFont.Create;
  try
    ft.Assign(FPDFGraphicsLib.Font);
    FPDFGraphicsLib.Font.Assign(AFont);

    useUnicode := ShouldUseUnicodeFontForText(AText);
    if useUnicode then
    begin
      FOutput.NotifyUnicode(AText);
      FOutput.ConvertStringToHex(AText);
    end
    else
    begin
      FOutput.NotifyText(AText);
      FOutput.EscapeString(AText);
    end;

    FPDFGraphicsLib.Font.Assign(ft);
  finally
    ft.Free;
  end;
end;

function  TTMSFNCGeneralPDFLib.UnlockWithPassword(Password: String): Boolean;
begin
  Result := False;
end;

procedure TTMSFNCGeneralPDFLib.InitializeFontList;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  ftff: TTMSFNCGeneralPDFLibFontFile;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  if not Assigned(FOutput) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibFontFile then
      begin
        ftff := (x.XRefObject as TTMSFNCGeneralPDFLibFontFile);
        if not ftff.Font.Inactive then
          ftff.InitializeFontFile;
      end
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.InsertPage(PageIndex: Integer);
begin
  NewPage;
  if Assigned(FActivePage) then
    FActivePage.InsertPageNumber := PageIndex;
end;

function TTMSFNCGeneralPDFLib.IsDocumentOpened: Boolean;
begin
  Result := False;
end;

function TTMSFNCGeneralPDFLib.GetAcroFormFieldReferences: string;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  sb: TStringStream;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := '';
  sb := CreateStringStream;
  try
  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
      if (x.XRefObject is TTMSFNCGeneralPDFLibFormField) and not (x.XRefObject is TTMSFNCGeneralPDFLibFormFieldRadioButton) then
      begin
        sb.WriteString(IntToStr(FXRefObjects.IndexOf(x)));
        sb.WriteString(' 0 R ');
      end;
  end;

    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetAcroFormRef: string;
begin
  Result := '';
  if Assigned(FAcroForm) and Assigned(FAcroForm.XRefObject) then
    Result := IntToStr(FXRefObjects.IndexOf(FAcroForm.XRefObject));

  Result := Trim(Result);
end;

function TTMSFNCGeneralPDFLib.GetAllowsCopying: Boolean;
begin
  Result := AllowsCopying;
end;

function TTMSFNCGeneralPDFLib.GetAllowsPrinting: Boolean;
begin
  Result := AllowsPrinting;
end;

function TTMSFNCGeneralPDFLib.GetArtBox: TRectF;
begin
  Result := ArtBox;
end;

function TTMSFNCGeneralPDFLib.GetAuthor: String;
begin
  Result := Author;
end;

function TTMSFNCGeneralPDFLib.GetBitmapContainer: TTMSFNCBitmapContainer;
begin
  Result := nil;
  if Assigned(FPDFGraphicsLib) then
    Result := FPDFGraphicsLib.BitmapContainer;
end;

function TTMSFNCGeneralPDFLib.GetBleedBox: TRectF;
begin
  Result := BleedBox;
end;

function TTMSFNCGeneralPDFLib.GetContentRef(APage: TTMSFNCGeneralPDFLibPage): string;
begin
  Result := '';
  if Assigned(APage.Content) and Assigned(APage.Content.XRefObject) then
    Result := IntToStr(FXRefObjects.IndexOf(APage.Content.XRefObject));

  Result := Trim(Result);
end;

function TTMSFNCGeneralPDFLib.GetCreationDate: String;
begin
  Result := CreationDate;
end;

function TTMSFNCGeneralPDFLib.GetCreator: String;
begin
  Result := Creator;
end;

function TTMSFNCGeneralPDFLib.GetCropBox: TRectF;
begin
  Result := CropBox;
end;

procedure TTMSFNCGeneralPDFLib.GetDocumentInfo;
begin
end;

function TTMSFNCGeneralPDFLib.GetEmbedFonts: Boolean;
begin
  Result := EmbedFonts;
end;

function TTMSFNCGeneralPDFLib.GetFontFallBackList: TStrings;
begin
  Result := FontFallBackList;
end;

function TTMSFNCGeneralPDFLib.GetFontRefs(APage: TTMSFNCGeneralPDFLibPage): String;
var
  I: Integer;
  sb: TStringStream;
begin
  Result := '';
  if not Assigned(APage) then
    Exit;

  sb := CreateStringStream;
  try
    for I := 0 to APage.FontList.Count - 1 do
    begin
      if not APage.FontList[I].Inactive then
        sb.WriteString(APage.FontList[I].Ref);
    end;
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetAcroFormFontsRefs: string;
var
  refs: TStringList;
  I: Integer;
  ft: TTMSFNCGeneralPDFLibFont;
  sb: TStringStream;
begin
  Result := '';
  refs := TStringList.Create;
  sb := CreateStringStream;
  try
    refs.Sorted := True;
    refs.CaseSensitive := True;
    refs.Duplicates := dupIgnore;

    {$IFDEF WEBLIB}
    for I := 0 to FFontList.Count - 1 do
    begin
      ft := FFontList[I];
    {$ELSE}
    for ft in FFontList do
    begin
    {$ENDIF}
      if Assigned(ft) and not ft.Inactive then
        refs.Add(ft.Ref);
    end;

    for I := 0 to refs.Count - 1 do
    begin
      sb.WriteString(refs[I]);
      sb.WriteString(' ');
    end;

    Result := Trim(sb.DataString);
  finally
    sb.Free;
    refs.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetFooter: UnicodeString;
begin
  Result := Footer;
end;

function TTMSFNCGeneralPDFLib.GetFooterAlignment: TTMSFNCGraphicsTextAlign;
begin
  Result := FooterAlignment;
end;

function TTMSFNCGeneralPDFLib.GetFooterFont: TTMSFNCPDFGraphicsLibFont;
begin
  Result := FFooterFont;
end;

function TTMSFNCGeneralPDFLib.GetFooterMargins: TTMSFNCMargins;
begin
  Result := FooterMargins;
end;

function TTMSFNCGeneralPDFLib.GetFooterRect: TRectF;
begin
  Result := RectF(FMediaBox.Left + FFooterMargins.Left, FMediaBox.Bottom - FFooterSize - FFooterMargins.Bottom, FMediaBox.Right - FMediaBox.Left - FFooterMargins.Right, FMediaBox.Bottom - FFooterMargins.Bottom);
end;

function TTMSFNCGeneralPDFLib.GetFooterSize: Single;
begin
  Result := FooterSize;
end;

function TTMSFNCGeneralPDFLib.GetFormFieldAutosize: Boolean;
begin
  Result := FFormFieldGlobalAutoSize;
end;

function TTMSFNCGeneralPDFLib.GetFormFieldFont: TTMSFNCPDFGraphicsLibFont;
begin
  Result := FFormFieldGlobalFont;
end;

function TTMSFNCGeneralPDFLib.GetHeader: UnicodeString;
begin
  Result := Header;
end;

function TTMSFNCGeneralPDFLib.GetHeaderAlignment: TTMSFNCGraphicsTextAlign;
begin
  Result := HeaderAlignment;
end;

function TTMSFNCGeneralPDFLib.GetHeaderFont: TTMSFNCPDFGraphicsLibFont;
begin
  Result := FHeaderFont;
end;

function TTMSFNCGeneralPDFLib.GetHeaderMargins: TTMSFNCMargins;
begin
  Result := HeaderMargins;
end;

function TTMSFNCGeneralPDFLib.GetHeaderRect: TRectF;
begin
  Result := RectF(FMediaBox.Left + FHeaderMargins.Left, FMediaBox.Top + FHeaderMargins.Top, FMediaBox.Right - FMediaBox.Left - FHeaderMargins.Right, FMediaBox.Top + FHeaderMargins.Top + FHeaderSize);
end;

function TTMSFNCGeneralPDFLib.GetHeaderSize: Single;
begin
  Result := HeaderSize;
end;

function TTMSFNCGeneralPDFLib.GetPageNumberFormat: UnicodeString;
begin
  Result := PageNumberFormat;
end;

function TTMSFNCGeneralPDFLib.GetPageNumber: TTMSFNCPDFLibPageNumber;
begin
  Result := PageNumber;
end;

function TTMSFNCGeneralPDFLib.GetPageNumberAlignment: TTMSFNCGraphicsTextAlign;
begin
  Result := PageNumberAlignment;
end;

function TTMSFNCGeneralPDFLib.GetPageNumberFont: TTMSFNCPDFGraphicsLibFont;
begin
  Result := FPageNumberFont;
end;

function TTMSFNCGeneralPDFLib.GetPageNumberMargins: TTMSFNCMargins;
begin
  Result := PageNumberMargins;
end;

function TTMSFNCGeneralPDFLib.GetPageNumberRect: TRectF;
begin
  Result := RectF(0, 0, 0, 0);
  case PageNumber of
    pnHeader: Result := RectF(FMediaBox.Left + FPageNumberMargins.Left, FMediaBox.Top + FPageNumberMargins.Top, FMediaBox.Right - FMediaBox.Left - FPageNumberMargins.Right, FMediaBox.Top + FPageNumberMargins.Top + FPageNumberSize);
    pnFooter: Result := RectF(FMediaBox.Left + FPageNumberMargins.Left, FMediaBox.Bottom - FPageNumberSize - FPageNumberMargins.Bottom, FMediaBox.Right - FMediaBox.Left - FPageNumberMargins.Right, FMediaBox.Bottom - FPageNumberMargins.Bottom);
  end;
end;

function TTMSFNCGeneralPDFLib.GetPageNumberSize: Single;
begin
  Result := PageNumberSize;
end;

function TTMSFNCGeneralPDFLib.GetKeywordsString: string;
var
  s: string;
  sb: TStringStream;
begin
  Result := '';
  sb := CreateStringStream;
  try
    for s in FKeywords do
    begin
      sb.WriteString(s);
      sb.WriteString(' ');
    end;
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetKeywords: TStrings;
begin
  Result := Keywords;
end;

function TTMSFNCGeneralPDFLib.GetMediaBox: TRectF;
begin
  Result := MediaBox;
end;

function TTMSFNCGeneralPDFLib.GetModificationDate: string;
begin
  Result := ModificationDate;
end;

function TTMSFNCGeneralPDFLib.GetOnAfterDrawFooter: TTMSFNCPDFLibAfterDrawFooterEvent;
begin
  Result := FOnAfterDrawFooter;
end;

function TTMSFNCGeneralPDFLib.GetOnAfterDrawHeader: TTMSFNCPDFLibAfterDrawHeaderEvent;
begin
  Result := FOnAfterDrawHeader;
end;

function TTMSFNCGeneralPDFLib.GetOnAfterDrawPageNumber: TTMSFNCPDFLibAfterDrawPageNumberEvent;
begin
  Result := FOnAfterDrawPageNumber;
end;

function TTMSFNCGeneralPDFLib.GetOnBeforeDrawFooter: TTMSFNCPDFLibBeforeDrawFooterEvent;
begin
  Result := FOnBeforeDrawFooter;
end;

function TTMSFNCGeneralPDFLib.GetOnBeforeDrawHeader: TTMSFNCPDFLibBeforeDrawHeaderEvent;
begin
  Result := FOnBeforeDrawHeader
end;

function TTMSFNCGeneralPDFLib.GetOnBeforeDrawPageNumber: TTMSFNCPDFLibBeforeDrawPageNumberEvent;
begin
  Result := FOnBeforeDrawPageNumber
end;

function TTMSFNCGeneralPDFLib.GetOnNewPageStarted: TTMSFNCPDFLibNewPageStartedEvent;
begin
  Result := FOnNewPageStarted;
end;

function TTMSFNCGeneralPDFLib.GetDestOutputProfileRef: String;
begin
  Result := '';
  if Assigned(FDestOutputProfile) and Assigned(FDestOutputProfile.XRefObject) then
    Result := IntToStr(FXRefObjects.IndexOf(FDestOutputProfile.XRefObject));

  Result := Trim(Result);
end;

function TTMSFNCGeneralPDFLib.GetOwnerPassword: String;
begin
  Result := OwnerPassword;
end;

function TTMSFNCGeneralPDFLib.GetPageCount: Integer;
begin
  Result := FPageCount;
end;

function TTMSFNCGeneralPDFLib.GetPageHeight: Single;
begin
  Result := FPageHeight;
end;

function TTMSFNCGeneralPDFLib.GetPageIndex: Integer;
begin
  Result := 0;
  if Assigned(FActivePage) then
    Result := FActivePage.PageNumber;
end;

procedure TTMSFNCGeneralPDFLib.GetPageInfo(PageIndex: Integer);
begin
end;

function TTMSFNCGeneralPDFLib.GetPageOrientation: TTMSFNCPDFLibPageOrientation;
begin
  Result := Orientation;
end;

function TTMSFNCGeneralPDFLib.GetPageByIndex(APageIndex: Integer): TTMSFNCGeneralPDFLibPage;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := nil;
  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if x.XRefObject is TTMSFNCGeneralPDFLibPage then
      begin
        if (x.XRefObject as TTMSFNCGeneralPDFLibPage).PageNumber = APageIndex then
        begin
          Result := (x.XRefObject as TTMSFNCGeneralPDFLibPage);
          Break;
        end;
      end;
    end;
  end;
end;

function TTMSFNCGeneralPDFLib.GetPageRef(APage: TTMSFNCGeneralPDFLibPage): string;
begin
  Result := '';
  if Assigned(APage) and Assigned(APage.XRefObject) then
    Result := IntToStr(FXRefObjects.IndexOf(APage.XRefObject));

  Result := Trim(Result);
end;

function ComparePageNumbers(const Item1, Item2: TTMSFNCGeneralPDFLibPage): Integer;
begin
  Result := CompareValue(Item1.InsertPageNumber, Item2.InsertPageNumber);
end;

function TTMSFNCGeneralPDFLib.GetPageReferences: String;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  l: TTMSFNCGeneralPDFLibPageList;
  I: Integer;
  sb: TStringStream;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := '';

  l := TTMSFNCGeneralPDFLibPageList.Create;
  try
    {$IFDEF WEBLIB}
    for v in FXRefObjects do
    begin
      x := TTMSFNCGeneralPDFLibXRefObject(v);
    {$ELSE}
    for x in FXRefObjects do
    begin
    {$ENDIF}
      if Assigned(x.XRefObject) then
        if x.XRefObject is TTMSFNCGeneralPDFLibPage then
          l.Add(x.XRefObject as TTMSFNCGeneralPDFLibPage);
    end;

    {$IFNDEF LCLWEBLIB}
    l.Sort(FComparePageNumbers);
    {$ENDIF}
    {$IFDEF LCLWEBLIB}
    {$IFDEF LCLLIB}
    l.Sort(@ComparePageNumbers);
    {$ENDIF}
    {$IFNDEF LCLLIB}
    l.Sort(TListSortCompare(@ComparePageNumbers));
    {$ENDIF}
    {$ENDIF}

    sb := CreateStringStream;
    try
    for I := 0 to l.Count - 1 do
      begin
        sb.WriteString(IntToStr(FXRefObjects.IndexOf(l[I].XRefObject)));
        sb.WriteString(' 0 R ');
      end;

      Result := Trim(sb.DataString);
    finally
      sb.Free;
    end;
  finally
    l.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetPageSize: TTMSFNCPDFLibPageSize;
begin
  Result := PageSize;
end;

function TTMSFNCGeneralPDFLib.GetPageWidth: Single;
begin
  Result := FPageWidth;
end;

function TTMSFNCGeneralPDFLib.GetShadingRef(APage: TTMSFNCGeneralPDFLibPage): string;
var
  I: Integer;
  sb: TStringStream;
begin
  Result := '';
  if not Assigned(APage) then
    Exit;

  sb := CreateStringStream;
  try
    for I := 0 to APage.Shadings.Count - 1 do
      sb.WriteString(APage.Shadings[I].Ref);
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetAnnotationsRef(APage: TTMSFNCGeneralPDFLibPage): string;
var
  I: Integer;
  sb: TStringStream;
begin
  Result := '';
  if not Assigned(APage) then
    Exit;

  sb := CreateStringStream;
  try
    for I := 0 to APage.Annotations.Count - 1 do
    begin
      sb.WriteString(APage.Annotations[I].Ref);
      sb.WriteString(' ');
    end;
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetPatternRef(APage: TTMSFNCGeneralPDFLibPage): string;
var
  I: Integer;
  sb: TStringStream;
begin
  Result := '';
  if not Assigned(APage) then
    Exit;

  sb := CreateStringStream;
  try
    for I := 0 to APage.Patterns.Count - 1 do
      sb.WriteString(APage.Patterns[I].Ref);
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetPDFGraphicsExLib: ITMSFNCCustomPDFGraphicsExLib;
begin
  Result := FPDFGraphicsExLib;
end;

function TTMSFNCGeneralPDFLib.GetPDFGraphicsLib: ITMSFNCCustomPDFGraphicsLib;
begin
  Result := FPDFGraphicsLib;
end;

function TTMSFNCGeneralPDFLib.GetPDFInitializationLib: ITMSFNCCustomPDFInitializationLib;
begin
  Result := FPDFInitializationLib;
end;

function TTMSFNCGeneralPDFLib.GetPDFStandard: TTMSFNCPDFLibStandard;
begin
  Result := PDFStandard;
end;

function TTMSFNCGeneralPDFLib.GetProducer: String;
begin
  Result := Producer;
end;

function TTMSFNCGeneralPDFLib.GetRadioButtonParentRef(
  ARadioButton: TTMSFNCGeneralPDFLibFormFieldRadioButton): string;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := '';
  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if (x.XRefObject is TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup) then
      begin
        if (x.XRefObject as TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup).GroupID = ARadioButton.GroupID then
        begin
          Result := IntToStr(FXRefObjects.IndexOf(x)) + ' 0 R';
          Exit;
        end;
      end;
    end;
  end;

  Result := Trim(Result);
end;

function TTMSFNCGeneralPDFLib.GetRadioGroupCheckedValueRef(
  AGroup: TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup): string;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := '';
  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if (x.XRefObject is TTMSFNCGeneralPDFLibFormFieldRadioButton) then
      begin
        if (x.XRefObject as TTMSFNCGeneralPDFLibFormFieldRadioButton).GroupID = AGroup.GroupID then
        begin
          if (x.XRefObject as TTMSFNCGeneralPDFLibFormFieldRadioButton).IsChecked then
          begin
            Result := (x.XRefObject as TTMSFNCGeneralPDFLibFormFieldRadioButton).PartialName;
            Break;
          end;
        end;
      end;
    end;
  end;

  Result := Trim(Result);
end;

function TTMSFNCGeneralPDFLib.GetRadioGroupReferences(
  AGroup: TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup): string;
var
  x: TTMSFNCGeneralPDFLibXRefObject;
  sb: TStringStream;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := '';
  sb := CreateStringStream;
  try
  {$IFDEF WEBLIB}
  for v in FXRefObjects do
  begin
    x := TTMSFNCGeneralPDFLibXRefObject(v);
  {$ELSE}
  for x in FXRefObjects do
  begin
  {$ENDIF}
    if Assigned(x.XRefObject) then
    begin
      if (x.XRefObject is TTMSFNCGeneralPDFLibFormFieldRadioButton) then
      begin
        if (x.XRefObject as TTMSFNCGeneralPDFLibFormFieldRadioButton).GroupID = AGroup.GroupID then
        begin
          sb.WriteString(IntToStr(FXRefObjects.IndexOf(x)));
          sb.WriteString(' 0 R ');
        end;
      end;
    end;
  end;

    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLib.GetSubject: String;
begin
  Result := Subject;
end;

function TTMSFNCGeneralPDFLib.GetTitle: String;
begin
  Result := Title;
end;

function TTMSFNCGeneralPDFLib.GetTrimBox: TRectF;
begin
  Result := TrimBox;
end;

function TTMSFNCGeneralPDFLib.GetUserPassword: String;
begin
  Result := UserPassword;
end;

function TTMSFNCGeneralPDFLib.GetXObjectRefs(APage: TTMSFNCGeneralPDFLibPage): string;
var
  I: Integer;
  sb: TStringStream;
begin
  Result := '';
  if not Assigned(APage) then
    Exit;

  sb := CreateStringStream;
  try
    for I := 0 to APage.XObjectList.Count - 1 do
      sb.WriteString(APage.XObjectList[I].Ref);
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

procedure TTMSFNCGeneralPDFLib.SaveDocumentFromStream(FileStream: TMemoryStream;
  FileName: String);
begin
end;

procedure TTMSFNCGeneralPDFLib.CacheFont(const AFont: TTMSFNCGeneralPDFLibFont);
var
  idx: Integer;
  key: string;
begin
  if not Assigned(FFontLookupCache) or not Assigned(AFont) then
    Exit;

  key := GetFontCacheKey(AFont.Name, AFont.Unicode);
  idx := FFontLookupCache.IndexOf(key);
  if idx > -1 then
    FFontLookupCache.Objects[idx] := AFont
  else
    FFontLookupCache.AddObject(key, AFont);
end;

procedure TTMSFNCGeneralPDFLib.ClearFontCache;
begin
  if Assigned(FFontLookupCache) then
    FFontLookupCache.Clear;
end;

function TTMSFNCGeneralPDFLib.GetCachedFont(const ABaseFontName: string;
  AUnicodeFont: Boolean): TTMSFNCGeneralPDFLibFont;
var
  idx: Integer;
begin
  Result := nil;
  if not Assigned(FFontLookupCache) then
    Exit;

  idx := FFontLookupCache.IndexOf(GetFontCacheKey(ABaseFontName, AUnicodeFont));
  if idx > -1 then
    Result := TTMSFNCGeneralPDFLibFont(FFontLookupCache.Objects[idx]);

  if Assigned(Result) and (Result.Inactive or (Result.Name <> ABaseFontName) or
    (Result.Unicode <> AUnicodeFont) or (FFontList.IndexOf(Result) = -1)) then
  begin
    FFontLookupCache.Delete(idx);
    Result := nil;
  end;
end;

function TTMSFNCGeneralPDFLib.GetFontCacheKey(const ABaseFontName: string;
  AUnicodeFont: Boolean): string;
begin
  if AUnicodeFont then
    Result := '1|' + ABaseFontName
  else
    Result := '0|' + ABaseFontName;
end;

function TTMSFNCGeneralPDFLib.BuildInternalFontName(const AFontName: string;
  const AFontStyle: TFontStyles): string;
begin
  Result := StringReplace(AFontName, ' ', '', [rfReplaceAll]);
  if (TFontStyle.fsBold in AFontStyle) and (TFontStyle.fsItalic in AFontStyle) then
    Result := Result + ',BoldItalic'
  else if TFontStyle.fsBold in AFontStyle then
    Result := Result + ',Bold'
  else if TFontStyle.fsItalic in AFontStyle then
    Result := Result + ',Italic';
end;

function TTMSFNCGeneralPDFLib.ShouldUseUnicodeFontForText(
  const AText: UnicodeString): Boolean;
begin
  Result := Assigned(FOutput) and FOutput.IsUnicodeString(AText);
end;

procedure TTMSFNCGeneralPDFLib.RemoveCachedFont(
  const AFont: TTMSFNCGeneralPDFLibFont);
var
  i: Integer;
begin
  if not Assigned(FFontLookupCache) or not Assigned(AFont) then
    Exit;

  for i := FFontLookupCache.Count - 1 downto 0 do
  begin
    if FFontLookupCache.Objects[i] = AFont then
      FFontLookupCache.Delete(i);
  end;
end;

function TTMSFNCGeneralPDFLib.SearchForFont(ABaseFontName: string; AUnicodeFont: Boolean): TTMSFNCGeneralPDFLibFont;
var
  ft: TTMSFNCGeneralPDFLibFont;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := GetCachedFont(ABaseFontName, AUnicodeFont);
  if Assigned(Result) then
    Exit;

  {$IFDEF WEBLIB}
  for v in FFontList do
  begin
    ft := TTMSFNCGeneralPDFLibFont(v);
  {$ELSE}
  for ft in FFontList do
  begin
  {$ENDIF}
    if not ft.Inactive and (ft.Name = ABaseFontName) and (ft.Unicode = AUnicodeFont) then
    begin
      Result := ft;
      Break;
    end;
  end;

  if Assigned(Result) then
    CacheFont(Result);
end;

procedure TTMSFNCGeneralPDFLib.SetAllowsCopying(const Value: Boolean);
begin
  AllowsCopying := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetAllowsPrinting(const Value: Boolean);
begin
  AllowsPrinting := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetArtBox(const Value: TRectF);
begin
  ArtBox := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetAuthor(const Value: String);
begin
  Author := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetBitmapContainer(
  const Value: TTMSFNCBitmapContainer);
begin
  if Assigned(FPDFGraphicsLib) then
    FPDFGraphicsLib.BitmapContainer := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetBleedBox(const Value: TRectF);
begin
  BleedBox := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetCreator(const Value: String);
begin
  Creator := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetCropBox(const Value: TRectF);
begin
  CropBox := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetEmbedFonts(const Value: Boolean);
begin
  EmbedFonts := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetFontFallBackList(const Value: TStrings);
begin
  FontFallBackList.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetFooter(const Value: UnicodeString);
begin
  Footer := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetFooterAlignment(const Value: TTMSFNCGraphicsTextAlign);
begin
  FooterAlignment := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetFooterFont(
  const Value: TTMSFNCPDFGraphicsLibFont);
begin
  FFooterFont.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetFooterMargins(const Value: TTMSFNCMargins);
begin
  FooterMargins.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetFooterSize(const Value: Single);
begin
  FooterSize := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetFormFieldAutoSize(const Value: Boolean);
begin
  FFormFieldGlobalAutoSize := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetFormFieldFont(
  const Value: TTMSFNCPDFGraphicsLibFont);
begin
  FFormFieldGlobalFont.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetPDFGraphicsExLib(
  const Value: ITMSFNCCustomPDFGraphicsExLib);
begin
  FPDFGraphicsExLib := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPDFGraphicsLib(
  const Value: ITMSFNCCustomPDFGraphicsLib);
begin
  FPDFGraphicsLib := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPDFInitializationLib(
  const Value: ITMSFNCCustomPDFInitializationLib);
begin
  FPDFInitializationLib := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPDFStandard(
  const Value: TTMSFNCPDFLibStandard);
begin
  PDFStandard := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetHeader(const Value: UnicodeString);
begin
  FHeader := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetHeaderAlignment(const Value: TTMSFNCGraphicsTextAlign);
begin
  HeaderAlignment := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetHeaderFont(
  const Value: TTMSFNCPDFGraphicsLibFont);
begin
  FHeaderFont.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetHeaderMargins(const Value: TTMSFNCMargins);
begin
  HeaderMargins.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetHeaderSize(const Value: Single);
begin
  HeaderSize := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPageNumberFormat(const Value: UnicodeString);
begin
  FPageNumberFormat := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPageNumber(const Value: TTMSFNCPDFLibPageNumber);
begin
  FPageNumber := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPageNumberAlignment(const Value: TTMSFNCGraphicsTextAlign);
begin
  FPageNumberAlignment := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPageNumberFont(
  const Value: TTMSFNCPDFGraphicsLibFont);
begin
  FPageNumberFont.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetPageNumberMargins(const Value: TTMSFNCMargins);
begin
  FPageNumberMargins.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetPageNumberSize(const Value: Single);
begin
  FPageNumberSize := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetKeywords(const Value: TStrings);
begin
  Keywords.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLib.SetMediaBox(const Value: TRectF);
begin
  MediaBox := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOnAfterDrawFooter(
  const Value: TTMSFNCPDFLibAfterDrawFooterEvent);
begin
  FOnAfterDrawFooter := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOnAfterDrawHeader(
  const Value: TTMSFNCPDFLibAfterDrawHeaderEvent);
begin
  FOnAfterDrawHeader := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOnAfterDrawPageNumber(
  const Value: TTMSFNCPDFLibAfterDrawPageNumberEvent);
begin
  FOnAfterDrawPageNumber := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOnBeforeDrawFooter(
  const Value: TTMSFNCPDFLibBeforeDrawFooterEvent);
begin
  FOnBeforeDrawFooter := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOnBeforeDrawHeader(
  const Value: TTMSFNCPDFLibBeforeDrawHeaderEvent);
begin
  FOnBeforeDrawHeader := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOnBeforeDrawPageNumber(
  const Value: TTMSFNCPDFLibBeforeDrawPageNumberEvent);
begin
  FOnBeforeDrawPageNumber := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOnNewPageStarted(
  const Value: TTMSFNCPDFLibNewPageStartedEvent);
begin
  FOnNewPageStarted := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetOwnerPassword(const Value: String);
begin
  OwnerPassword := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetPageHeight(const Value: Single);
begin
  FPageHeight := Value;
  UpdateBoxRect;
end;

procedure TTMSFNCGeneralPDFLib.SetPageOrientation(
  const Value: TTMSFNCPDFLibPageOrientation);
begin
  Orientation := Value;
  UpdateBoxRect;
end;

procedure TTMSFNCGeneralPDFLib.SetPageSize(
  const Value: TTMSFNCPDFLibPageSize);
begin
  PageSize := Value;
  UpdateBoxRect;
end;

procedure TTMSFNCGeneralPDFLib.SetPageWidth(const Value: Single);
begin
  FPageWidth := Value;
  UpdateBoxRect;
end;

procedure TTMSFNCGeneralPDFLib.SetSubject(const Value: String);
begin
  Subject := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetTitle(const Value: String);
begin
  Title := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetTrimBox(const Value: TRectF);
begin
  TrimBox := Value;
end;

procedure TTMSFNCGeneralPDFLib.SetUserPassword(const Value: String);
begin
  UserPassword := Value;
end;

procedure TTMSFNCGeneralPDFLib.UpdateBoxRect;
var
  w, h: Single;
  g: ITMSFNCCustomPDFInitializationLib;
begin
  case PageSize of
    psA0: FMediaBox := RectF(0, 0, 2384, 3370);
    psA1: FMediaBox := RectF(0, 0, 1684, 2384);
    psA2: FMediaBox := RectF(0, 0, 1190, 1684);
    psA3: FMediaBox := RectF(0, 0, 842, 1190);
    psA4: FMediaBox := RectF(0, 0, 595, 842);
    psA5: FMediaBox := RectF(0, 0, 420, 595);
    psA6: FMediaBox := RectF(0, 0, 298, 420);
    psA7: FMediaBox := RectF(0, 0, 210, 298);
    psA8: FMediaBox := RectF(0, 0, 148, 210);
    psB0: FMediaBox := RectF(0, 0, 2835, 4008);
    psB1: FMediaBox := RectF(0, 0, 2004, 2835);
    psB2: FMediaBox := RectF(0, 0, 1417, 2004);
    psB3: FMediaBox := RectF(0, 0, 1001, 1417);
    psB4: FMediaBox := RectF(0, 0, 709, 1001);
    psB5: FMediaBox := RectF(0, 0, 499, 709);
    psB6: FMediaBox := RectF(0, 0, 354, 499);
    psB7: FMediaBox := RectF(0, 0, 249, 354);
    psB8: FMediaBox := RectF(0, 0, 176, 249);
    psB9: FMediaBox := RectF(0, 0, 125, 176);
    psB10: FMediaBox := RectF(0, 0, 88, 125);
    psC2: FMediaBox := RectF(0, 0, 1837, 578);
    psC3: FMediaBox := RectF(0, 0, 578, 919);
    psC4: FMediaBox := RectF(0, 0, 919, 649);
    psC5: FMediaBox := RectF(0, 0, 649, 459);
    psC6: FMediaBox := RectF(0, 0, 459, 323);
    psD0: FMediaBox := RectF(0, 0, 3090, 2186);
    psSRA0: FMediaBox := RectF(0, 0, 3628, 2551);
    psSRA1: FMediaBox := RectF(0, 0, 2551, 1814);
    psSRA2: FMediaBox := RectF(0, 0, 1814, 1276);
    psSRA3: FMediaBox := RectF(0, 0, 1276, 907);
    psSRA4: FMediaBox := RectF(0, 0, 907, 638);
    psRA0: FMediaBox := RectF(0, 0, 3458, 2438);
    psRA1: FMediaBox := RectF(0, 0, 2438, 1729);
    psRA2: FMediaBox := RectF(0, 0, 1729, 1219);
    psLetter: FMediaBox := RectF(0, 0, 612, 792);
    psLegal: FMediaBox := RectF(0, 0, 612, 1008);
    psLedger: FMediaBox := RectF(0, 0, 792, 1224);
    psTabloid: FMediaBox := RectF(0, 0, 1224, 792);
    psExecutive: FMediaBox := RectF(0, 0, 522, 756);
    psANSIC: FMediaBox := RectF(0, 0, 1584, 1224);
    psANSID: FMediaBox := RectF(0, 0, 2448, 1584);
    psANSIE: FMediaBox := RectF(0, 0, 3168, 2448);
    psFoolscap: FMediaBox := RectF(0, 0, 954, 1188);
    psSmallPost: FMediaBox := RectF(0, 0, 1044, 1332);
    psSheetAnd13Cap: FMediaBox := RectF(0, 0, 954, 1584);
    psSheetAnd12Cap: FMediaBox := RectF(0, 0, 954, 1782);
    psDemy: FMediaBox := RectF(0, 0, 1116, 1440);
    psLargePost: FMediaBox := RectF(0, 0, 1188, 1512);
    psSmallmedium: FMediaBox := RectF(0, 0, 1260, 1584);
    psMedium: FMediaBox := RectF(0, 0, 1296, 1656);
    psSmallRoyal: FMediaBox := RectF(0, 0, 1368, 1728);
    psRoyal: FMediaBox := RectF(0, 0, 1440, 1800);
    psImperial: FMediaBox := RectF(0, 0, 1584, 2160);
    psMetricCrownQuarto: FMediaBox := RectF(0, 0, 536, 697);
    psMetricCrownOctavo: FMediaBox := RectF(0, 0, 349, 527);
    psMetricLargeCrownQuarto: FMediaBox := RectF(0, 0, 570, 731);
    psMetricLargeCrownOctavo: FMediaBox := RectF(0, 0, 366, 561);
    psMetricDemyQuarto: FMediaBox := RectF(0, 0, 621, 782);
    psMetricDemyOctavo: FMediaBox := RectF(0, 0, 391, 612);
    psMetricRoyalQuarto: FMediaBox := RectF(0, 0, 672, 884);
    psMetricRoyalOctavo: FMediaBox := RectF(0, 0, 366, 561);
    psCustom: FMediaBox := RectF(0, 0, PageWidth, PageHeight);
  end;

  if FPageOrientation = poLandscape then
  begin
    w := FMediaBox.Right - FMediaBox.Left;
    h := FMediaBox.Bottom - FMediaBox.Top;
    FMediaBox.Bottom := FMediaBox.Top + w;
    FMediaBox.Right := FMediaBox.Left + h;
  end;

  FCropBox := FMediaBox;
  FBleedBox := FMediaBox;
  FArtBox := FMediaBox;
  FTrimBox := FMediaBox;

  g := FPDFInitializationLib;
  if Assigned(g) then
  begin
    g.SetPageWidth(MediaBox.Right - MediaBox.Left);
    g.SetPageHeight(MediaBox.Bottom - MediaBox.Top);
  end;
end;

procedure TTMSFNCGeneralPDFLib.UpdateFontList(ASearchForUnicodeFont: Boolean = False);
var
  g: ITMSFNCCustomPDFGraphicsLib;
  r: TTMSFNCGeneralPDFLibXRefObject;
  ft: TTMSFNCGeneralPDFLibFont;
  ftd: TTMSFNCGeneralPDFLibFontDescriptor;
  ftff: TTMSFNCGeneralPDFLibFontFile;
  ftu: TTMSFNCGeneralPDFLibFontUnicode;
  ftds: TTMSFNCGeneralPDFLibFontDescendant;
  fontn: string;
  fontb: string;
  fonti: string;
  tm: TTMSFNCGeneralPDFLibFontMetrics;
begin
  if FBlockFontUpdate then
    Exit;

  g := FPDFGraphicsLib;
  if Assigned(g) and Assigned(FOutput) then
  begin
    fontn := VerifyFontName(g.Font.Name);
    fontb := StringReplace(fontn, ' ', '', [rfReplaceAll]);
    fonti := BuildInternalFontName(fontn, g.Font.Style);
    FBlockFontUpdate := True;
    g.Font.Name := fontn;
    FBlockFontUpdate := False;

    if (FOutput.FontBase <> fontb) or (FOutput.FontStyle <> g.Font.Style) or ASearchForUnicodeFont or
      ((FOutput.FontUnicode and not ASearchForUnicodeFont) and
      (not Assigned(FActiveFont) or (FActiveFont.FontProgramType <> fptOpenTypeCFF))) then
    begin
      FOutput.FontBase := fontb;
      FOutput.FontName := fonti;

      ft := SearchForFont(FOutput.FontName, ASearchForUnicodeFont);

      if not Assigned(ft) then
      begin
        ft := TTMSFNCGeneralPDFLibFont.Create(Self, FInitializer, fontn, FOutput.FontName, g.Font.Size, g.Font.Style);
        ft.Unicode := ASearchForUnicodeFont;
        FXRefObjects.AddObject(ft);
        FFontList.Add(ft);
        tm := ft.Initializer.GetFontMetrics;
        ft.Initializer.IsFixedWidth := tm.Fixed;
        ft.Initializer.InitializeCharWidths;
        tm := ft.Initializer.GetFontMetrics;
        ft.Ascent := tm.Ascent;
        ft.CapHeight := tm.CapHeight;
        ft.ItalicAngle := tm.ItalicAngle;
        ft.Descent := tm.Descent;
        ft.Box := tm.FontBox;
        ft.TrueType := tm.TrueType;
        ft.FontProgramType := tm.FontProgramType;
        ft.UnitsPerEm := ft.Initializer.GetUnitsPerEm;
        ft.RefNameOriginal := Format(PDFPageFontTextRef, [ft.RefNameNotEscaped]);
        ft.RefNameGlyphOriginal := Format(PDFPageFontGlyphTextRef, [ft.RefNameNotEscaped]);
        CacheFont(ft);
      end;

      if not Assigned(ft.FontDescriptor) then
      begin
        ftd := TTMSFNCGeneralPDFLibFontDescriptor.Create(Self, ft);
        r := FXRefObjects.AddObject(ftd);
        r.XRefType := 'n';
        ft.FontDescriptor := ftd;
      end;

      if not Assigned(ft.FontUnicode) and (ft.Unicode or (ft.FontProgramType = fptOpenTypeCFF)) then
      begin        
        ftu := TTMSFNCGeneralPDFLibFontUnicode.Create(Self, ft);
        r := FXRefObjects.AddObject(ftu);
        r.XRefType := 'n';
        ft.FontUnicode := ftu;
      end;

      if not Assigned(ft.FontDescendant) and (ft.Unicode or (ft.FontProgramType = fptOpenTypeCFF)) then
      begin        
        ftds := TTMSFNCGeneralPDFLibFontDescendant.Create(Self, ft);
        r := FXRefObjects.AddObject(ftds);
        r.XRefType := 'n';
        ft.FontDescendant := ftds;
      end;

      if not Assigned(ft.FontFile) and EmbedFonts and (ft.FontProgramType <> fptUnknown) then
      begin
        ftff := TTMSFNCGeneralPDFLibFontFile.Create(Self, ft);
        r := FXRefObjects.AddObject(ftff);
        r.XRefType := 'n';
        ft.FontFile := ftff;
      end;
    end
    else
      ft := SearchForFont(FOutput.FontName, ASearchForUnicodeFont);

    FActiveFont := ft;

    if Assigned(ft) and Assigned(FActivePage) and (FActivePage.FontList.IndexOf(ft) = -1) then
      FActivePage.FontList.Add(ft);

    if Assigned(ft) then
    begin
      FOutput.FontCapHeight := ft.CapHeight;
      FOutput.FontUnitsPerEm := ft.UnitsPerEm;
    end
    else
    begin
      FOutput.FontCapHeight := 0;
      FOutput.FontUnitsPerEm := 0;
    end;

    FOutput.FontSize := g.Font.Size;
    FOutput.FontColor := g.Font.Color;
    FOutput.FontStyle := g.Font.Style;
    FOutput.FontLeading := g.Font.Size;
    FOutput.FontWordSpacing := 0;
    FOutput.FontCharSpacing := 0;
    FOutput.FontUnicode := Assigned(ft) and (ft.Unicode or (ft.FontProgramType = fptOpenTypeCFF));
    FOutput.FontEmbedding := EmbedFonts;
    if Assigned(ft) then
    begin
      FOutput.FontRefName := ft.RefNameOriginal;
      FOutput.FontGlyphRefName := ft.RefNameGlyphOriginal;
      FOutput.FontCharWidths := ft.CharWidths;
      FOutput.FontCharArray := ft.CharArray;
      FOutput.FontUsedCharArray := ft.UsedCharArray;
    end;
  end;
end;

procedure TTMSFNCGeneralPDFLib.UpdateGlyphIds;
{$IFDEF WEBLIB}
var
  I, J, Idx, ReplaceIdx, ReplaceCount: Integer;
  SearchValues: array of String;
  ReplaceValues: array of String;
  ft: TTMSFNCGeneralPDFLibFont;
{$ENDIF}
begin
  {$IFDEF WEBLIB}
  if EmbedFonts and Assigned(FFontList) then
  begin
    ReplaceCount := 0;
    for I := 0 to FFontList.Count - 1 do
    begin
      ft := FFontList[I];
      if ft.Inactive or (ft.UsedCharArray.Count = 0) then
        Continue;
      for J := 0 to ft.UsedCharArray.Count - 1 do
      begin
        idx := ft.CharArray.IndexOf(ft.UsedCharArray[J]);
        if (idx > -1) and (idx < Length(ft.CharWidths)) then
          Inc(ReplaceCount);
      end;
    end;

    if ReplaceCount = 0 then
      Exit;

    SetLength(SearchValues, ReplaceCount);
    SetLength(ReplaceValues, ReplaceCount);
    ReplaceIdx := 0;
    for I := 0 to FFontList.Count - 1 do
    begin
      ft := FFontList[I];
      if ft.Inactive or (ft.UsedCharArray.Count = 0) then
        Continue;
      for J := 0 to ft.UsedCharArray.Count - 1 do
      begin
        idx := ft.CharArray.IndexOf(ft.UsedCharArray[J]);
        if (idx > -1) and (idx < Length(ft.CharWidths)) then
        begin
          SearchValues[ReplaceIdx] := Format(PDFPageFontGlyphRef, [IntToStr(ft.UsedCharArray[J]), ft.RefNameGlyphOriginal]);
          ReplaceValues[ReplaceIdx] := FOutput.AddHex4(ft.CharWidths[idx].g);
          Inc(ReplaceIdx);
        end;
      end;
    end;

    if ReplaceIdx > 0 then
    begin
      if ReplaceIdx <> Length(SearchValues) then
      begin
        SetLength(SearchValues, ReplaceIdx);
        SetLength(ReplaceValues, ReplaceIdx);
      end;
      FOutput.ReplaceStrings(SearchValues, ReplaceValues);
    end;
  end;
  {$ENDIF}
end;

function TTMSFNCGeneralPDFLib.VerifyFontName(AFontName: string): string;
var
  idx: Integer;
  fbi: Integer;
  originalName: string;
begin
  originalName := AFontName;
  Result := originalName;
  {$IFDEF WEBLIB}
  if Assigned(FInitializer) and FInitializer.IsFontAvailable(Result) then
    idx := 0
  else
    idx := -1;
  {$ELSE}
  idx := FOSFontList.IndexOf(Result);
  {$ENDIF}
  fbi := 0;
  while (idx = - 1) and (fbi >= 0) and (fbi <= FontFallBackList.Count - 1) do
  begin
    Result := FontFallBackList[fbi];
    {$IFDEF WEBLIB}
    if Assigned(FInitializer) and FInitializer.IsFontAvailable(Result) then
      idx := 0
    else
      idx := -1;
    {$ELSE}
    idx := FOSFontList.IndexOf(Result);
    {$ENDIF}
    if idx = -1 then
      Inc(fbi);
  end;

  if idx = -1 then
    Result := originalName;
end;

{ TTMSFNCGeneralPDFLibXRefObject }

constructor TTMSFNCGeneralPDFLibXRefObject.Create(const AValue: TTMSFNCGeneralPDFLibObject = nil);
begin
  if Assigned(AValue) then
  begin
    FXRefType := 'n';
    FXRefNumber := AValue.Number;
    FXRefObject := AValue;
  end
  else
  begin
    FXRefType := 'f';
    FXRefNumber := 0;
  end;
  FXRefOffset := -1;
  FInXRefList := True;
end;

destructor TTMSFNCGeneralPDFLibXRefObject.Destroy;
begin
  if Assigned(FXRefObject) then
  begin
    FXRefObject.Free;
    FXRefObject := nil;
  end;

  inherited;
end;

class function TTMSFNCGeneralPDFLibXRefObject.FormatValue(AValue,
  ALength: Integer): string;
var
  i, K: integer;
  S: string;
begin
  Result := '';
  if AValue > 0 then
    S := IntToStr(AValue)
  else
    S := '0';

  i := ALength - Length(S);

  for K := 0 to i - 1 do
    Result := Result + '0';

  Result := Result + S;
end;

function TTMSFNCGeneralPDFLibXRefObject.GenerateXRefValue: string;
begin
  Result := FormatValue(FXRefOffset, 10) + ' ' + FormatValue(FXRefNumber, 5) + ' ' + FXRefType;
end;

{ TTMSFNCGeneralPDFLibObject }

constructor TTMSFNCGeneralPDFLibObject.Create(const APDFLib: TTMSFNCGeneralPDFLib; const ANumber: Integer = -1; const AXRefNumber: Integer = 0);
begin
  FPDFLib := APDFLib;
  FXRefNumber := AXRefNumber;
  FNumber := ANumber;
  FXRefObject := nil;
end;

destructor TTMSFNCGeneralPDFLibObject.Destroy;
begin
  FXRefObject := nil;
  inherited;
end;

function TTMSFNCGeneralPDFLibObject.GetRefNameBase: String;
begin
  Result := '';
end;

function TTMSFNCGeneralPDFLibObject.GetRef: string;
var
  r: String;
begin
  r := RefName;
  if r <> '' then
    Result := r + ' ' + IntToStr(GetRefIndex(False)) + ' 0 R'
  else
    Result := IntToStr(GetRefIndex(False)) + ' 0 R';
end;

function TTMSFNCGeneralPDFLibObject.GetRefIndex(ACheckClassType: Boolean): Integer;
begin
  Result := -1;
  if Assigned(PDFLib) and Assigned(PDFLib.FXRefObjects) then
    Result := PDFLib.FXRefObjects.IndexOfObject(Self, ACheckClassType);
end;

function TTMSFNCGeneralPDFLibObject.GetRefName: string;
var
  r: String;
begin
  Result := '';
  r := RefNameNotEscaped;
  if r <> '' then
    Result := '/' + r;
end;

function TTMSFNCGeneralPDFLibObject.GetRefNameNotEscaped: string;
var
  r: String;
begin
  Result := '';
  r := RefNameBase;
  if r <> '' then
    Result := r + IntToStr(GetRefIndex(True));
end;

procedure TTMSFNCGeneralPDFLibObject.SetNumber(const Value: integer);
begin
  FNumber := Value;
  if Value < 0 then
    FType := lotIndirect
  else
    FType := lotDirect;
end;

{ TTMSFNCGeneralPDFLibXRefObjects }

function TTMSFNCGeneralPDFLibXRefObjects.AddObject(const AObject: TTMSFNCGeneralPDFLibObject = nil): TTMSFNCGeneralPDFLibXRefObject;
var
  i: Integer;
begin
  Result := TTMSFNCGeneralPDFLibXRefObject.Create(AObject);
  i := Add(Result);
  if Assigned(AObject) then
  begin
    AObject.Number := i;
    AObject.XRefObject := Result;
  end;
end;

function TTMSFNCGeneralPDFLibXRefObjects.AddObjectClass(
  const AObjectClass: TTMSFNCGeneralPDFLibObjectClass): TTMSFNCGeneralPDFLibXRefObject;
var
  i: Integer;
  AObject: TTMSFNCGeneralPDFLibObject;
begin
  AObject := AObjectClass.Create(nil);
  Result := TTMSFNCGeneralPDFLibXRefObject.Create(AObject);
  i := Add(Result);
  if Assigned(AObject) then
  begin
    AObject.Number := i;
    AObject.XRefObject := Result;
  end;
end;

function TTMSFNCGeneralPDFLibXRefObjects.IndexOfObject(
  const AObject: TTMSFNCGeneralPDFLibObject; const ACheckClassType: Boolean = False): Integer;
var
  I, K: Integer;
  x: TTMSFNCGeneralPDFLibObject;
begin
  Result := -1;
  K := -1;
  if Assigned(AObject) then
  begin
    for I := 0 to Count - 1 do
    begin
      x := Items[I].XRefObject;
      if Assigned(x) then
      begin
        if (not ACheckClassType) or (ACheckClassType and (x.ClassType = AObject.ClassType)) then
          Inc(K);

        if Items[I].XRefObject = AObject then
        begin
          Result := K;
          Break;
        end;
      end
      else if not ACheckClassType then
        Inc(K);
    end;
  end;
end;

{ TTMSFNCGeneralPDFLibPage }

constructor TTMSFNCGeneralPDFLibPage.Create(const APDFLib: TTMSFNCGeneralPDFLib; const APageNumber: Integer);
begin
  inherited Create(APDFLib);
  FPageNumber := APageNumber;
  FInsertPageNumber := APageNumber;
  FFontList := TTMSFNCGeneralPDFLibFonts.Create;
  FXObjectList := TTMSFNCGeneralPDFLibXObjects.Create;
  FShadings := TTMSFNCGeneralPDFLibShadings.Create;
  FBitmaps := TTMSFNCGeneralPDFLibBitmaps.Create;
  FAnnotations := TTMSFNCGeneralPDFLibAnnotations.Create;
  FPatterns := TTMSFNCGeneralPDFLibPatterns.Create;
end;

destructor TTMSFNCGeneralPDFLibPage.Destroy;
begin
  FContent := nil;

  if Assigned(FAnnotations) then
  begin
    FAnnotations.Free;
    FAnnotations := nil;
  end;

  if Assigned(FBitmaps) then
  begin
    FBitmaps.Free;
    FBitmaps := nil;
  end;

  if Assigned(FShadings) then
  begin
    FShadings.Free;
    FShadings := nil;
  end;

  if Assigned(FPatterns) then
  begin
    FPatterns.Free;
    FPatterns := nil;
  end;

  if Assigned(FXObjectList) then
  begin
    FXObjectList.Free;
    FXObjectList := nil;
  end;

  if Assigned(FFontList) then
  begin
    FFontList.Free;
    FFontList := nil;
  end;

  inherited;
end;

{ TTMSFNCGeneralPDFLibFont }

constructor TTMSFNCGeneralPDFLibFont.Create(const APDFLib: TTMSFNCGeneralPDFLib; const AMainInitializer: TTMSFNCGeneralPDFLibInitializer; const ABase: String; const AName: String; const ASize: Single; const AStyle: TFontStyles);
begin
  inherited Create(APDFLib);
  FInitializer := TTMSFNCGeneralPDFLibFontInitializer.Create(AMainInitializer, ABase, AStyle, ASize);
  FFontFile := nil;
  FFontDescriptor := nil;
  FFontDescendant := nil;
  FFontUnicode := nil;
  FTrueType := False;
  FFontProgramType := fptUnknown;
  FBase := ABase;
  FSize := ASize;
  FName := AName;
  FStyle := AStyle;
end;

destructor TTMSFNCGeneralPDFLibFont.Destroy;
begin
  if Assigned(FInitializer) then
  begin
    FInitializer.Free;
    FInitializer := nil;
  end;

  FFontFile := nil;
  FFontDescriptor := nil;
  FFontDescendant := nil;
  FFontUnicode := nil;
  inherited;
end;

function TTMSFNCGeneralPDFLibFont.BoxAsString: string;
begin
  Result := IntToStr(Box.Left) + ' ' + IntToStr(Box.Bottom) + ' ' + IntToStr(Box.Right) + ' ' + IntToStr(Box.Top);
end;

function TTMSFNCGeneralPDFLibFont.BuildGlyphMapEntries: TTMSFNCGeneralPDFLibGlyphMapEntries;
var
  I, Idx, OrigIdx, OutCount, J: Integer;
  Entry: TTMSFNCGeneralPDFLibGlyphMapEntry;
begin
  SetLength(Result, 0);
  if UsedCharArray.Count = 0 then
    Exit;

  SetLength(Result, UsedCharArray.Count);
  OutCount := 0;
  for I := 0 to UsedCharArray.Count - 1 do
  begin
    OrigIdx := CharArray.IndexOf(UsedCharArray[I]);
    Idx := OrigIdx;
    if Idx = -1 then
      Idx := CharArray.IndexOf(Ord('?'));

    if (Idx > -1) and (Idx < Length(CharWidths)) then
    begin
      Result[OutCount].GlyphId := CharWidths[Idx].g;
      if OrigIdx > -1 then
        Result[OutCount].UnicodeValue := CharArray.v[OrigIdx]
      else
        Result[OutCount].UnicodeValue := Ord('?');
      Result[OutCount].Width := CharWidths[Idx].w;
      Inc(OutCount);
    end;
  end;

  if OutCount = 0 then
  begin
    SetLength(Result, 0);
    Exit;
  end;
  SetLength(Result, OutCount);

  for I := 1 to Length(Result) - 1 do
  begin
    Entry := Result[I];
    J := I - 1;
    while (J >= 0) and
      ((Result[J].GlyphId > Entry.GlyphId) or
       ((Result[J].GlyphId = Entry.GlyphId) and
        (Result[J].UnicodeValue > Entry.UnicodeValue))) do
    begin
      Result[J + 1] := Result[J];
      Dec(J);
    end;
    Result[J + 1] := Entry;
  end;

  OutCount := 0;
  for I := 0 to Length(Result) - 1 do
  begin
    if (OutCount = 0) or (Result[OutCount - 1].GlyphId <> Result[I].GlyphId) then
    begin
      Result[OutCount] := Result[I];
      Inc(OutCount);
    end;
  end;

  SetLength(Result, OutCount);
end;

function TTMSFNCGeneralPDFLibFont.FirstGlyph: Integer;
begin
  Result := 0;
  if (UsedCharArray.Count > 0) then
    Result := UsedCharArray[0];
end;

function TTMSFNCGeneralPDFLibFont.FirstGlyphAsString: string;
begin
  Result := IntToStr(FirstGlyph);
end;

function TTMSFNCGeneralPDFLibFont.GlyphsAndWidthsAsString: string;
var
  GlyphMap: TTMSFNCGeneralPDFLibGlyphMapEntries;
  I: Integer;
  sb: TStringStream;
begin
  Result := '';
  GlyphMap := BuildGlyphMapEntries;
  sb := CreateStringStream;
  try
    for I := 0 to Length(GlyphMap) - 1 do
    begin
      sb.WriteString(IntToStr(GlyphMap[I].GlyphId));
      sb.WriteString('[');
      sb.WriteString(IntToStr(GlyphMap[I].Width));
      sb.WriteString('] ');
    end;
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLibFont.LastGlyph: Integer;
begin
  Result := 0;
  if (UsedCharArray.Count > 0) then
    Result := UsedCharArray[UsedCharArray.Count - 1];
end;

function TTMSFNCGeneralPDFLibFont.LastGlyphAsString: string;
begin
  Result := IntToStr(LastGlyph);
end;

function TTMSFNCGeneralPDFLibFont.WidthsAsString: string;
var
  I: Integer;
  idx, idxc: Integer;
  sb: TStringStream;
begin
  Result := '';
  sb := CreateStringStream;
  try
    for I := FirstGlyph to LastGlyph do
    begin
      idx := UsedCharArray.IndexOf(I);
      idxc := CharArray.IndexOf(I);
      if (idx > -1) and (idxc > -1) then
        sb.WriteString(IntToStr(CharWidths[idxc].w))
      else
        sb.WriteString('0');
      sb.WriteString(' ');
    end;
    Result := Trim(sb.DataString);
  finally
    sb.Free;
  end;
end;

function TTMSFNCGeneralPDFLibFont.GetCharArray: TTMSFNCPDFGraphicsLibFontCharArray;
begin
  Result := Initializer.GetCharArray;
end;

function TTMSFNCGeneralPDFLibFont.GetGlyphIDs: TTMSFNCPDFGraphicsLibUsedFontCharArray;
begin
  Result := Initializer.GetGlyphIDs;
end;

function TTMSFNCGeneralPDFLibFont.GetCharWidths: TTMSFNCPDFGraphicsLibFontCharWidths;
begin
  Result := Initializer.GetCharWidths;
end;

function TTMSFNCGeneralPDFLibFont.GetRefNameBase: string;
begin
  Result := 'FT';
end;

function TTMSFNCGeneralPDFLibFont.GetUsedCharArray: TTMSFNCPDFGraphicsLibUsedFontCharArray;
begin
  Result := Initializer.GetUsedCharArray;
end;

{ TTMSFNCGeneralPDFLibFontDescriptor }

constructor TTMSFNCGeneralPDFLibFontDescriptor.Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont);
begin
  inherited Create(APDFLib);
  FFont := AFont;
end;

destructor TTMSFNCGeneralPDFLibFontDescriptor.Destroy;
begin
  FFont := nil;
  inherited;
end;

{ TTMSFNCGeneralPDFLibFontDescendant }

constructor TTMSFNCGeneralPDFLibFontDescendant.Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont);
begin
  inherited Create(APDFLib);
  FFont := AFont;
end;

destructor TTMSFNCGeneralPDFLibFontDescendant.Destroy;
begin
  FFont := nil;
  inherited;
end;

{ TTMSFNCGeneralPDFLibFontFile }

constructor TTMSFNCGeneralPDFLibFontFile.Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont);
begin
  inherited Create(APDFLib);
  FFont := AFont;
end;

procedure TTMSFNCGeneralPDFLibFontFile.InitializeFontFile;
begin
  if Assigned(FFont) then
  begin
    FFont.Initializer.InitializeFontFile;
  end;
end;

destructor TTMSFNCGeneralPDFLibFontFile.Destroy;
begin
  FFont := nil;
  inherited;
end;

{ TTMSFNCGeneralPDFLibFontUnicode }

constructor TTMSFNCGeneralPDFLibFontUnicode.Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFont: TTMSFNCGeneralPDFLibFont);
begin
  inherited Create(APDFLib);
  FFont := AFont;
end;

destructor TTMSFNCGeneralPDFLibFontUnicode.Destroy;
begin
  FFont := nil;
  inherited;
end;

{ TTMSFNCGeneralPDFLibShading }

function TTMSFNCGeneralPDFLibShading.RectAsString: string;
begin
  Result := '0 0 0 0';
  if Self is TTMSFNCGeneralPDFLibLinearGradient then
  begin
    case (Self as TTMSFNCGeneralPDFLibLinearGradient).FillOrientation of
      gfoHorizontal: Result := IntToStr(Round(Rect.Left)) + ' ' + IntToStr(Round(Rect.Top)) + ' ' + IntToStr(Round(Rect.Right)) + ' ' + IntToStr(Round(Rect.Bottom - (Rect.Bottom - Rect.Top)));
      gfoVertical: Result := IntToStr(Round(Rect.Left)) + ' ' + IntToStr(Round(Rect.Bottom)) + ' ' + IntToStr(Round(Rect.Left)) + ' ' + IntToStr(Round(Rect.Bottom - (Rect.Bottom - Rect.Top)));
    end;
  end;
end;

constructor TTMSFNCGeneralPDFLibShading.Create(const APDFLib: TTMSFNCGeneralPDFLib);
begin
  inherited Create(APDFLib);
end;

destructor TTMSFNCGeneralPDFLibShading.Destroy;
begin
  FFunction := nil;
  inherited;
end;

{ TTMSFNCGeneralPDFLibShadingFunction }

constructor TTMSFNCGeneralPDFLibShadingFunction.Create(const APDFLib: TTMSFNCGeneralPDFLib);
begin
  inherited Create(APDFLib);
  FSubFunctions := TTMSFNCGeneralPDFLibShadingSubFunctions.Create;
end;

destructor TTMSFNCGeneralPDFLibShadingFunction.Destroy;
begin
  if Assigned(FSubFunctions) then
  begin
    FSubFunctions.Free;
    FSubFunctions := nil;
  end;
  inherited;
end;

function TTMSFNCGeneralPDFLibShadingFunction.SubFunctionsRef: String;
var
  x: TTMSFNCGeneralPDFLibShadingSubFunction;
  {$IFDEF WEBLIB}
  v: JSValue;
  {$ENDIF}
begin
  Result := '';
  if Assigned(FSubFunctions) then
  begin
    {$IFDEF WEBLIB}
    for v in FSubFunctions do
    begin
      x := TTMSFNCGeneralPDFLibShadingSubFunction(v);
    {$ELSE}
    for x in FSubFunctions do
    begin
    {$ENDIF}
      Result := Result + IntToStr(PDFLib.FXRefObjects.IndexOf(x.XRefObject)) + ' 0 R ';
    end;

    Result := Trim(Result);
  end;
end;

{ TTMSFNCGeneralPDFLibShadingSubFunction }

constructor TTMSFNCGeneralPDFLibShadingSubFunction.Create(const APDFLib: TTMSFNCGeneralPDFLib; const AFillColor: TTMSFNCGraphicsColor; const AFillColorTo: TTMSFNCGraphicsColor);
begin
  inherited Create(APDFLib);
  FFillColor := AFillColor;
  FFillColorTo := AFillColorTo;
end;

{ TTMSFNCGeneralPDFLibPattern }

destructor TTMSFNCGeneralPDFLibPattern.Destroy;
begin
  FShading := nil;
  inherited;
end;

function TTMSFNCGeneralPDFLibPattern.GetRefNameBase: string;
begin
  Result := 'PT';
end;

{ TTMSFNCGeneralPDFLibBitmap }

constructor TTMSFNCGeneralPDFLibBitmap.Create(const APDFLib: TTMSFNCGeneralPDFLib; const ABitmap: TTMSFNCBitmapHelperClass; const AStream: TMemoryStream; const AImageType: TTMSFNCPDFGraphicsLibImageType; const AQuality: Single; const ABackgroundColor: TTMSFNCGraphicsColor);
begin
  inherited Create(APDFLib);
  FBitmap := TTMSFNCBitmap.Create;
  FBitmap.Assign(ABitmap);
  FImageType := AImageType;
  FQuality := AQuality;
  FBackgroundColor := ABackgroundColor;
  FStream := TMemoryStream.Create;
  FStream.LoadFromStream(AStream);
end;

destructor TTMSFNCGeneralPDFLibBitmap.Destroy;
begin
  if Assigned(FStream) then
  begin
    FStream.Free;
    FStream := nil;
  end;

  if Assigned(FBitmap) then
  begin
    FBitmap.Free;
    FBitmap := nil;
  end;
  inherited;
end;

function TTMSFNCGeneralPDFLibBitmap.GetRefNameBase: String;
begin
  Result := 'IM';
end;

procedure TTMSFNCGeneralPDFLibBitmap.SetBitmap(const Value: TTMSFNCBitmap);
begin
  FBitmap.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLibBitmap.SetStream(const Value: TMemoryStream);
begin
  FStream.LoadFromStream(Value);
end;

{ TTMSFNCGeneralPDFLibContent }

destructor TTMSFNCGeneralPDFLibContent.Destroy;
begin
  FPage := nil;
  inherited;
end;

{ TTMSFNCGeneralPDFLibAnnotation }

function TTMSFNCGeneralPDFLibAnnotation.RectAsString: String;
begin
  Result := IntToStr(Round(Rect.Left)) + ' ' + IntToStr(Round(Rect.Top)) + ' ' + IntToStr(Round(Rect.Right)) + ' ' + IntToStr(Round(Rect.Bottom))
end;

constructor TTMSFNCGeneralPDFLibAnnotation.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const ARect: TRectF);
begin
  inherited Create(APDFLib);
  FRect := ARect;
end;

destructor TTMSFNCGeneralPDFLibAnnotation.Destroy;
begin
  inherited;
end;

{ TTMSFNCGeneralPDFLibURL }

constructor TTMSFNCGeneralPDFLibURL.Create(const APDFLib: TTMSFNCGeneralPDFLib;
  const ARect: TRectF; const AURL: UnicodeString);
begin
  inherited Create(APDFLib, ARect);
  FURL := AURL;
end;

{ TTMSFNCGeneralPDFLibGoTo }

constructor TTMSFNCGeneralPDFLibGoTo.Create(const APDFLib: TTMSFNCGeneralPDFLib;
  const ARect: TRectF; const ADestination: UnicodeString);
begin
  inherited Create(APDFLib, ARect);
  FDestination := ADestination;
end;

{ TTMSFNCGeneralPDFLibGoTo2 }

constructor TTMSFNCGeneralPDFLibGoTo2.Create(const APDFLib: TTMSFNCGeneralPDFLib;
  const ARect: TRectF; const APageIndex: Integer; const AOptions: UnicodeString);
begin
  inherited Create(APDFLib, ARect);
  FOptions := AOptions;
  FPageIndex := APageIndex;
end;

{ TTMSFNCGeneralPDFLibLinearGradient }

constructor TTMSFNCGeneralPDFLibLinearGradient.Create(
  const APDFLib: TTMSFNCGeneralPDFLib;
  const AFillOrientation: TTMSFNCGraphicsFillOrientation);
begin
  inherited Create(APDFLib);
  FFillOrientation := AFillOrientation;
end;

{$IFDEF WEBLIB}
function TTMSFNCGeneralPDFLibPageList.GetItem(Index: Integer): TTMSFNCGeneralPDFLibPage;
begin
  Result := TTMSFNCGeneralPDFLibPage(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibPageList.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibPage);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibFonts.GetItem(Index: Integer): TTMSFNCGeneralPDFLibFont;
begin
  Result := TTMSFNCGeneralPDFLibFont(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibFonts.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibFont);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibShadings.GetItem(Index: Integer): TTMSFNCGeneralPDFLibShading;
begin
  Result := TTMSFNCGeneralPDFLibShading(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibShadings.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibShading);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibXObjects.GetItem(Index: Integer): TTMSFNCGeneralPDFLibXObject;
begin
  Result := TTMSFNCGeneralPDFLibXObject(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibXObjects.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibXObject);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibPatterns.GetItem(Index: Integer): TTMSFNCGeneralPDFLibPattern;
begin
  Result := TTMSFNCGeneralPDFLibPattern(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibPatterns.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibPattern);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibAnnotations.GetItem(Index: Integer): TTMSFNCGeneralPDFLibAnnotation;
begin
  Result := TTMSFNCGeneralPDFLibAnnotation(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibAnnotations.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibAnnotation);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibBitmaps.GetItem(Index: Integer): TTMSFNCGeneralPDFLibBitmap;
begin
  Result := TTMSFNCGeneralPDFLibBitmap(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibBitmaps.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibBitmap);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibShadingSubFunctions.GetItem(Index: Integer): TTMSFNCGeneralPDFLibShadingSubFunction;
begin
  Result := TTMSFNCGeneralPDFLibShadingSubFunction(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibShadingSubFunctions.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibShadingSubFunction);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCGeneralPDFLibXRefObjects.GetItem(Index: Integer): TTMSFNCGeneralPDFLibXRefObject;
begin
  Result := TTMSFNCGeneralPDFLibXRefObject(inherited Items[Index]);
end;

procedure TTMSFNCGeneralPDFLibXRefObjects.SetItem(Index: Integer; const Value: TTMSFNCGeneralPDFLibXRefObject);
begin
  inherited Items[Index] := Value;
end;
{$ENDIF}

{ TTMSFNCGeneralPDFLibFormField }

constructor TTMSFNCGeneralPDFLibFormField.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string;
  const ARect: TRectF; const AReadOnly, AHidden: Boolean);
begin
  inherited Create(APDFLib, ARect);
  FPartialName := AFieldName;
  FHidden := AHidden;
  FReadOnly := AReadOnly;
end;

function TTMSFNCGeneralPDFLibFormField.GetFieldName: string;
begin
  Result := FPartialName;
end;

function TTMSFNCGeneralPDFLibFormField.GetHidden: Boolean;
begin
  Result := FHidden;
end;

function TTMSFNCGeneralPDFLibFormField.GetReadOnly: Boolean;
begin
  Result := FReadOnly;
end;

function TTMSFNCGeneralPDFLibFormField.GetRect: TRectF;
begin
  Result := FRect;
end;

{$IFDEF LCLLIB}
function TTMSFNCGeneralPDFLibFormField.QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCGeneralPDFLibFormField.QueryInterface(const IID: TGUID; out Obj): HResult;
{$ENDIF}
const
  E_NOINTERFACE = HResult($80004002);
begin
  if GetInterface(IID, Obj) then Result := 0 else Result := E_NOINTERFACE;
end;

procedure TTMSFNCGeneralPDFLibFormField.SetFieldName(const Value: string);
begin
  FPartialName := Value;
end;

procedure TTMSFNCGeneralPDFLibFormField.SetHidden(const Value: Boolean);
begin
  FHidden := Value;
end;

procedure TTMSFNCGeneralPDFLibFormField.SetReadOnly(const Value: Boolean);
begin
  FReadOnly := Value;
end;

procedure TTMSFNCGeneralPDFLibFormField.SetRect(const Value: TRectF);
begin
  FRect := Value;
end;

{$IFDEF LCLLIB}
function TTMSFNCGeneralPDFLibFormField._AddRef: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCGeneralPDFLibFormField._AddRef: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._AddRef
  else
    Result := -1;
end;

{$IFDEF LCLLIB}
function TTMSFNCGeneralPDFLibFormField._Release: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCGeneralPDFLibFormField._Release: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._Release
  else
    Result := -1;
end;

{ TTMSFNCGeneralPDFLibFormFieldText }

constructor TTMSFNCGeneralPDFLibFormFieldText.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string;
  const ARect: TRectF; const AText: UnicodeString; const ATextAlign: TTMSFNCGraphicsTextAlign;
  const AReadOnly: Boolean; const AHidden: Boolean);
begin
  inherited Create(APDFLib, AFieldName, ARect, AReadOnly, AHidden);
  FAutoSize := APDFLib.FFormFieldGlobalAutoSize;
  FText := AText;
  FHorizontalAlign := ATextAlign;
  FFont := TTMSFNCPDFGraphicsLibFont.Create;
  FFont.Assign(APDFLib.FFormFieldGlobalFont);
  FFont.OnChanged := @DoFontChanged;
end;

destructor TTMSFNCGeneralPDFLibFormFieldText.Destroy;
begin
  if Assigned(FFont) then
  begin
    FFont.Free;
    FFont := nil;
  end;

  inherited;
end;

procedure TTMSFNCGeneralPDFLibFormFieldText.DoChanged;
begin
  if Assigned(OnChanged) then
    OnChanged(Self);
end;

procedure TTMSFNCGeneralPDFLibFormFieldText.DoFontChanged(Sender: TObject);
begin
  DoChanged;
end;

function TTMSFNCGeneralPDFLibFormFieldText.GetFont: TTMSFNCPDFGraphicsLibFont;
begin
  Result := FFont;
end;

function TTMSFNCGeneralPDFLibFormFieldText.GetFontAutoSize: Boolean;
begin
  Result := FAutoSize;
end;

function TTMSFNCGeneralPDFLibFormFieldText.GetHorizontalAlign: TTMSFNCGraphicsTextAlign;
begin
  Result := FHorizontalAlign;
end;

function TTMSFNCGeneralPDFLibFormFieldText.GetText: UnicodeString;
begin
  Result := FText;
end;

procedure TTMSFNCGeneralPDFLibFormFieldText.SetFont(
  const Value: TTMSFNCPDFGraphicsLibFont);
begin
  FFont.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLibFormFieldText.SetFontAutoSize(
  const Value: Boolean);
begin
  FAutoSize := Value;
end;

procedure TTMSFNCGeneralPDFLibFormFieldText.SetHorizontalAlign(
  const Value: TTMSFNCGraphicsTextAlign);
begin
  FHorizontalAlign := Value;
end;

procedure TTMSFNCGeneralPDFLibFormFieldText.SetText(const Value: UnicodeString);
begin
  if FText <> Value then
  begin
    FText := Value;
    DoChanged;
  end;
end;

{ TTMSFNCGeneralPDFLibFormFieldCheckBox }

constructor TTMSFNCGeneralPDFLibFormFieldCheckBox.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string;
  const ARect: TRectF; const AIsChecked, AReadOnly,
  AHidden: Boolean);
begin
  inherited Create(APDFLib, AFieldName, ARect, AReadOnly, AHidden);
  FIsChecked := AIsChecked;
end;

{ TTMSFNCGeneralPDFLibFormFieldChoice }

constructor TTMSFNCGeneralPDFLibFormFieldChoice.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string;
  const ARect: TRectF; const AItems: TTMSFNCPDFLibStringArray;
  const AItemIndex: Integer; const AReadOnly, AHidden: Boolean);
var
  I: Integer;
begin
  inherited Create(APDFLib, AFieldName, ARect, AReadOnly, AHidden);
  FItemIndex := AItemIndex;
  FFont := TTMSFNCPDFGraphicsLibFont.Create;
  FFont.Assign(APDFLib.FFormFieldGlobalFont);
  FFont.OnChanged := @DoFontChanged;
  FItems := TStringList.Create;
  for I := 0 to Length(AItems) - 1 do
    FItems.Add(AItems[I]);

  TStringList(FItems).OnChange := @DoItemsChange;
end;

destructor TTMSFNCGeneralPDFLibFormFieldChoice.Destroy;
begin
  FItems.Free;
  if Assigned(FFont) then
  begin
    FFont.Free;
    FFont := nil;
  end;

  inherited;
end;

procedure TTMSFNCGeneralPDFLibFormFieldChoice.DoChanged;
begin
  if Assigned(OnChanged) then
    OnChanged(Self);
end;

procedure TTMSFNCGeneralPDFLibFormFieldChoice.DoFontChanged(Sender: TObject);
begin
  DoChanged;
end;

procedure TTMSFNCGeneralPDFLibFormFieldChoice.DoItemsChange(Sender: TObject);
begin
  DoChanged;
end;

{ TTMSFNCGeneralPDFLibFormFieldComboBox }

constructor TTMSFNCGeneralPDFLibFormFieldComboBox.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string;
  const ARect: TRectF; const AItems: TTMSFNCPDFLibStringArray;
  const AItemIndex: Integer; const AEditable: Boolean;
  const AReadOnly, AHidden: Boolean);
begin
  inherited Create(APDFLib, AFieldName, ARect, AItems, AItemIndex, AReadOnly, AHidden);
  FAutoSize := APDFLib.FFormFieldGlobalAutoSize;
  FEditable := AEditable;
end;

function TTMSFNCGeneralPDFLibFormFieldComboBox.GetFontAutoSize: Boolean;
begin
  Result := FAutoSize;
end;

function TTMSFNCGeneralPDFLibFormFieldComboBox.GetEditable: Boolean;
begin
  Result := FEditable;
end;

function TTMSFNCGeneralPDFLibFormFieldComboBox.GetFont: TTMSFNCPDFGraphicsLibFont;
begin
  Result := FFont;
end;

function TTMSFNCGeneralPDFLibFormFieldComboBox.GetItemIndex: Integer;
begin
  Result := FItemIndex;
end;

function TTMSFNCGeneralPDFLibFormFieldComboBox.GetItems: TStrings;
begin
  Result := FItems;
end;

procedure TTMSFNCGeneralPDFLibFormFieldComboBox.SetFontAutoSize(
  const Value: Boolean);
begin
  FAutoSize := Value;
end;

procedure TTMSFNCGeneralPDFLibFormFieldComboBox.SetEditable(
  const Value: Boolean);
begin
  FEditable := Value;
end;

procedure TTMSFNCGeneralPDFLibFormFieldComboBox.SetFont(
  const Value: TTMSFNCPDFGraphicsLibFont);
begin
  FFont.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLibFormFieldComboBox.SetItemIndex(
  const Value: Integer);
begin
  FItemIndex := Value;
end;

procedure TTMSFNCGeneralPDFLibFormFieldComboBox.SetItems(const Value: TStrings);
begin
  FItems.Assign(Value);
end;

{ TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup }

constructor TTMSFNCGeneralPDFLibFormFieldRadioButtonGroup.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string;
  const AGroupID: string);
begin
  inherited Create(APDFLib, AFieldName, RectF(0, 0, 0, 0), False, False);
  FGroupID := AGroupID;
end;

{ TTMSFNCGeneralPDFLibFormFieldRadioButton }

constructor TTMSFNCGeneralPDFLibFormFieldRadioButton.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFieldName: string;
  const ARect: TRectF; const AGroupID: string; const AIsChecked, AReadOnly,
  AHidden: Boolean);
begin
  inherited Create(APDFLib, AFieldName, ARect, AReadOnly, AHidden);
  FGroupID := AGroupID;
  FIsChecked := AIsChecked;
end;

{ TTMSFNCGeneralPDFLibFormFieldTextContent }

constructor TTMSFNCGeneralPDFLibFormFieldTextContent.Create(
  const APDFLib: TTMSFNCGeneralPDFLib;
  AFormField: TTMSFNCGeneralPDFLibFormFieldText);
begin
  inherited Create(APDFLib);
  FFormField := AFormField;
  FFormField.Content := Self;
end;

{ TTMSFNCGeneralPDFLibFormFieldCheckBoxContent }

constructor TTMSFNCGeneralPDFLibFormFieldCheckBoxContent.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFormField:
  TTMSFNCGeneralPDFLibFormFieldCheckBox; const AIsOnState: Boolean);
begin
  inherited Create(APDFLib);
  FFormField := AFormField;
  FIsOnState := AIsOnState;
  if FIsOnState then
    FFormField.OnContent := Self
  else
    FFormField.OffContent := Self;
end;

{ TTMSFNCGeneralPDFLibFormFieldRadioButtonContent }

constructor TTMSFNCGeneralPDFLibFormFieldRadioButtonContent.Create(
  const APDFLib: TTMSFNCGeneralPDFLib; const AFormField:
  TTMSFNCGeneralPDFLibFormFieldRadioButton; const AIsOnState: Boolean);
begin
  inherited Create(APDFLib);
  FFormField := AFormField;
  FIsOnState := AIsOnState;
  if FIsOnState then
    FFormField.OnContent := Self
  else
    FFormField.OffContent := Self;
end;

{ TTMSFNCGeneralPDFLibFormFieldListBoxContent }

constructor TTMSFNCGeneralPDFLibFormFieldListBoxContent.Create(
  const APDFLib: TTMSFNCGeneralPDFLib;
  AFormField: TTMSFNCGeneralPDFLibFormFieldListBox);
begin
  inherited Create(APDFLib);
  FFormField := AFormField;
  FFormField.Content := Self;
end;

{ TTMSFNCGeneralPDFLibFormFieldListBox }

function TTMSFNCGeneralPDFLibFormFieldListBox.GetFont: TTMSFNCPDFGraphicsLibFont;
begin
  Result := FFont;
end;

function TTMSFNCGeneralPDFLibFormFieldListBox.GetItemIndex: Integer;
begin
  Result := FItemIndex;
end;

function TTMSFNCGeneralPDFLibFormFieldListBox.GetItems: TStrings;
begin
  Result := FItems;
end;

procedure TTMSFNCGeneralPDFLibFormFieldListBox.SetFont(
  const Value: TTMSFNCPDFGraphicsLibFont);
begin
  FFont.Assign(Value);
end;

procedure TTMSFNCGeneralPDFLibFormFieldListBox.SetItemIndex(
  const Value: Integer);
begin
  FItemIndex := Value;
end;

procedure TTMSFNCGeneralPDFLibFormFieldListBox.SetItems(const Value: TStrings);
begin
  FItems.Assign(Value);
end;

{ TTMSFNCGeneralPDFLibFormFieldComboBoxContent }

constructor TTMSFNCGeneralPDFLibFormFieldComboBoxContent.Create(
  const APDFLib: TTMSFNCGeneralPDFLib;
  AFormField: TTMSFNCGeneralPDFLibFormFieldComboBox);
begin
  inherited Create(APDFLib);
  FFormField := AFormField;
  FFormField.Content := Self;
end;

end.

